// This file has been automatically generated based on the IANA Language Subtag
// Registry. Do therefore not modify it directly! If you wish to make changes,
// do so in `scripts/languages.js` and run `yarn generate` to rebuild this file.
/**
 * @internal
 */
export const Languages = {
    primary: {
        aa: { scope: null },
        ab: { scope: null },
        ae: { scope: null },
        af: { scope: null },
        ak: { scope: "macrolanguage" },
        am: { scope: null },
        an: { scope: null },
        ar: { scope: "macrolanguage" },
        as: { scope: null },
        av: { scope: null },
        ay: { scope: "macrolanguage" },
        az: { scope: "macrolanguage" },
        ba: { scope: null },
        be: { scope: null },
        bg: { scope: null },
        bh: { scope: "collection" },
        bi: { scope: null },
        bm: { scope: null },
        bn: { scope: null },
        bo: { scope: null },
        br: { scope: null },
        bs: { scope: null },
        ca: { scope: null },
        ce: { scope: null },
        ch: { scope: null },
        co: { scope: null },
        cr: { scope: "macrolanguage" },
        cs: { scope: null },
        cu: { scope: null },
        cv: { scope: null },
        cy: { scope: null },
        da: { scope: null },
        de: { scope: null },
        dv: { scope: null },
        dz: { scope: null },
        ee: { scope: null },
        el: { scope: null },
        en: { scope: null },
        eo: { scope: null },
        es: { scope: null },
        et: { scope: "macrolanguage" },
        eu: { scope: null },
        fa: { scope: "macrolanguage" },
        ff: { scope: "macrolanguage" },
        fi: { scope: null },
        fj: { scope: null },
        fo: { scope: null },
        fr: { scope: null },
        fy: { scope: null },
        ga: { scope: null },
        gd: { scope: null },
        gl: { scope: null },
        gn: { scope: "macrolanguage" },
        gu: { scope: null },
        gv: { scope: null },
        ha: { scope: null },
        he: { scope: null },
        hi: { scope: null },
        ho: { scope: null },
        hr: { scope: null },
        ht: { scope: null },
        hu: { scope: null },
        hy: { scope: null },
        hz: { scope: null },
        ia: { scope: null },
        id: { scope: null },
        ie: { scope: null },
        ig: { scope: null },
        ii: { scope: null },
        ik: { scope: "macrolanguage" },
        in: { scope: null },
        io: { scope: null },
        is: { scope: null },
        it: { scope: null },
        iu: { scope: "macrolanguage" },
        iw: { scope: null },
        ja: { scope: null },
        ji: { scope: null },
        jv: { scope: null },
        jw: { scope: null },
        ka: { scope: null },
        kg: { scope: "macrolanguage" },
        ki: { scope: null },
        kj: { scope: null },
        kk: { scope: null },
        kl: { scope: null },
        km: { scope: null },
        kn: { scope: null },
        ko: { scope: null },
        kr: { scope: "macrolanguage" },
        ks: { scope: null },
        ku: { scope: "macrolanguage" },
        kv: { scope: "macrolanguage" },
        kw: { scope: null },
        ky: { scope: null },
        la: { scope: null },
        lb: { scope: null },
        lg: { scope: null },
        li: { scope: null },
        ln: { scope: null },
        lo: { scope: null },
        lt: { scope: null },
        lu: { scope: null },
        lv: { scope: "macrolanguage" },
        mg: { scope: "macrolanguage" },
        mh: { scope: null },
        mi: { scope: null },
        mk: { scope: null },
        ml: { scope: null },
        mn: { scope: "macrolanguage" },
        mo: { scope: null },
        mr: { scope: null },
        ms: { scope: "macrolanguage" },
        mt: { scope: null },
        my: { scope: null },
        na: { scope: null },
        nb: { scope: null },
        nd: { scope: null },
        ne: { scope: "macrolanguage" },
        ng: { scope: null },
        nl: { scope: null },
        nn: { scope: null },
        no: { scope: "macrolanguage" },
        nr: { scope: null },
        nv: { scope: null },
        ny: { scope: null },
        oc: { scope: null },
        oj: { scope: "macrolanguage" },
        om: { scope: "macrolanguage" },
        or: { scope: "macrolanguage" },
        os: { scope: null },
        pa: { scope: null },
        pi: { scope: null },
        pl: { scope: null },
        ps: { scope: "macrolanguage" },
        pt: { scope: null },
        qu: { scope: "macrolanguage" },
        rm: { scope: null },
        rn: { scope: null },
        ro: { scope: null },
        ru: { scope: null },
        rw: { scope: null },
        sa: { scope: null },
        sc: { scope: "macrolanguage" },
        sd: { scope: null },
        se: { scope: null },
        sg: { scope: null },
        sh: { scope: "macrolanguage" },
        si: { scope: null },
        sk: { scope: null },
        sl: { scope: null },
        sm: { scope: null },
        sn: { scope: null },
        so: { scope: null },
        sq: { scope: "macrolanguage" },
        sr: { scope: null },
        ss: { scope: null },
        st: { scope: null },
        su: { scope: null },
        sv: { scope: null },
        sw: { scope: "macrolanguage" },
        ta: { scope: null },
        te: { scope: null },
        tg: { scope: null },
        th: { scope: null },
        ti: { scope: null },
        tk: { scope: null },
        tl: { scope: null },
        tn: { scope: null },
        to: { scope: null },
        tr: { scope: null },
        ts: { scope: null },
        tt: { scope: null },
        tw: { scope: null },
        ty: { scope: null },
        ug: { scope: null },
        uk: { scope: null },
        ur: { scope: null },
        uz: { scope: "macrolanguage" },
        ve: { scope: null },
        vi: { scope: null },
        vo: { scope: null },
        wa: { scope: null },
        wo: { scope: null },
        xh: { scope: null },
        yi: { scope: "macrolanguage" },
        yo: { scope: null },
        za: { scope: "macrolanguage" },
        zh: { scope: "macrolanguage" },
        zu: { scope: null },
        aaa: { scope: null },
        aab: { scope: null },
        aac: { scope: null },
        aad: { scope: null },
        aae: { scope: null },
        aaf: { scope: null },
        aag: { scope: null },
        aah: { scope: null },
        aai: { scope: null },
        aak: { scope: null },
        aal: { scope: null },
        aam: { scope: null },
        aan: { scope: null },
        aao: { scope: null },
        aap: { scope: null },
        aaq: { scope: null },
        aas: { scope: null },
        aat: { scope: null },
        aau: { scope: null },
        aav: { scope: "collection" },
        aaw: { scope: null },
        aax: { scope: null },
        aaz: { scope: null },
        aba: { scope: null },
        abb: { scope: null },
        abc: { scope: null },
        abd: { scope: null },
        abe: { scope: null },
        abf: { scope: null },
        abg: { scope: null },
        abh: { scope: null },
        abi: { scope: null },
        abj: { scope: null },
        abl: { scope: null },
        abm: { scope: null },
        abn: { scope: null },
        abo: { scope: null },
        abp: { scope: null },
        abq: { scope: null },
        abr: { scope: null },
        abs: { scope: null },
        abt: { scope: null },
        abu: { scope: null },
        abv: { scope: null },
        abw: { scope: null },
        abx: { scope: null },
        aby: { scope: null },
        abz: { scope: null },
        aca: { scope: null },
        acb: { scope: null },
        acd: { scope: null },
        ace: { scope: null },
        acf: { scope: null },
        ach: { scope: null },
        aci: { scope: null },
        ack: { scope: null },
        acl: { scope: null },
        acm: { scope: null },
        acn: { scope: null },
        acp: { scope: null },
        acq: { scope: null },
        acr: { scope: null },
        acs: { scope: null },
        act: { scope: null },
        acu: { scope: null },
        acv: { scope: null },
        acw: { scope: null },
        acx: { scope: null },
        acy: { scope: null },
        acz: { scope: null },
        ada: { scope: null },
        adb: { scope: null },
        add: { scope: null },
        ade: { scope: null },
        adf: { scope: null },
        adg: { scope: null },
        adh: { scope: null },
        adi: { scope: null },
        adj: { scope: null },
        adl: { scope: null },
        adn: { scope: null },
        ado: { scope: null },
        adp: { scope: null },
        adq: { scope: null },
        adr: { scope: null },
        ads: { scope: null },
        adt: { scope: null },
        adu: { scope: null },
        adw: { scope: null },
        adx: { scope: null },
        ady: { scope: null },
        adz: { scope: null },
        aea: { scope: null },
        aeb: { scope: null },
        aec: { scope: null },
        aed: { scope: null },
        aee: { scope: null },
        aek: { scope: null },
        ael: { scope: null },
        aem: { scope: null },
        aen: { scope: null },
        aeq: { scope: null },
        aer: { scope: null },
        aes: { scope: null },
        aeu: { scope: null },
        aew: { scope: null },
        aey: { scope: null },
        aez: { scope: null },
        afa: { scope: "collection" },
        afb: { scope: null },
        afd: { scope: null },
        afe: { scope: null },
        afg: { scope: null },
        afh: { scope: null },
        afi: { scope: null },
        afk: { scope: null },
        afn: { scope: null },
        afo: { scope: null },
        afp: { scope: null },
        afs: { scope: null },
        aft: { scope: null },
        afu: { scope: null },
        afz: { scope: null },
        aga: { scope: null },
        agb: { scope: null },
        agc: { scope: null },
        agd: { scope: null },
        age: { scope: null },
        agf: { scope: null },
        agg: { scope: null },
        agh: { scope: null },
        agi: { scope: null },
        agj: { scope: null },
        agk: { scope: null },
        agl: { scope: null },
        agm: { scope: null },
        agn: { scope: null },
        ago: { scope: null },
        agp: { scope: null },
        agq: { scope: null },
        agr: { scope: null },
        ags: { scope: null },
        agt: { scope: null },
        agu: { scope: null },
        agv: { scope: null },
        agw: { scope: null },
        agx: { scope: null },
        agy: { scope: null },
        agz: { scope: null },
        aha: { scope: null },
        ahb: { scope: null },
        ahg: { scope: null },
        ahh: { scope: null },
        ahi: { scope: null },
        ahk: { scope: null },
        ahl: { scope: null },
        ahm: { scope: null },
        ahn: { scope: null },
        aho: { scope: null },
        ahp: { scope: null },
        ahr: { scope: null },
        ahs: { scope: null },
        aht: { scope: null },
        aia: { scope: null },
        aib: { scope: null },
        aic: { scope: null },
        aid: { scope: null },
        aie: { scope: null },
        aif: { scope: null },
        aig: { scope: null },
        aih: { scope: null },
        aii: { scope: null },
        aij: { scope: null },
        aik: { scope: null },
        ail: { scope: null },
        aim: { scope: null },
        ain: { scope: null },
        aio: { scope: null },
        aip: { scope: null },
        aiq: { scope: null },
        air: { scope: null },
        ais: { scope: null },
        ait: { scope: null },
        aiw: { scope: null },
        aix: { scope: null },
        aiy: { scope: null },
        aja: { scope: null },
        ajg: { scope: null },
        aji: { scope: null },
        ajn: { scope: null },
        ajp: { scope: null },
        ajt: { scope: null },
        aju: { scope: null },
        ajw: { scope: null },
        ajz: { scope: null },
        akb: { scope: null },
        akc: { scope: null },
        akd: { scope: null },
        ake: { scope: null },
        akf: { scope: null },
        akg: { scope: null },
        akh: { scope: null },
        aki: { scope: null },
        akj: { scope: null },
        akk: { scope: null },
        akl: { scope: null },
        akm: { scope: null },
        ako: { scope: null },
        akp: { scope: null },
        akq: { scope: null },
        akr: { scope: null },
        aks: { scope: null },
        akt: { scope: null },
        aku: { scope: null },
        akv: { scope: null },
        akw: { scope: null },
        akx: { scope: null },
        aky: { scope: null },
        akz: { scope: null },
        ala: { scope: null },
        alc: { scope: null },
        ald: { scope: null },
        ale: { scope: null },
        alf: { scope: null },
        alg: { scope: "collection" },
        alh: { scope: null },
        ali: { scope: null },
        alj: { scope: null },
        alk: { scope: null },
        all: { scope: null },
        alm: { scope: null },
        aln: { scope: null },
        alo: { scope: null },
        alp: { scope: null },
        alq: { scope: null },
        alr: { scope: null },
        als: { scope: null },
        alt: { scope: null },
        alu: { scope: null },
        alv: { scope: "collection" },
        alw: { scope: null },
        alx: { scope: null },
        aly: { scope: null },
        alz: { scope: null },
        ama: { scope: null },
        amb: { scope: null },
        amc: { scope: null },
        ame: { scope: null },
        amf: { scope: null },
        amg: { scope: null },
        ami: { scope: null },
        amj: { scope: null },
        amk: { scope: null },
        aml: { scope: null },
        amm: { scope: null },
        amn: { scope: null },
        amo: { scope: null },
        amp: { scope: null },
        amq: { scope: null },
        amr: { scope: null },
        ams: { scope: null },
        amt: { scope: null },
        amu: { scope: null },
        amv: { scope: null },
        amw: { scope: null },
        amx: { scope: null },
        amy: { scope: null },
        amz: { scope: null },
        ana: { scope: null },
        anb: { scope: null },
        anc: { scope: null },
        and: { scope: null },
        ane: { scope: null },
        anf: { scope: null },
        ang: { scope: null },
        anh: { scope: null },
        ani: { scope: null },
        anj: { scope: null },
        ank: { scope: null },
        anl: { scope: null },
        anm: { scope: null },
        ann: { scope: null },
        ano: { scope: null },
        anp: { scope: null },
        anq: { scope: null },
        anr: { scope: null },
        ans: { scope: null },
        ant: { scope: null },
        anu: { scope: null },
        anv: { scope: null },
        anw: { scope: null },
        anx: { scope: null },
        any: { scope: null },
        anz: { scope: null },
        aoa: { scope: null },
        aob: { scope: null },
        aoc: { scope: null },
        aod: { scope: null },
        aoe: { scope: null },
        aof: { scope: null },
        aog: { scope: null },
        aoh: { scope: null },
        aoi: { scope: null },
        aoj: { scope: null },
        aok: { scope: null },
        aol: { scope: null },
        aom: { scope: null },
        aon: { scope: null },
        aor: { scope: null },
        aos: { scope: null },
        aot: { scope: null },
        aou: { scope: null },
        aox: { scope: null },
        aoz: { scope: null },
        apa: { scope: "collection" },
        apb: { scope: null },
        apc: { scope: null },
        apd: { scope: null },
        ape: { scope: null },
        apf: { scope: null },
        apg: { scope: null },
        aph: { scope: null },
        api: { scope: null },
        apj: { scope: null },
        apk: { scope: null },
        apl: { scope: null },
        apm: { scope: null },
        apn: { scope: null },
        apo: { scope: null },
        app: { scope: null },
        apq: { scope: null },
        apr: { scope: null },
        aps: { scope: null },
        apt: { scope: null },
        apu: { scope: null },
        apv: { scope: null },
        apw: { scope: null },
        apx: { scope: null },
        apy: { scope: null },
        apz: { scope: null },
        aqa: { scope: "collection" },
        aqc: { scope: null },
        aqd: { scope: null },
        aqg: { scope: null },
        aqk: { scope: null },
        aql: { scope: "collection" },
        aqm: { scope: null },
        aqn: { scope: null },
        aqp: { scope: null },
        aqr: { scope: null },
        aqt: { scope: null },
        aqz: { scope: null },
        arb: { scope: null },
        arc: { scope: null },
        ard: { scope: null },
        are: { scope: null },
        arh: { scope: null },
        ari: { scope: null },
        arj: { scope: null },
        ark: { scope: null },
        arl: { scope: null },
        arn: { scope: null },
        aro: { scope: null },
        arp: { scope: null },
        arq: { scope: null },
        arr: { scope: null },
        ars: { scope: null },
        art: { scope: "collection" },
        aru: { scope: null },
        arv: { scope: null },
        arw: { scope: null },
        arx: { scope: null },
        ary: { scope: null },
        arz: { scope: null },
        asa: { scope: null },
        asb: { scope: null },
        asc: { scope: null },
        asd: { scope: null },
        ase: { scope: null },
        asf: { scope: null },
        asg: { scope: null },
        ash: { scope: null },
        asi: { scope: null },
        asj: { scope: null },
        ask: { scope: null },
        asl: { scope: null },
        asn: { scope: null },
        aso: { scope: null },
        asp: { scope: null },
        asq: { scope: null },
        asr: { scope: null },
        ass: { scope: null },
        ast: { scope: null },
        asu: { scope: null },
        asv: { scope: null },
        asw: { scope: null },
        asx: { scope: null },
        asy: { scope: null },
        asz: { scope: null },
        ata: { scope: null },
        atb: { scope: null },
        atc: { scope: null },
        atd: { scope: null },
        ate: { scope: null },
        atg: { scope: null },
        ath: { scope: "collection" },
        ati: { scope: null },
        atj: { scope: null },
        atk: { scope: null },
        atl: { scope: null },
        atm: { scope: null },
        atn: { scope: null },
        ato: { scope: null },
        atp: { scope: null },
        atq: { scope: null },
        atr: { scope: null },
        ats: { scope: null },
        att: { scope: null },
        atu: { scope: null },
        atv: { scope: null },
        atw: { scope: null },
        atx: { scope: null },
        aty: { scope: null },
        atz: { scope: null },
        aua: { scope: null },
        aub: { scope: null },
        auc: { scope: null },
        aud: { scope: null },
        aue: { scope: null },
        auf: { scope: "collection" },
        aug: { scope: null },
        auh: { scope: null },
        aui: { scope: null },
        auj: { scope: null },
        auk: { scope: null },
        aul: { scope: null },
        aum: { scope: null },
        aun: { scope: null },
        auo: { scope: null },
        aup: { scope: null },
        auq: { scope: null },
        aur: { scope: null },
        aus: { scope: "collection" },
        aut: { scope: null },
        auu: { scope: null },
        auw: { scope: null },
        aux: { scope: null },
        auy: { scope: null },
        auz: { scope: null },
        avb: { scope: null },
        avd: { scope: null },
        avi: { scope: null },
        avk: { scope: null },
        avl: { scope: null },
        avm: { scope: null },
        avn: { scope: null },
        avo: { scope: null },
        avs: { scope: null },
        avt: { scope: null },
        avu: { scope: null },
        avv: { scope: null },
        awa: { scope: null },
        awb: { scope: null },
        awc: { scope: null },
        awd: { scope: "collection" },
        awe: { scope: null },
        awg: { scope: null },
        awh: { scope: null },
        awi: { scope: null },
        awk: { scope: null },
        awm: { scope: null },
        awn: { scope: null },
        awo: { scope: null },
        awr: { scope: null },
        aws: { scope: null },
        awt: { scope: null },
        awu: { scope: null },
        awv: { scope: null },
        aww: { scope: null },
        awx: { scope: null },
        awy: { scope: null },
        axb: { scope: null },
        axe: { scope: null },
        axg: { scope: null },
        axk: { scope: null },
        axl: { scope: null },
        axm: { scope: null },
        axx: { scope: null },
        aya: { scope: null },
        ayb: { scope: null },
        ayc: { scope: null },
        ayd: { scope: null },
        aye: { scope: null },
        ayg: { scope: null },
        ayh: { scope: null },
        ayi: { scope: null },
        ayk: { scope: null },
        ayl: { scope: null },
        ayn: { scope: null },
        ayo: { scope: null },
        ayp: { scope: null },
        ayq: { scope: null },
        ayr: { scope: null },
        ays: { scope: null },
        ayt: { scope: null },
        ayu: { scope: null },
        ayx: { scope: null },
        ayy: { scope: null },
        ayz: { scope: null },
        aza: { scope: null },
        azb: { scope: null },
        azc: { scope: "collection" },
        azd: { scope: null },
        azg: { scope: null },
        azj: { scope: null },
        azm: { scope: null },
        azn: { scope: null },
        azo: { scope: null },
        azt: { scope: null },
        azz: { scope: null },
        baa: { scope: null },
        bab: { scope: null },
        bac: { scope: null },
        bad: { scope: "collection" },
        bae: { scope: null },
        baf: { scope: null },
        bag: { scope: null },
        bah: { scope: null },
        bai: { scope: "collection" },
        baj: { scope: null },
        bal: { scope: "macrolanguage" },
        ban: { scope: null },
        bao: { scope: null },
        bap: { scope: null },
        bar: { scope: null },
        bas: { scope: null },
        bat: { scope: "collection" },
        bau: { scope: null },
        bav: { scope: null },
        baw: { scope: null },
        bax: { scope: null },
        bay: { scope: null },
        baz: { scope: null },
        bba: { scope: null },
        bbb: { scope: null },
        bbc: { scope: null },
        bbd: { scope: null },
        bbe: { scope: null },
        bbf: { scope: null },
        bbg: { scope: null },
        bbh: { scope: null },
        bbi: { scope: null },
        bbj: { scope: null },
        bbk: { scope: null },
        bbl: { scope: null },
        bbm: { scope: null },
        bbn: { scope: null },
        bbo: { scope: null },
        bbp: { scope: null },
        bbq: { scope: null },
        bbr: { scope: null },
        bbs: { scope: null },
        bbt: { scope: null },
        bbu: { scope: null },
        bbv: { scope: null },
        bbw: { scope: null },
        bbx: { scope: null },
        bby: { scope: null },
        bbz: { scope: null },
        bca: { scope: null },
        bcb: { scope: null },
        bcc: { scope: null },
        bcd: { scope: null },
        bce: { scope: null },
        bcf: { scope: null },
        bcg: { scope: null },
        bch: { scope: null },
        bci: { scope: null },
        bcj: { scope: null },
        bck: { scope: null },
        bcl: { scope: null },
        bcm: { scope: null },
        bcn: { scope: null },
        bco: { scope: null },
        bcp: { scope: null },
        bcq: { scope: null },
        bcr: { scope: null },
        bcs: { scope: null },
        bct: { scope: null },
        bcu: { scope: null },
        bcv: { scope: null },
        bcw: { scope: null },
        bcy: { scope: null },
        bcz: { scope: null },
        bda: { scope: null },
        bdb: { scope: null },
        bdc: { scope: null },
        bdd: { scope: null },
        bde: { scope: null },
        bdf: { scope: null },
        bdg: { scope: null },
        bdh: { scope: null },
        bdi: { scope: null },
        bdj: { scope: null },
        bdk: { scope: null },
        bdl: { scope: null },
        bdm: { scope: null },
        bdn: { scope: null },
        bdo: { scope: null },
        bdp: { scope: null },
        bdq: { scope: null },
        bdr: { scope: null },
        bds: { scope: null },
        bdt: { scope: null },
        bdu: { scope: null },
        bdv: { scope: null },
        bdw: { scope: null },
        bdx: { scope: null },
        bdy: { scope: null },
        bdz: { scope: null },
        bea: { scope: null },
        beb: { scope: null },
        bec: { scope: null },
        bed: { scope: null },
        bee: { scope: null },
        bef: { scope: null },
        beg: { scope: null },
        beh: { scope: null },
        bei: { scope: null },
        bej: { scope: null },
        bek: { scope: null },
        bem: { scope: null },
        beo: { scope: null },
        bep: { scope: null },
        beq: { scope: null },
        ber: { scope: "collection" },
        bes: { scope: null },
        bet: { scope: null },
        beu: { scope: null },
        bev: { scope: null },
        bew: { scope: null },
        bex: { scope: null },
        bey: { scope: null },
        bez: { scope: null },
        bfa: { scope: null },
        bfb: { scope: null },
        bfc: { scope: null },
        bfd: { scope: null },
        bfe: { scope: null },
        bff: { scope: null },
        bfg: { scope: null },
        bfh: { scope: null },
        bfi: { scope: null },
        bfj: { scope: null },
        bfk: { scope: null },
        bfl: { scope: null },
        bfm: { scope: null },
        bfn: { scope: null },
        bfo: { scope: null },
        bfp: { scope: null },
        bfq: { scope: null },
        bfr: { scope: null },
        bfs: { scope: null },
        bft: { scope: null },
        bfu: { scope: null },
        bfw: { scope: null },
        bfx: { scope: null },
        bfy: { scope: null },
        bfz: { scope: null },
        bga: { scope: null },
        bgb: { scope: null },
        bgc: { scope: null },
        bgd: { scope: null },
        bge: { scope: null },
        bgf: { scope: null },
        bgg: { scope: null },
        bgi: { scope: null },
        bgj: { scope: null },
        bgk: { scope: null },
        bgl: { scope: null },
        bgm: { scope: null },
        bgn: { scope: null },
        bgo: { scope: null },
        bgp: { scope: null },
        bgq: { scope: null },
        bgr: { scope: null },
        bgs: { scope: null },
        bgt: { scope: null },
        bgu: { scope: null },
        bgv: { scope: null },
        bgw: { scope: null },
        bgx: { scope: null },
        bgy: { scope: null },
        bgz: { scope: null },
        bha: { scope: null },
        bhb: { scope: null },
        bhc: { scope: null },
        bhd: { scope: null },
        bhe: { scope: null },
        bhf: { scope: null },
        bhg: { scope: null },
        bhh: { scope: null },
        bhi: { scope: null },
        bhj: { scope: null },
        bhk: { scope: null },
        bhl: { scope: null },
        bhm: { scope: null },
        bhn: { scope: null },
        bho: { scope: null },
        bhp: { scope: null },
        bhq: { scope: null },
        bhr: { scope: null },
        bhs: { scope: null },
        bht: { scope: null },
        bhu: { scope: null },
        bhv: { scope: null },
        bhw: { scope: null },
        bhx: { scope: null },
        bhy: { scope: null },
        bhz: { scope: null },
        bia: { scope: null },
        bib: { scope: null },
        bic: { scope: null },
        bid: { scope: null },
        bie: { scope: null },
        bif: { scope: null },
        big: { scope: null },
        bij: { scope: null },
        bik: { scope: "macrolanguage" },
        bil: { scope: null },
        bim: { scope: null },
        bin: { scope: null },
        bio: { scope: null },
        bip: { scope: null },
        biq: { scope: null },
        bir: { scope: null },
        bit: { scope: null },
        biu: { scope: null },
        biv: { scope: null },
        biw: { scope: null },
        bix: { scope: null },
        biy: { scope: null },
        biz: { scope: null },
        bja: { scope: null },
        bjb: { scope: null },
        bjc: { scope: null },
        bjd: { scope: null },
        bje: { scope: null },
        bjf: { scope: null },
        bjg: { scope: null },
        bjh: { scope: null },
        bji: { scope: null },
        bjj: { scope: null },
        bjk: { scope: null },
        bjl: { scope: null },
        bjm: { scope: null },
        bjn: { scope: null },
        bjo: { scope: null },
        bjp: { scope: null },
        bjq: { scope: null },
        bjr: { scope: null },
        bjs: { scope: null },
        bjt: { scope: null },
        bju: { scope: null },
        bjv: { scope: null },
        bjw: { scope: null },
        bjx: { scope: null },
        bjy: { scope: null },
        bjz: { scope: null },
        bka: { scope: null },
        bkb: { scope: null },
        bkc: { scope: null },
        bkd: { scope: null },
        bkf: { scope: null },
        bkg: { scope: null },
        bkh: { scope: null },
        bki: { scope: null },
        bkj: { scope: null },
        bkk: { scope: null },
        bkl: { scope: null },
        bkm: { scope: null },
        bkn: { scope: null },
        bko: { scope: null },
        bkp: { scope: null },
        bkq: { scope: null },
        bkr: { scope: null },
        bks: { scope: null },
        bkt: { scope: null },
        bku: { scope: null },
        bkv: { scope: null },
        bkw: { scope: null },
        bkx: { scope: null },
        bky: { scope: null },
        bkz: { scope: null },
        bla: { scope: null },
        blb: { scope: null },
        blc: { scope: null },
        bld: { scope: null },
        ble: { scope: null },
        blf: { scope: null },
        blg: { scope: null },
        blh: { scope: null },
        bli: { scope: null },
        blj: { scope: null },
        blk: { scope: null },
        bll: { scope: null },
        blm: { scope: null },
        bln: { scope: null },
        blo: { scope: null },
        blp: { scope: null },
        blq: { scope: null },
        blr: { scope: null },
        bls: { scope: null },
        blt: { scope: null },
        blv: { scope: null },
        blw: { scope: null },
        blx: { scope: null },
        bly: { scope: null },
        blz: { scope: null },
        bma: { scope: null },
        bmb: { scope: null },
        bmc: { scope: null },
        bmd: { scope: null },
        bme: { scope: null },
        bmf: { scope: null },
        bmg: { scope: null },
        bmh: { scope: null },
        bmi: { scope: null },
        bmj: { scope: null },
        bmk: { scope: null },
        bml: { scope: null },
        bmm: { scope: null },
        bmn: { scope: null },
        bmo: { scope: null },
        bmp: { scope: null },
        bmq: { scope: null },
        bmr: { scope: null },
        bms: { scope: null },
        bmt: { scope: null },
        bmu: { scope: null },
        bmv: { scope: null },
        bmw: { scope: null },
        bmx: { scope: null },
        bmy: { scope: null },
        bmz: { scope: null },
        bna: { scope: null },
        bnb: { scope: null },
        bnc: { scope: "macrolanguage" },
        bnd: { scope: null },
        bne: { scope: null },
        bnf: { scope: null },
        bng: { scope: null },
        bni: { scope: null },
        bnj: { scope: null },
        bnk: { scope: null },
        bnl: { scope: null },
        bnm: { scope: null },
        bnn: { scope: null },
        bno: { scope: null },
        bnp: { scope: null },
        bnq: { scope: null },
        bnr: { scope: null },
        bns: { scope: null },
        bnt: { scope: "collection" },
        bnu: { scope: null },
        bnv: { scope: null },
        bnw: { scope: null },
        bnx: { scope: null },
        bny: { scope: null },
        bnz: { scope: null },
        boa: { scope: null },
        bob: { scope: null },
        boe: { scope: null },
        bof: { scope: null },
        bog: { scope: null },
        boh: { scope: null },
        boi: { scope: null },
        boj: { scope: null },
        bok: { scope: null },
        bol: { scope: null },
        bom: { scope: null },
        bon: { scope: null },
        boo: { scope: null },
        bop: { scope: null },
        boq: { scope: null },
        bor: { scope: null },
        bot: { scope: null },
        bou: { scope: null },
        bov: { scope: null },
        bow: { scope: null },
        box: { scope: null },
        boy: { scope: null },
        boz: { scope: null },
        bpa: { scope: null },
        bpb: { scope: null },
        bpd: { scope: null },
        bpe: { scope: null },
        bpg: { scope: null },
        bph: { scope: null },
        bpi: { scope: null },
        bpj: { scope: null },
        bpk: { scope: null },
        bpl: { scope: null },
        bpm: { scope: null },
        bpn: { scope: null },
        bpo: { scope: null },
        bpp: { scope: null },
        bpq: { scope: null },
        bpr: { scope: null },
        bps: { scope: null },
        bpt: { scope: null },
        bpu: { scope: null },
        bpv: { scope: null },
        bpw: { scope: null },
        bpx: { scope: null },
        bpy: { scope: null },
        bpz: { scope: null },
        bqa: { scope: null },
        bqb: { scope: null },
        bqc: { scope: null },
        bqd: { scope: null },
        bqf: { scope: null },
        bqg: { scope: null },
        bqh: { scope: null },
        bqi: { scope: null },
        bqj: { scope: null },
        bqk: { scope: null },
        bql: { scope: null },
        bqm: { scope: null },
        bqn: { scope: null },
        bqo: { scope: null },
        bqp: { scope: null },
        bqq: { scope: null },
        bqr: { scope: null },
        bqs: { scope: null },
        bqt: { scope: null },
        bqu: { scope: null },
        bqv: { scope: null },
        bqw: { scope: null },
        bqx: { scope: null },
        bqy: { scope: null },
        bqz: { scope: null },
        bra: { scope: null },
        brb: { scope: null },
        brc: { scope: null },
        brd: { scope: null },
        brf: { scope: null },
        brg: { scope: null },
        brh: { scope: null },
        bri: { scope: null },
        brj: { scope: null },
        brk: { scope: null },
        brl: { scope: null },
        brm: { scope: null },
        brn: { scope: null },
        bro: { scope: null },
        brp: { scope: null },
        brq: { scope: null },
        brr: { scope: null },
        brs: { scope: null },
        brt: { scope: null },
        bru: { scope: null },
        brv: { scope: null },
        brw: { scope: null },
        brx: { scope: null },
        bry: { scope: null },
        brz: { scope: null },
        bsa: { scope: null },
        bsb: { scope: null },
        bsc: { scope: null },
        bse: { scope: null },
        bsf: { scope: null },
        bsg: { scope: null },
        bsh: { scope: null },
        bsi: { scope: null },
        bsj: { scope: null },
        bsk: { scope: null },
        bsl: { scope: null },
        bsm: { scope: null },
        bsn: { scope: null },
        bso: { scope: null },
        bsp: { scope: null },
        bsq: { scope: null },
        bsr: { scope: null },
        bss: { scope: null },
        bst: { scope: null },
        bsu: { scope: null },
        bsv: { scope: null },
        bsw: { scope: null },
        bsx: { scope: null },
        bsy: { scope: null },
        bta: { scope: null },
        btb: { scope: null },
        btc: { scope: null },
        btd: { scope: null },
        bte: { scope: null },
        btf: { scope: null },
        btg: { scope: null },
        bth: { scope: null },
        bti: { scope: null },
        btj: { scope: null },
        btk: { scope: "collection" },
        btl: { scope: null },
        btm: { scope: null },
        btn: { scope: null },
        bto: { scope: null },
        btp: { scope: null },
        btq: { scope: null },
        btr: { scope: null },
        bts: { scope: null },
        btt: { scope: null },
        btu: { scope: null },
        btv: { scope: null },
        btw: { scope: null },
        btx: { scope: null },
        bty: { scope: null },
        btz: { scope: null },
        bua: { scope: "macrolanguage" },
        bub: { scope: null },
        buc: { scope: null },
        bud: { scope: null },
        bue: { scope: null },
        buf: { scope: null },
        bug: { scope: null },
        buh: { scope: null },
        bui: { scope: null },
        buj: { scope: null },
        buk: { scope: null },
        bum: { scope: null },
        bun: { scope: null },
        buo: { scope: null },
        bup: { scope: null },
        buq: { scope: null },
        bus: { scope: null },
        but: { scope: null },
        buu: { scope: null },
        buv: { scope: null },
        buw: { scope: null },
        bux: { scope: null },
        buy: { scope: null },
        buz: { scope: null },
        bva: { scope: null },
        bvb: { scope: null },
        bvc: { scope: null },
        bvd: { scope: null },
        bve: { scope: null },
        bvf: { scope: null },
        bvg: { scope: null },
        bvh: { scope: null },
        bvi: { scope: null },
        bvj: { scope: null },
        bvk: { scope: null },
        bvl: { scope: null },
        bvm: { scope: null },
        bvn: { scope: null },
        bvo: { scope: null },
        bvp: { scope: null },
        bvq: { scope: null },
        bvr: { scope: null },
        bvt: { scope: null },
        bvu: { scope: null },
        bvv: { scope: null },
        bvw: { scope: null },
        bvx: { scope: null },
        bvy: { scope: null },
        bvz: { scope: null },
        bwa: { scope: null },
        bwb: { scope: null },
        bwc: { scope: null },
        bwd: { scope: null },
        bwe: { scope: null },
        bwf: { scope: null },
        bwg: { scope: null },
        bwh: { scope: null },
        bwi: { scope: null },
        bwj: { scope: null },
        bwk: { scope: null },
        bwl: { scope: null },
        bwm: { scope: null },
        bwn: { scope: null },
        bwo: { scope: null },
        bwp: { scope: null },
        bwq: { scope: null },
        bwr: { scope: null },
        bws: { scope: null },
        bwt: { scope: null },
        bwu: { scope: null },
        bww: { scope: null },
        bwx: { scope: null },
        bwy: { scope: null },
        bwz: { scope: null },
        bxa: { scope: null },
        bxb: { scope: null },
        bxc: { scope: null },
        bxd: { scope: null },
        bxe: { scope: null },
        bxf: { scope: null },
        bxg: { scope: null },
        bxh: { scope: null },
        bxi: { scope: null },
        bxj: { scope: null },
        bxk: { scope: null },
        bxl: { scope: null },
        bxm: { scope: null },
        bxn: { scope: null },
        bxo: { scope: null },
        bxp: { scope: null },
        bxq: { scope: null },
        bxr: { scope: null },
        bxs: { scope: null },
        bxu: { scope: null },
        bxv: { scope: null },
        bxw: { scope: null },
        bxx: { scope: null },
        bxz: { scope: null },
        bya: { scope: null },
        byb: { scope: null },
        byc: { scope: null },
        byd: { scope: null },
        bye: { scope: null },
        byf: { scope: null },
        byg: { scope: null },
        byh: { scope: null },
        byi: { scope: null },
        byj: { scope: null },
        byk: { scope: null },
        byl: { scope: null },
        bym: { scope: null },
        byn: { scope: null },
        byo: { scope: null },
        byp: { scope: null },
        byq: { scope: null },
        byr: { scope: null },
        bys: { scope: null },
        byt: { scope: null },
        byv: { scope: null },
        byw: { scope: null },
        byx: { scope: null },
        byy: { scope: null },
        byz: { scope: null },
        bza: { scope: null },
        bzb: { scope: null },
        bzc: { scope: null },
        bzd: { scope: null },
        bze: { scope: null },
        bzf: { scope: null },
        bzg: { scope: null },
        bzh: { scope: null },
        bzi: { scope: null },
        bzj: { scope: null },
        bzk: { scope: null },
        bzl: { scope: null },
        bzm: { scope: null },
        bzn: { scope: null },
        bzo: { scope: null },
        bzp: { scope: null },
        bzq: { scope: null },
        bzr: { scope: null },
        bzs: { scope: null },
        bzt: { scope: null },
        bzu: { scope: null },
        bzv: { scope: null },
        bzw: { scope: null },
        bzx: { scope: null },
        bzy: { scope: null },
        bzz: { scope: null },
        caa: { scope: null },
        cab: { scope: null },
        cac: { scope: null },
        cad: { scope: null },
        cae: { scope: null },
        caf: { scope: null },
        cag: { scope: null },
        cah: { scope: null },
        cai: { scope: "collection" },
        caj: { scope: null },
        cak: { scope: null },
        cal: { scope: null },
        cam: { scope: null },
        can: { scope: null },
        cao: { scope: null },
        cap: { scope: null },
        caq: { scope: null },
        car: { scope: null },
        cas: { scope: null },
        cau: { scope: "collection" },
        cav: { scope: null },
        caw: { scope: null },
        cax: { scope: null },
        cay: { scope: null },
        caz: { scope: null },
        cba: { scope: "collection" },
        cbb: { scope: null },
        cbc: { scope: null },
        cbd: { scope: null },
        cbe: { scope: null },
        cbg: { scope: null },
        cbh: { scope: null },
        cbi: { scope: null },
        cbj: { scope: null },
        cbk: { scope: null },
        cbl: { scope: null },
        cbn: { scope: null },
        cbo: { scope: null },
        cbq: { scope: null },
        cbr: { scope: null },
        cbs: { scope: null },
        cbt: { scope: null },
        cbu: { scope: null },
        cbv: { scope: null },
        cbw: { scope: null },
        cby: { scope: null },
        cca: { scope: null },
        ccc: { scope: null },
        ccd: { scope: null },
        cce: { scope: null },
        ccg: { scope: null },
        cch: { scope: null },
        ccj: { scope: null },
        ccl: { scope: null },
        ccm: { scope: null },
        ccn: { scope: "collection" },
        cco: { scope: null },
        ccp: { scope: null },
        ccq: { scope: null },
        ccr: { scope: null },
        ccs: { scope: "collection" },
        cda: { scope: null },
        cdc: { scope: "collection" },
        cdd: { scope: "collection" },
        cde: { scope: null },
        cdf: { scope: null },
        cdg: { scope: null },
        cdh: { scope: null },
        cdi: { scope: null },
        cdj: { scope: null },
        cdm: { scope: null },
        cdn: { scope: null },
        cdo: { scope: null },
        cdr: { scope: null },
        cds: { scope: null },
        cdy: { scope: null },
        cdz: { scope: null },
        cea: { scope: null },
        ceb: { scope: null },
        ceg: { scope: null },
        cek: { scope: null },
        cel: { scope: "collection" },
        cen: { scope: null },
        cet: { scope: null },
        cey: { scope: null },
        cfa: { scope: null },
        cfd: { scope: null },
        cfg: { scope: null },
        cfm: { scope: null },
        cga: { scope: null },
        cgc: { scope: null },
        cgg: { scope: null },
        cgk: { scope: null },
        chb: { scope: null },
        chc: { scope: null },
        chd: { scope: null },
        chf: { scope: null },
        chg: { scope: null },
        chh: { scope: null },
        chj: { scope: null },
        chk: { scope: null },
        chl: { scope: null },
        chm: { scope: "macrolanguage" },
        chn: { scope: null },
        cho: { scope: null },
        chp: { scope: null },
        chq: { scope: null },
        chr: { scope: null },
        cht: { scope: null },
        chw: { scope: null },
        chx: { scope: null },
        chy: { scope: null },
        chz: { scope: null },
        cia: { scope: null },
        cib: { scope: null },
        cic: { scope: null },
        cid: { scope: null },
        cie: { scope: null },
        cih: { scope: null },
        cik: { scope: null },
        cim: { scope: null },
        cin: { scope: null },
        cip: { scope: null },
        cir: { scope: null },
        ciw: { scope: null },
        ciy: { scope: null },
        cja: { scope: null },
        cje: { scope: null },
        cjh: { scope: null },
        cji: { scope: null },
        cjk: { scope: null },
        cjm: { scope: null },
        cjn: { scope: null },
        cjo: { scope: null },
        cjp: { scope: null },
        cjr: { scope: null },
        cjs: { scope: null },
        cjv: { scope: null },
        cjy: { scope: null },
        cka: { scope: null },
        ckb: { scope: null },
        ckh: { scope: null },
        ckl: { scope: null },
        ckm: { scope: null },
        ckn: { scope: null },
        cko: { scope: null },
        ckq: { scope: null },
        ckr: { scope: null },
        cks: { scope: null },
        ckt: { scope: null },
        cku: { scope: null },
        ckv: { scope: null },
        ckx: { scope: null },
        cky: { scope: null },
        ckz: { scope: null },
        cla: { scope: null },
        clc: { scope: null },
        cld: { scope: null },
        cle: { scope: null },
        clh: { scope: null },
        cli: { scope: null },
        clj: { scope: null },
        clk: { scope: null },
        cll: { scope: null },
        clm: { scope: null },
        clo: { scope: null },
        clt: { scope: null },
        clu: { scope: null },
        clw: { scope: null },
        cly: { scope: null },
        cma: { scope: null },
        cmc: { scope: "collection" },
        cme: { scope: null },
        cmg: { scope: null },
        cmi: { scope: null },
        cmk: { scope: null },
        cml: { scope: null },
        cmm: { scope: null },
        cmn: { scope: null },
        cmo: { scope: null },
        cmr: { scope: null },
        cms: { scope: null },
        cmt: { scope: null },
        cna: { scope: null },
        cnb: { scope: null },
        cnc: { scope: null },
        cng: { scope: null },
        cnh: { scope: null },
        cni: { scope: null },
        cnk: { scope: null },
        cnl: { scope: null },
        cno: { scope: null },
        cnp: { scope: null },
        cnr: { scope: null },
        cns: { scope: null },
        cnt: { scope: null },
        cnu: { scope: null },
        cnw: { scope: null },
        cnx: { scope: null },
        coa: { scope: null },
        cob: { scope: null },
        coc: { scope: null },
        cod: { scope: null },
        coe: { scope: null },
        cof: { scope: null },
        cog: { scope: null },
        coh: { scope: null },
        coj: { scope: null },
        cok: { scope: null },
        col: { scope: null },
        com: { scope: null },
        con: { scope: null },
        coo: { scope: null },
        cop: { scope: null },
        coq: { scope: null },
        cot: { scope: null },
        cou: { scope: null },
        cov: { scope: null },
        cow: { scope: null },
        cox: { scope: null },
        coy: { scope: null },
        coz: { scope: null },
        cpa: { scope: null },
        cpb: { scope: null },
        cpc: { scope: null },
        cpe: { scope: "collection" },
        cpf: { scope: "collection" },
        cpg: { scope: null },
        cpi: { scope: null },
        cpn: { scope: null },
        cpo: { scope: null },
        cpp: { scope: "collection" },
        cps: { scope: null },
        cpu: { scope: null },
        cpx: { scope: null },
        cpy: { scope: null },
        cqd: { scope: null },
        cqu: { scope: null },
        cra: { scope: null },
        crb: { scope: null },
        crc: { scope: null },
        crd: { scope: null },
        crf: { scope: null },
        crg: { scope: null },
        crh: { scope: null },
        cri: { scope: null },
        crj: { scope: null },
        crk: { scope: null },
        crl: { scope: null },
        crm: { scope: null },
        crn: { scope: null },
        cro: { scope: null },
        crp: { scope: "collection" },
        crq: { scope: null },
        crr: { scope: null },
        crs: { scope: null },
        crt: { scope: null },
        crv: { scope: null },
        crw: { scope: null },
        crx: { scope: null },
        cry: { scope: null },
        crz: { scope: null },
        csa: { scope: null },
        csb: { scope: null },
        csc: { scope: null },
        csd: { scope: null },
        cse: { scope: null },
        csf: { scope: null },
        csg: { scope: null },
        csh: { scope: null },
        csi: { scope: null },
        csj: { scope: null },
        csk: { scope: null },
        csl: { scope: null },
        csm: { scope: null },
        csn: { scope: null },
        cso: { scope: null },
        csp: { scope: null },
        csq: { scope: null },
        csr: { scope: null },
        css: { scope: null },
        cst: { scope: null },
        csu: { scope: "collection" },
        csv: { scope: null },
        csw: { scope: null },
        csx: { scope: null },
        csy: { scope: null },
        csz: { scope: null },
        cta: { scope: null },
        ctc: { scope: null },
        ctd: { scope: null },
        cte: { scope: null },
        ctg: { scope: null },
        cth: { scope: null },
        ctl: { scope: null },
        ctm: { scope: null },
        ctn: { scope: null },
        cto: { scope: null },
        ctp: { scope: null },
        cts: { scope: null },
        ctt: { scope: null },
        ctu: { scope: null },
        cty: { scope: null },
        ctz: { scope: null },
        cua: { scope: null },
        cub: { scope: null },
        cuc: { scope: null },
        cug: { scope: null },
        cuh: { scope: null },
        cui: { scope: null },
        cuj: { scope: null },
        cuk: { scope: null },
        cul: { scope: null },
        cum: { scope: null },
        cuo: { scope: null },
        cup: { scope: null },
        cuq: { scope: null },
        cur: { scope: null },
        cus: { scope: "collection" },
        cut: { scope: null },
        cuu: { scope: null },
        cuv: { scope: null },
        cuw: { scope: null },
        cux: { scope: null },
        cuy: { scope: null },
        cvg: { scope: null },
        cvn: { scope: null },
        cwa: { scope: null },
        cwb: { scope: null },
        cwd: { scope: null },
        cwe: { scope: null },
        cwg: { scope: null },
        cwt: { scope: null },
        cya: { scope: null },
        cyb: { scope: null },
        cyo: { scope: null },
        czh: { scope: null },
        czk: { scope: null },
        czn: { scope: null },
        czo: { scope: null },
        czt: { scope: null },
        daa: { scope: null },
        dac: { scope: null },
        dad: { scope: null },
        dae: { scope: null },
        daf: { scope: null },
        dag: { scope: null },
        dah: { scope: null },
        dai: { scope: null },
        daj: { scope: null },
        dak: { scope: null },
        dal: { scope: null },
        dam: { scope: null },
        dao: { scope: null },
        dap: { scope: null },
        daq: { scope: null },
        dar: { scope: null },
        das: { scope: null },
        dau: { scope: null },
        dav: { scope: null },
        daw: { scope: null },
        dax: { scope: null },
        day: { scope: "collection" },
        daz: { scope: null },
        dba: { scope: null },
        dbb: { scope: null },
        dbd: { scope: null },
        dbe: { scope: null },
        dbf: { scope: null },
        dbg: { scope: null },
        dbi: { scope: null },
        dbj: { scope: null },
        dbl: { scope: null },
        dbm: { scope: null },
        dbn: { scope: null },
        dbo: { scope: null },
        dbp: { scope: null },
        dbq: { scope: null },
        dbr: { scope: null },
        dbt: { scope: null },
        dbu: { scope: null },
        dbv: { scope: null },
        dbw: { scope: null },
        dby: { scope: null },
        dcc: { scope: null },
        dcr: { scope: null },
        dda: { scope: null },
        ddd: { scope: null },
        dde: { scope: null },
        ddg: { scope: null },
        ddi: { scope: null },
        ddj: { scope: null },
        ddn: { scope: null },
        ddo: { scope: null },
        ddr: { scope: null },
        dds: { scope: null },
        ddw: { scope: null },
        dec: { scope: null },
        ded: { scope: null },
        dee: { scope: null },
        def: { scope: null },
        deg: { scope: null },
        deh: { scope: null },
        dei: { scope: null },
        dek: { scope: null },
        del: { scope: "macrolanguage" },
        dem: { scope: null },
        den: { scope: "macrolanguage" },
        dep: { scope: null },
        deq: { scope: null },
        der: { scope: null },
        des: { scope: null },
        dev: { scope: null },
        dez: { scope: null },
        dga: { scope: null },
        dgb: { scope: null },
        dgc: { scope: null },
        dgd: { scope: null },
        dge: { scope: null },
        dgg: { scope: null },
        dgh: { scope: null },
        dgi: { scope: null },
        dgk: { scope: null },
        dgl: { scope: null },
        dgn: { scope: null },
        dgo: { scope: null },
        dgr: { scope: null },
        dgs: { scope: null },
        dgt: { scope: null },
        dgu: { scope: null },
        dgw: { scope: null },
        dgx: { scope: null },
        dgz: { scope: null },
        dha: { scope: null },
        dhd: { scope: null },
        dhg: { scope: null },
        dhi: { scope: null },
        dhl: { scope: null },
        dhm: { scope: null },
        dhn: { scope: null },
        dho: { scope: null },
        dhr: { scope: null },
        dhs: { scope: null },
        dhu: { scope: null },
        dhv: { scope: null },
        dhw: { scope: null },
        dhx: { scope: null },
        dia: { scope: null },
        dib: { scope: null },
        dic: { scope: null },
        did: { scope: null },
        dif: { scope: null },
        dig: { scope: null },
        dih: { scope: null },
        dii: { scope: null },
        dij: { scope: null },
        dik: { scope: null },
        dil: { scope: null },
        dim: { scope: null },
        din: { scope: "macrolanguage" },
        dio: { scope: null },
        dip: { scope: null },
        diq: { scope: null },
        dir: { scope: null },
        dis: { scope: null },
        dit: { scope: null },
        diu: { scope: null },
        diw: { scope: null },
        dix: { scope: null },
        diy: { scope: null },
        diz: { scope: null },
        dja: { scope: null },
        djb: { scope: null },
        djc: { scope: null },
        djd: { scope: null },
        dje: { scope: null },
        djf: { scope: null },
        dji: { scope: null },
        djj: { scope: null },
        djk: { scope: null },
        djl: { scope: null },
        djm: { scope: null },
        djn: { scope: null },
        djo: { scope: null },
        djr: { scope: null },
        dju: { scope: null },
        djw: { scope: null },
        dka: { scope: null },
        dkg: { scope: null },
        dkk: { scope: null },
        dkl: { scope: null },
        dkr: { scope: null },
        dks: { scope: null },
        dkx: { scope: null },
        dlg: { scope: null },
        dlk: { scope: null },
        dlm: { scope: null },
        dln: { scope: null },
        dma: { scope: null },
        dmb: { scope: null },
        dmc: { scope: null },
        dmd: { scope: null },
        dme: { scope: null },
        dmf: { scope: null },
        dmg: { scope: null },
        dmk: { scope: null },
        dml: { scope: null },
        dmm: { scope: null },
        dmn: { scope: "collection" },
        dmo: { scope: null },
        dmr: { scope: null },
        dms: { scope: null },
        dmu: { scope: null },
        dmv: { scope: null },
        dmw: { scope: null },
        dmx: { scope: null },
        dmy: { scope: null },
        dna: { scope: null },
        dnd: { scope: null },
        dne: { scope: null },
        dng: { scope: null },
        dni: { scope: null },
        dnj: { scope: null },
        dnk: { scope: null },
        dnn: { scope: null },
        dno: { scope: null },
        dnr: { scope: null },
        dnt: { scope: null },
        dnu: { scope: null },
        dnv: { scope: null },
        dnw: { scope: null },
        dny: { scope: null },
        doa: { scope: null },
        dob: { scope: null },
        doc: { scope: null },
        doe: { scope: null },
        dof: { scope: null },
        doh: { scope: null },
        doi: { scope: "macrolanguage" },
        dok: { scope: null },
        dol: { scope: null },
        don: { scope: null },
        doo: { scope: null },
        dop: { scope: null },
        doq: { scope: null },
        dor: { scope: null },
        dos: { scope: null },
        dot: { scope: null },
        dov: { scope: null },
        dow: { scope: null },
        dox: { scope: null },
        doy: { scope: null },
        doz: { scope: null },
        dpp: { scope: null },
        dra: { scope: "collection" },
        drb: { scope: null },
        drc: { scope: null },
        drd: { scope: null },
        dre: { scope: null },
        drg: { scope: null },
        drh: { scope: null },
        dri: { scope: null },
        drl: { scope: null },
        drn: { scope: null },
        dro: { scope: null },
        drq: { scope: null },
        drr: { scope: null },
        drs: { scope: null },
        drt: { scope: null },
        dru: { scope: null },
        drw: { scope: null },
        dry: { scope: null },
        dsb: { scope: null },
        dse: { scope: null },
        dsh: { scope: null },
        dsi: { scope: null },
        dsl: { scope: null },
        dsn: { scope: null },
        dso: { scope: null },
        dsq: { scope: null },
        dta: { scope: null },
        dtb: { scope: null },
        dtd: { scope: null },
        dth: { scope: null },
        dti: { scope: null },
        dtk: { scope: null },
        dtm: { scope: null },
        dtn: { scope: null },
        dto: { scope: null },
        dtp: { scope: null },
        dtr: { scope: null },
        dts: { scope: null },
        dtt: { scope: null },
        dtu: { scope: null },
        dty: { scope: null },
        dua: { scope: null },
        dub: { scope: null },
        duc: { scope: null },
        dud: { scope: null },
        due: { scope: null },
        duf: { scope: null },
        dug: { scope: null },
        duh: { scope: null },
        dui: { scope: null },
        duj: { scope: null },
        duk: { scope: null },
        dul: { scope: null },
        dum: { scope: null },
        dun: { scope: null },
        duo: { scope: null },
        dup: { scope: null },
        duq: { scope: null },
        dur: { scope: null },
        dus: { scope: null },
        duu: { scope: null },
        duv: { scope: null },
        duw: { scope: null },
        dux: { scope: null },
        duy: { scope: null },
        duz: { scope: null },
        dva: { scope: null },
        dwa: { scope: null },
        dwk: { scope: null },
        dwl: { scope: null },
        dwr: { scope: null },
        dws: { scope: null },
        dwu: { scope: null },
        dww: { scope: null },
        dwy: { scope: null },
        dwz: { scope: null },
        dya: { scope: null },
        dyb: { scope: null },
        dyd: { scope: null },
        dyg: { scope: null },
        dyi: { scope: null },
        dym: { scope: null },
        dyn: { scope: null },
        dyo: { scope: null },
        dyu: { scope: null },
        dyy: { scope: null },
        dza: { scope: null },
        dzd: { scope: null },
        dze: { scope: null },
        dzg: { scope: null },
        dzl: { scope: null },
        dzn: { scope: null },
        eaa: { scope: null },
        ebc: { scope: null },
        ebg: { scope: null },
        ebk: { scope: null },
        ebo: { scope: null },
        ebr: { scope: null },
        ebu: { scope: null },
        ecr: { scope: null },
        ecs: { scope: null },
        ecy: { scope: null },
        eee: { scope: null },
        efa: { scope: null },
        efe: { scope: null },
        efi: { scope: null },
        ega: { scope: null },
        egl: { scope: null },
        ego: { scope: null },
        egx: { scope: "collection" },
        egy: { scope: null },
        ehs: { scope: null },
        ehu: { scope: null },
        eip: { scope: null },
        eit: { scope: null },
        eiv: { scope: null },
        eja: { scope: null },
        eka: { scope: null },
        ekc: { scope: null },
        eke: { scope: null },
        ekg: { scope: null },
        eki: { scope: null },
        ekk: { scope: null },
        ekl: { scope: null },
        ekm: { scope: null },
        eko: { scope: null },
        ekp: { scope: null },
        ekr: { scope: null },
        eky: { scope: null },
        ele: { scope: null },
        elh: { scope: null },
        eli: { scope: null },
        elk: { scope: null },
        elm: { scope: null },
        elo: { scope: null },
        elp: { scope: null },
        elu: { scope: null },
        elx: { scope: null },
        ema: { scope: null },
        emb: { scope: null },
        eme: { scope: null },
        emg: { scope: null },
        emi: { scope: null },
        emk: { scope: null },
        emm: { scope: null },
        emn: { scope: null },
        emo: { scope: null },
        emp: { scope: null },
        emq: { scope: null },
        ems: { scope: null },
        emu: { scope: null },
        emw: { scope: null },
        emx: { scope: null },
        emy: { scope: null },
        emz: { scope: null },
        ena: { scope: null },
        enb: { scope: null },
        enc: { scope: null },
        end: { scope: null },
        enf: { scope: null },
        enh: { scope: null },
        enl: { scope: null },
        enm: { scope: null },
        enn: { scope: null },
        eno: { scope: null },
        enq: { scope: null },
        enr: { scope: null },
        enu: { scope: null },
        env: { scope: null },
        enw: { scope: null },
        enx: { scope: null },
        eot: { scope: null },
        epi: { scope: null },
        era: { scope: null },
        erg: { scope: null },
        erh: { scope: null },
        eri: { scope: null },
        erk: { scope: null },
        ero: { scope: null },
        err: { scope: null },
        ers: { scope: null },
        ert: { scope: null },
        erw: { scope: null },
        ese: { scope: null },
        esg: { scope: null },
        esh: { scope: null },
        esi: { scope: null },
        esk: { scope: null },
        esl: { scope: null },
        esm: { scope: null },
        esn: { scope: null },
        eso: { scope: null },
        esq: { scope: null },
        ess: { scope: null },
        esu: { scope: null },
        esx: { scope: "collection" },
        esy: { scope: null },
        etb: { scope: null },
        etc: { scope: null },
        eth: { scope: null },
        etn: { scope: null },
        eto: { scope: null },
        etr: { scope: null },
        ets: { scope: null },
        ett: { scope: null },
        etu: { scope: null },
        etx: { scope: null },
        etz: { scope: null },
        euq: { scope: "collection" },
        eve: { scope: null },
        evh: { scope: null },
        evn: { scope: null },
        ewo: { scope: null },
        ext: { scope: null },
        eya: { scope: null },
        eyo: { scope: null },
        eza: { scope: null },
        eze: { scope: null },
        faa: { scope: null },
        fab: { scope: null },
        fad: { scope: null },
        faf: { scope: null },
        fag: { scope: null },
        fah: { scope: null },
        fai: { scope: null },
        faj: { scope: null },
        fak: { scope: null },
        fal: { scope: null },
        fam: { scope: null },
        fan: { scope: null },
        fap: { scope: null },
        far: { scope: null },
        fat: { scope: null },
        fau: { scope: null },
        fax: { scope: null },
        fay: { scope: null },
        faz: { scope: null },
        fbl: { scope: null },
        fcs: { scope: null },
        fer: { scope: null },
        ffi: { scope: null },
        ffm: { scope: null },
        fgr: { scope: null },
        fia: { scope: null },
        fie: { scope: null },
        fif: { scope: null },
        fil: { scope: null },
        fip: { scope: null },
        fir: { scope: null },
        fit: { scope: null },
        fiu: { scope: "collection" },
        fiw: { scope: null },
        fkk: { scope: null },
        fkv: { scope: null },
        fla: { scope: null },
        flh: { scope: null },
        fli: { scope: null },
        fll: { scope: null },
        fln: { scope: null },
        flr: { scope: null },
        fly: { scope: null },
        fmp: { scope: null },
        fmu: { scope: null },
        fnb: { scope: null },
        fng: { scope: null },
        fni: { scope: null },
        fod: { scope: null },
        foi: { scope: null },
        fom: { scope: null },
        fon: { scope: null },
        for: { scope: null },
        fos: { scope: null },
        fox: { scope: "collection" },
        fpe: { scope: null },
        fqs: { scope: null },
        frc: { scope: null },
        frd: { scope: null },
        frk: { scope: null },
        frm: { scope: null },
        fro: { scope: null },
        frp: { scope: null },
        frq: { scope: null },
        frr: { scope: null },
        frs: { scope: null },
        frt: { scope: null },
        fse: { scope: null },
        fsl: { scope: null },
        fss: { scope: null },
        fub: { scope: null },
        fuc: { scope: null },
        fud: { scope: null },
        fue: { scope: null },
        fuf: { scope: null },
        fuh: { scope: null },
        fui: { scope: null },
        fuj: { scope: null },
        fum: { scope: null },
        fun: { scope: null },
        fuq: { scope: null },
        fur: { scope: null },
        fut: { scope: null },
        fuu: { scope: null },
        fuv: { scope: null },
        fuy: { scope: null },
        fvr: { scope: null },
        fwa: { scope: null },
        fwe: { scope: null },
        gaa: { scope: null },
        gab: { scope: null },
        gac: { scope: null },
        gad: { scope: null },
        gae: { scope: null },
        gaf: { scope: null },
        gag: { scope: null },
        gah: { scope: null },
        gai: { scope: null },
        gaj: { scope: null },
        gak: { scope: null },
        gal: { scope: null },
        gam: { scope: null },
        gan: { scope: null },
        gao: { scope: null },
        gap: { scope: null },
        gaq: { scope: null },
        gar: { scope: null },
        gas: { scope: null },
        gat: { scope: null },
        gau: { scope: null },
        gav: { scope: null },
        gaw: { scope: null },
        gax: { scope: null },
        gay: { scope: null },
        gaz: { scope: null },
        gba: { scope: "macrolanguage" },
        gbb: { scope: null },
        gbc: { scope: null },
        gbd: { scope: null },
        gbe: { scope: null },
        gbf: { scope: null },
        gbg: { scope: null },
        gbh: { scope: null },
        gbi: { scope: null },
        gbj: { scope: null },
        gbk: { scope: null },
        gbl: { scope: null },
        gbm: { scope: null },
        gbn: { scope: null },
        gbo: { scope: null },
        gbp: { scope: null },
        gbq: { scope: null },
        gbr: { scope: null },
        gbs: { scope: null },
        gbu: { scope: null },
        gbv: { scope: null },
        gbw: { scope: null },
        gbx: { scope: null },
        gby: { scope: null },
        gbz: { scope: null },
        gcc: { scope: null },
        gcd: { scope: null },
        gce: { scope: null },
        gcf: { scope: null },
        gcl: { scope: null },
        gcn: { scope: null },
        gcr: { scope: null },
        gct: { scope: null },
        gda: { scope: null },
        gdb: { scope: null },
        gdc: { scope: null },
        gdd: { scope: null },
        gde: { scope: null },
        gdf: { scope: null },
        gdg: { scope: null },
        gdh: { scope: null },
        gdi: { scope: null },
        gdj: { scope: null },
        gdk: { scope: null },
        gdl: { scope: null },
        gdm: { scope: null },
        gdn: { scope: null },
        gdo: { scope: null },
        gdq: { scope: null },
        gdr: { scope: null },
        gds: { scope: null },
        gdt: { scope: null },
        gdu: { scope: null },
        gdx: { scope: null },
        gea: { scope: null },
        geb: { scope: null },
        gec: { scope: null },
        ged: { scope: null },
        gef: { scope: null },
        geg: { scope: null },
        geh: { scope: null },
        gei: { scope: null },
        gej: { scope: null },
        gek: { scope: null },
        gel: { scope: null },
        gem: { scope: "collection" },
        geq: { scope: null },
        ges: { scope: null },
        gev: { scope: null },
        gew: { scope: null },
        gex: { scope: null },
        gey: { scope: null },
        gez: { scope: null },
        gfk: { scope: null },
        gft: { scope: null },
        gfx: { scope: null },
        gga: { scope: null },
        ggb: { scope: null },
        ggd: { scope: null },
        gge: { scope: null },
        ggg: { scope: null },
        ggk: { scope: null },
        ggl: { scope: null },
        ggn: { scope: null },
        ggo: { scope: null },
        ggr: { scope: null },
        ggt: { scope: null },
        ggu: { scope: null },
        ggw: { scope: null },
        gha: { scope: null },
        ghc: { scope: null },
        ghe: { scope: null },
        ghh: { scope: null },
        ghk: { scope: null },
        ghl: { scope: null },
        ghn: { scope: null },
        gho: { scope: null },
        ghr: { scope: null },
        ghs: { scope: null },
        ght: { scope: null },
        gia: { scope: null },
        gib: { scope: null },
        gic: { scope: null },
        gid: { scope: null },
        gie: { scope: null },
        gig: { scope: null },
        gih: { scope: null },
        gii: { scope: null },
        gil: { scope: null },
        gim: { scope: null },
        gin: { scope: null },
        gio: { scope: null },
        gip: { scope: null },
        giq: { scope: null },
        gir: { scope: null },
        gis: { scope: null },
        git: { scope: null },
        giu: { scope: null },
        giw: { scope: null },
        gix: { scope: null },
        giy: { scope: null },
        giz: { scope: null },
        gji: { scope: null },
        gjk: { scope: null },
        gjm: { scope: null },
        gjn: { scope: null },
        gjr: { scope: null },
        gju: { scope: null },
        gka: { scope: null },
        gkd: { scope: null },
        gke: { scope: null },
        gkn: { scope: null },
        gko: { scope: null },
        gkp: { scope: null },
        gku: { scope: null },
        glb: { scope: null },
        glc: { scope: null },
        gld: { scope: null },
        glh: { scope: null },
        gli: { scope: null },
        glj: { scope: null },
        glk: { scope: null },
        gll: { scope: null },
        glo: { scope: null },
        glr: { scope: null },
        glu: { scope: null },
        glw: { scope: null },
        gly: { scope: null },
        gma: { scope: null },
        gmb: { scope: null },
        gmd: { scope: null },
        gme: { scope: "collection" },
        gmg: { scope: null },
        gmh: { scope: null },
        gml: { scope: null },
        gmm: { scope: null },
        gmn: { scope: null },
        gmq: { scope: "collection" },
        gmr: { scope: null },
        gmu: { scope: null },
        gmv: { scope: null },
        gmw: { scope: "collection" },
        gmx: { scope: null },
        gmy: { scope: null },
        gmz: { scope: null },
        gna: { scope: null },
        gnb: { scope: null },
        gnc: { scope: null },
        gnd: { scope: null },
        gne: { scope: null },
        gng: { scope: null },
        gnh: { scope: null },
        gni: { scope: null },
        gnj: { scope: null },
        gnk: { scope: null },
        gnl: { scope: null },
        gnm: { scope: null },
        gnn: { scope: null },
        gno: { scope: null },
        gnq: { scope: null },
        gnr: { scope: null },
        gnt: { scope: null },
        gnu: { scope: null },
        gnw: { scope: null },
        gnz: { scope: null },
        goa: { scope: null },
        gob: { scope: null },
        goc: { scope: null },
        god: { scope: null },
        goe: { scope: null },
        gof: { scope: null },
        gog: { scope: null },
        goh: { scope: null },
        goi: { scope: null },
        goj: { scope: null },
        gok: { scope: null },
        gol: { scope: null },
        gom: { scope: null },
        gon: { scope: "macrolanguage" },
        goo: { scope: null },
        gop: { scope: null },
        goq: { scope: null },
        gor: { scope: null },
        gos: { scope: null },
        got: { scope: null },
        gou: { scope: null },
        gow: { scope: null },
        gox: { scope: null },
        goy: { scope: null },
        goz: { scope: null },
        gpa: { scope: null },
        gpe: { scope: null },
        gpn: { scope: null },
        gqa: { scope: null },
        gqi: { scope: null },
        gqn: { scope: null },
        gqr: { scope: null },
        gqu: { scope: null },
        gra: { scope: null },
        grb: { scope: "macrolanguage" },
        grc: { scope: null },
        grd: { scope: null },
        grg: { scope: null },
        grh: { scope: null },
        gri: { scope: null },
        grj: { scope: null },
        grk: { scope: "collection" },
        grm: { scope: null },
        gro: { scope: null },
        grq: { scope: null },
        grr: { scope: null },
        grs: { scope: null },
        grt: { scope: null },
        gru: { scope: null },
        grv: { scope: null },
        grw: { scope: null },
        grx: { scope: null },
        gry: { scope: null },
        grz: { scope: null },
        gse: { scope: null },
        gsg: { scope: null },
        gsl: { scope: null },
        gsm: { scope: null },
        gsn: { scope: null },
        gso: { scope: null },
        gsp: { scope: null },
        gss: { scope: null },
        gsw: { scope: null },
        gta: { scope: null },
        gti: { scope: null },
        gtu: { scope: null },
        gua: { scope: null },
        gub: { scope: null },
        guc: { scope: null },
        gud: { scope: null },
        gue: { scope: null },
        guf: { scope: null },
        gug: { scope: null },
        guh: { scope: null },
        gui: { scope: null },
        guk: { scope: null },
        gul: { scope: null },
        gum: { scope: null },
        gun: { scope: null },
        guo: { scope: null },
        gup: { scope: null },
        guq: { scope: null },
        gur: { scope: null },
        gus: { scope: null },
        gut: { scope: null },
        guu: { scope: null },
        guv: { scope: null },
        guw: { scope: null },
        gux: { scope: null },
        guz: { scope: null },
        gva: { scope: null },
        gvc: { scope: null },
        gve: { scope: null },
        gvf: { scope: null },
        gvj: { scope: null },
        gvl: { scope: null },
        gvm: { scope: null },
        gvn: { scope: null },
        gvo: { scope: null },
        gvp: { scope: null },
        gvr: { scope: null },
        gvs: { scope: null },
        gvy: { scope: null },
        gwa: { scope: null },
        gwb: { scope: null },
        gwc: { scope: null },
        gwd: { scope: null },
        gwe: { scope: null },
        gwf: { scope: null },
        gwg: { scope: null },
        gwi: { scope: null },
        gwj: { scope: null },
        gwm: { scope: null },
        gwn: { scope: null },
        gwr: { scope: null },
        gwt: { scope: null },
        gwu: { scope: null },
        gww: { scope: null },
        gwx: { scope: null },
        gxx: { scope: null },
        gya: { scope: null },
        gyb: { scope: null },
        gyd: { scope: null },
        gye: { scope: null },
        gyf: { scope: null },
        gyg: { scope: null },
        gyi: { scope: null },
        gyl: { scope: null },
        gym: { scope: null },
        gyn: { scope: null },
        gyo: { scope: null },
        gyr: { scope: null },
        gyy: { scope: null },
        gyz: { scope: null },
        gza: { scope: null },
        gzi: { scope: null },
        gzn: { scope: null },
        haa: { scope: null },
        hab: { scope: null },
        hac: { scope: null },
        had: { scope: null },
        hae: { scope: null },
        haf: { scope: null },
        hag: { scope: null },
        hah: { scope: null },
        hai: { scope: "macrolanguage" },
        haj: { scope: null },
        hak: { scope: null },
        hal: { scope: null },
        ham: { scope: null },
        han: { scope: null },
        hao: { scope: null },
        hap: { scope: null },
        haq: { scope: null },
        har: { scope: null },
        has: { scope: null },
        hav: { scope: null },
        haw: { scope: null },
        hax: { scope: null },
        hay: { scope: null },
        haz: { scope: null },
        hba: { scope: null },
        hbb: { scope: null },
        hbn: { scope: null },
        hbo: { scope: null },
        hbu: { scope: null },
        hca: { scope: null },
        hch: { scope: null },
        hdn: { scope: null },
        hds: { scope: null },
        hdy: { scope: null },
        hea: { scope: null },
        hed: { scope: null },
        heg: { scope: null },
        heh: { scope: null },
        hei: { scope: null },
        hem: { scope: null },
        hgm: { scope: null },
        hgw: { scope: null },
        hhi: { scope: null },
        hhr: { scope: null },
        hhy: { scope: null },
        hia: { scope: null },
        hib: { scope: null },
        hid: { scope: null },
        hif: { scope: null },
        hig: { scope: null },
        hih: { scope: null },
        hii: { scope: null },
        hij: { scope: null },
        hik: { scope: null },
        hil: { scope: null },
        him: { scope: "collection" },
        hio: { scope: null },
        hir: { scope: null },
        hit: { scope: null },
        hiw: { scope: null },
        hix: { scope: null },
        hji: { scope: null },
        hka: { scope: null },
        hke: { scope: null },
        hkh: { scope: null },
        hkk: { scope: null },
        hkn: { scope: null },
        hks: { scope: null },
        hla: { scope: null },
        hlb: { scope: null },
        hld: { scope: null },
        hle: { scope: null },
        hlt: { scope: null },
        hlu: { scope: null },
        hma: { scope: null },
        hmb: { scope: null },
        hmc: { scope: null },
        hmd: { scope: null },
        hme: { scope: null },
        hmf: { scope: null },
        hmg: { scope: null },
        hmh: { scope: null },
        hmi: { scope: null },
        hmj: { scope: null },
        hmk: { scope: null },
        hml: { scope: null },
        hmm: { scope: null },
        hmn: { scope: "macrolanguage" },
        hmp: { scope: null },
        hmq: { scope: null },
        hmr: { scope: null },
        hms: { scope: null },
        hmt: { scope: null },
        hmu: { scope: null },
        hmv: { scope: null },
        hmw: { scope: null },
        hmx: { scope: "collection" },
        hmy: { scope: null },
        hmz: { scope: null },
        hna: { scope: null },
        hnd: { scope: null },
        hne: { scope: null },
        hng: { scope: null },
        hnh: { scope: null },
        hni: { scope: null },
        hnj: { scope: null },
        hnn: { scope: null },
        hno: { scope: null },
        hns: { scope: null },
        hnu: { scope: null },
        hoa: { scope: null },
        hob: { scope: null },
        hoc: { scope: null },
        hod: { scope: null },
        hoe: { scope: null },
        hoh: { scope: null },
        hoi: { scope: null },
        hoj: { scope: null },
        hok: { scope: "collection" },
        hol: { scope: null },
        hom: { scope: null },
        hoo: { scope: null },
        hop: { scope: null },
        hor: { scope: null },
        hos: { scope: null },
        hot: { scope: null },
        hov: { scope: null },
        how: { scope: null },
        hoy: { scope: null },
        hoz: { scope: null },
        hpo: { scope: null },
        hps: { scope: null },
        hra: { scope: null },
        hrc: { scope: null },
        hre: { scope: null },
        hrk: { scope: null },
        hrm: { scope: null },
        hro: { scope: null },
        hrp: { scope: null },
        hrr: { scope: null },
        hrt: { scope: null },
        hru: { scope: null },
        hrw: { scope: null },
        hrx: { scope: null },
        hrz: { scope: null },
        hsb: { scope: null },
        hsh: { scope: null },
        hsl: { scope: null },
        hsn: { scope: null },
        hss: { scope: null },
        hti: { scope: null },
        hto: { scope: null },
        hts: { scope: null },
        htu: { scope: null },
        htx: { scope: null },
        hub: { scope: null },
        huc: { scope: null },
        hud: { scope: null },
        hue: { scope: null },
        huf: { scope: null },
        hug: { scope: null },
        huh: { scope: null },
        hui: { scope: null },
        huj: { scope: null },
        huk: { scope: null },
        hul: { scope: null },
        hum: { scope: null },
        huo: { scope: null },
        hup: { scope: null },
        huq: { scope: null },
        hur: { scope: null },
        hus: { scope: null },
        hut: { scope: null },
        huu: { scope: null },
        huv: { scope: null },
        huw: { scope: null },
        hux: { scope: null },
        huy: { scope: null },
        huz: { scope: null },
        hvc: { scope: null },
        hve: { scope: null },
        hvk: { scope: null },
        hvn: { scope: null },
        hvv: { scope: null },
        hwa: { scope: null },
        hwc: { scope: null },
        hwo: { scope: null },
        hya: { scope: null },
        hyw: { scope: null },
        hyx: { scope: "collection" },
        iai: { scope: null },
        ian: { scope: null },
        iap: { scope: null },
        iar: { scope: null },
        iba: { scope: null },
        ibb: { scope: null },
        ibd: { scope: null },
        ibe: { scope: null },
        ibg: { scope: null },
        ibh: { scope: null },
        ibi: { scope: null },
        ibl: { scope: null },
        ibm: { scope: null },
        ibn: { scope: null },
        ibr: { scope: null },
        ibu: { scope: null },
        iby: { scope: null },
        ica: { scope: null },
        ich: { scope: null },
        icl: { scope: null },
        icr: { scope: null },
        ida: { scope: null },
        idb: { scope: null },
        idc: { scope: null },
        idd: { scope: null },
        ide: { scope: null },
        idi: { scope: null },
        idr: { scope: null },
        ids: { scope: null },
        idt: { scope: null },
        idu: { scope: null },
        ifa: { scope: null },
        ifb: { scope: null },
        ife: { scope: null },
        iff: { scope: null },
        ifk: { scope: null },
        ifm: { scope: null },
        ifu: { scope: null },
        ify: { scope: null },
        igb: { scope: null },
        ige: { scope: null },
        igg: { scope: null },
        igl: { scope: null },
        igm: { scope: null },
        ign: { scope: null },
        igo: { scope: null },
        igs: { scope: null },
        igw: { scope: null },
        ihb: { scope: null },
        ihi: { scope: null },
        ihp: { scope: null },
        ihw: { scope: null },
        iin: { scope: null },
        iir: { scope: "collection" },
        ijc: { scope: null },
        ije: { scope: null },
        ijj: { scope: null },
        ijn: { scope: null },
        ijo: { scope: "collection" },
        ijs: { scope: null },
        ike: { scope: null },
        iki: { scope: null },
        ikk: { scope: null },
        ikl: { scope: null },
        iko: { scope: null },
        ikp: { scope: null },
        ikr: { scope: null },
        iks: { scope: null },
        ikt: { scope: null },
        ikv: { scope: null },
        ikw: { scope: null },
        ikx: { scope: null },
        ikz: { scope: null },
        ila: { scope: null },
        ilb: { scope: null },
        ilg: { scope: null },
        ili: { scope: null },
        ilk: { scope: null },
        ill: { scope: null },
        ilm: { scope: null },
        ilo: { scope: null },
        ilp: { scope: null },
        ils: { scope: null },
        ilu: { scope: null },
        ilv: { scope: null },
        ilw: { scope: null },
        ima: { scope: null },
        ime: { scope: null },
        imi: { scope: null },
        iml: { scope: null },
        imn: { scope: null },
        imo: { scope: null },
        imr: { scope: null },
        ims: { scope: null },
        imy: { scope: null },
        inb: { scope: null },
        inc: { scope: "collection" },
        ine: { scope: "collection" },
        ing: { scope: null },
        inh: { scope: null },
        inj: { scope: null },
        inl: { scope: null },
        inm: { scope: null },
        inn: { scope: null },
        ino: { scope: null },
        inp: { scope: null },
        ins: { scope: null },
        int: { scope: null },
        inz: { scope: null },
        ior: { scope: null },
        iou: { scope: null },
        iow: { scope: null },
        ipi: { scope: null },
        ipo: { scope: null },
        iqu: { scope: null },
        iqw: { scope: null },
        ira: { scope: "collection" },
        ire: { scope: null },
        irh: { scope: null },
        iri: { scope: null },
        irk: { scope: null },
        irn: { scope: null },
        iro: { scope: "collection" },
        irr: { scope: null },
        iru: { scope: null },
        irx: { scope: null },
        iry: { scope: null },
        isa: { scope: null },
        isc: { scope: null },
        isd: { scope: null },
        ise: { scope: null },
        isg: { scope: null },
        ish: { scope: null },
        isi: { scope: null },
        isk: { scope: null },
        ism: { scope: null },
        isn: { scope: null },
        iso: { scope: null },
        isr: { scope: null },
        ist: { scope: null },
        isu: { scope: null },
        itb: { scope: null },
        itc: { scope: "collection" },
        itd: { scope: null },
        ite: { scope: null },
        iti: { scope: null },
        itk: { scope: null },
        itl: { scope: null },
        itm: { scope: null },
        ito: { scope: null },
        itr: { scope: null },
        its: { scope: null },
        itt: { scope: null },
        itv: { scope: null },
        itw: { scope: null },
        itx: { scope: null },
        ity: { scope: null },
        itz: { scope: null },
        ium: { scope: null },
        ivb: { scope: null },
        ivv: { scope: null },
        iwk: { scope: null },
        iwm: { scope: null },
        iwo: { scope: null },
        iws: { scope: null },
        ixc: { scope: null },
        ixl: { scope: null },
        iya: { scope: null },
        iyo: { scope: null },
        iyx: { scope: null },
        izh: { scope: null },
        izi: { scope: null },
        izr: { scope: null },
        izz: { scope: null },
        jaa: { scope: null },
        jab: { scope: null },
        jac: { scope: null },
        jad: { scope: null },
        jae: { scope: null },
        jaf: { scope: null },
        jah: { scope: null },
        jaj: { scope: null },
        jak: { scope: null },
        jal: { scope: null },
        jam: { scope: null },
        jan: { scope: null },
        jao: { scope: null },
        jaq: { scope: null },
        jar: { scope: null },
        jas: { scope: null },
        jat: { scope: null },
        jau: { scope: null },
        jax: { scope: null },
        jay: { scope: null },
        jaz: { scope: null },
        jbe: { scope: null },
        jbi: { scope: null },
        jbj: { scope: null },
        jbk: { scope: null },
        jbm: { scope: null },
        jbn: { scope: null },
        jbo: { scope: null },
        jbr: { scope: null },
        jbt: { scope: null },
        jbu: { scope: null },
        jbw: { scope: null },
        jcs: { scope: null },
        jct: { scope: null },
        jda: { scope: null },
        jdg: { scope: null },
        jdt: { scope: null },
        jeb: { scope: null },
        jee: { scope: null },
        jeg: { scope: null },
        jeh: { scope: null },
        jei: { scope: null },
        jek: { scope: null },
        jel: { scope: null },
        jen: { scope: null },
        jer: { scope: null },
        jet: { scope: null },
        jeu: { scope: null },
        jgb: { scope: null },
        jge: { scope: null },
        jgk: { scope: null },
        jgo: { scope: null },
        jhi: { scope: null },
        jhs: { scope: null },
        jia: { scope: null },
        jib: { scope: null },
        jic: { scope: null },
        jid: { scope: null },
        jie: { scope: null },
        jig: { scope: null },
        jih: { scope: null },
        jii: { scope: null },
        jil: { scope: null },
        jim: { scope: null },
        jio: { scope: null },
        jiq: { scope: null },
        jit: { scope: null },
        jiu: { scope: null },
        jiv: { scope: null },
        jiy: { scope: null },
        jje: { scope: null },
        jjr: { scope: null },
        jka: { scope: null },
        jkm: { scope: null },
        jko: { scope: null },
        jkp: { scope: null },
        jkr: { scope: null },
        jks: { scope: null },
        jku: { scope: null },
        jle: { scope: null },
        jls: { scope: null },
        jma: { scope: null },
        jmb: { scope: null },
        jmc: { scope: null },
        jmd: { scope: null },
        jmi: { scope: null },
        jml: { scope: null },
        jmn: { scope: null },
        jmr: { scope: null },
        jms: { scope: null },
        jmw: { scope: null },
        jmx: { scope: null },
        jna: { scope: null },
        jnd: { scope: null },
        jng: { scope: null },
        jni: { scope: null },
        jnj: { scope: null },
        jnl: { scope: null },
        jns: { scope: null },
        job: { scope: null },
        jod: { scope: null },
        jog: { scope: null },
        jor: { scope: null },
        jos: { scope: null },
        jow: { scope: null },
        jpa: { scope: null },
        jpr: { scope: null },
        jpx: { scope: "collection" },
        jqr: { scope: null },
        jra: { scope: null },
        jrb: { scope: "macrolanguage" },
        jrr: { scope: null },
        jrt: { scope: null },
        jru: { scope: null },
        jsl: { scope: null },
        jua: { scope: null },
        jub: { scope: null },
        juc: { scope: null },
        jud: { scope: null },
        juh: { scope: null },
        jui: { scope: null },
        juk: { scope: null },
        jul: { scope: null },
        jum: { scope: null },
        jun: { scope: null },
        juo: { scope: null },
        jup: { scope: null },
        jur: { scope: null },
        jus: { scope: null },
        jut: { scope: null },
        juu: { scope: null },
        juw: { scope: null },
        juy: { scope: null },
        jvd: { scope: null },
        jvn: { scope: null },
        jwi: { scope: null },
        jya: { scope: null },
        jye: { scope: null },
        jyy: { scope: null },
        kaa: { scope: null },
        kab: { scope: null },
        kac: { scope: null },
        kad: { scope: null },
        kae: { scope: null },
        kaf: { scope: null },
        kag: { scope: null },
        kah: { scope: null },
        kai: { scope: null },
        kaj: { scope: null },
        kak: { scope: null },
        kam: { scope: null },
        kao: { scope: null },
        kap: { scope: null },
        kaq: { scope: null },
        kar: { scope: "collection" },
        kav: { scope: null },
        kaw: { scope: null },
        kax: { scope: null },
        kay: { scope: null },
        kba: { scope: null },
        kbb: { scope: null },
        kbc: { scope: null },
        kbd: { scope: null },
        kbe: { scope: null },
        kbf: { scope: null },
        kbg: { scope: null },
        kbh: { scope: null },
        kbi: { scope: null },
        kbj: { scope: null },
        kbk: { scope: null },
        kbl: { scope: null },
        kbm: { scope: null },
        kbn: { scope: null },
        kbo: { scope: null },
        kbp: { scope: null },
        kbq: { scope: null },
        kbr: { scope: null },
        kbs: { scope: null },
        kbt: { scope: null },
        kbu: { scope: null },
        kbv: { scope: null },
        kbw: { scope: null },
        kbx: { scope: null },
        kby: { scope: null },
        kbz: { scope: null },
        kca: { scope: null },
        kcb: { scope: null },
        kcc: { scope: null },
        kcd: { scope: null },
        kce: { scope: null },
        kcf: { scope: null },
        kcg: { scope: null },
        kch: { scope: null },
        kci: { scope: null },
        kcj: { scope: null },
        kck: { scope: null },
        kcl: { scope: null },
        kcm: { scope: null },
        kcn: { scope: null },
        kco: { scope: null },
        kcp: { scope: null },
        kcq: { scope: null },
        kcr: { scope: null },
        kcs: { scope: null },
        kct: { scope: null },
        kcu: { scope: null },
        kcv: { scope: null },
        kcw: { scope: null },
        kcx: { scope: null },
        kcy: { scope: null },
        kcz: { scope: null },
        kda: { scope: null },
        kdc: { scope: null },
        kdd: { scope: null },
        kde: { scope: null },
        kdf: { scope: null },
        kdg: { scope: null },
        kdh: { scope: null },
        kdi: { scope: null },
        kdj: { scope: null },
        kdk: { scope: null },
        kdl: { scope: null },
        kdm: { scope: null },
        kdn: { scope: null },
        kdo: { scope: "collection" },
        kdp: { scope: null },
        kdq: { scope: null },
        kdr: { scope: null },
        kdt: { scope: null },
        kdu: { scope: null },
        kdv: { scope: null },
        kdw: { scope: null },
        kdx: { scope: null },
        kdy: { scope: null },
        kdz: { scope: null },
        kea: { scope: null },
        keb: { scope: null },
        kec: { scope: null },
        ked: { scope: null },
        kee: { scope: null },
        kef: { scope: null },
        keg: { scope: null },
        keh: { scope: null },
        kei: { scope: null },
        kej: { scope: null },
        kek: { scope: null },
        kel: { scope: null },
        kem: { scope: null },
        ken: { scope: null },
        keo: { scope: null },
        kep: { scope: null },
        keq: { scope: null },
        ker: { scope: null },
        kes: { scope: null },
        ket: { scope: null },
        keu: { scope: null },
        kev: { scope: null },
        kew: { scope: null },
        kex: { scope: null },
        key: { scope: null },
        kez: { scope: null },
        kfa: { scope: null },
        kfb: { scope: null },
        kfc: { scope: null },
        kfd: { scope: null },
        kfe: { scope: null },
        kff: { scope: null },
        kfg: { scope: null },
        kfh: { scope: null },
        kfi: { scope: null },
        kfj: { scope: null },
        kfk: { scope: null },
        kfl: { scope: null },
        kfm: { scope: null },
        kfn: { scope: null },
        kfo: { scope: null },
        kfp: { scope: null },
        kfq: { scope: null },
        kfr: { scope: null },
        kfs: { scope: null },
        kft: { scope: null },
        kfu: { scope: null },
        kfv: { scope: null },
        kfw: { scope: null },
        kfx: { scope: null },
        kfy: { scope: null },
        kfz: { scope: null },
        kga: { scope: null },
        kgb: { scope: null },
        kgc: { scope: null },
        kgd: { scope: null },
        kge: { scope: null },
        kgf: { scope: null },
        kgg: { scope: null },
        kgh: { scope: null },
        kgi: { scope: null },
        kgj: { scope: null },
        kgk: { scope: null },
        kgl: { scope: null },
        kgm: { scope: null },
        kgn: { scope: null },
        kgo: { scope: null },
        kgp: { scope: null },
        kgq: { scope: null },
        kgr: { scope: null },
        kgs: { scope: null },
        kgt: { scope: null },
        kgu: { scope: null },
        kgv: { scope: null },
        kgw: { scope: null },
        kgx: { scope: null },
        kgy: { scope: null },
        kha: { scope: null },
        khb: { scope: null },
        khc: { scope: null },
        khd: { scope: null },
        khe: { scope: null },
        khf: { scope: null },
        khg: { scope: null },
        khh: { scope: null },
        khi: { scope: "collection" },
        khj: { scope: null },
        khk: { scope: null },
        khl: { scope: null },
        khn: { scope: null },
        kho: { scope: null },
        khp: { scope: null },
        khq: { scope: null },
        khr: { scope: null },
        khs: { scope: null },
        kht: { scope: null },
        khu: { scope: null },
        khv: { scope: null },
        khw: { scope: null },
        khx: { scope: null },
        khy: { scope: null },
        khz: { scope: null },
        kia: { scope: null },
        kib: { scope: null },
        kic: { scope: null },
        kid: { scope: null },
        kie: { scope: null },
        kif: { scope: null },
        kig: { scope: null },
        kih: { scope: null },
        kii: { scope: null },
        kij: { scope: null },
        kil: { scope: null },
        kim: { scope: null },
        kio: { scope: null },
        kip: { scope: null },
        kiq: { scope: null },
        kis: { scope: null },
        kit: { scope: null },
        kiu: { scope: null },
        kiv: { scope: null },
        kiw: { scope: null },
        kix: { scope: null },
        kiy: { scope: null },
        kiz: { scope: null },
        kja: { scope: null },
        kjb: { scope: null },
        kjc: { scope: null },
        kjd: { scope: null },
        kje: { scope: null },
        kjf: { scope: null },
        kjg: { scope: null },
        kjh: { scope: null },
        kji: { scope: null },
        kjj: { scope: null },
        kjk: { scope: null },
        kjl: { scope: null },
        kjm: { scope: null },
        kjn: { scope: null },
        kjo: { scope: null },
        kjp: { scope: null },
        kjq: { scope: null },
        kjr: { scope: null },
        kjs: { scope: null },
        kjt: { scope: null },
        kju: { scope: null },
        kjv: { scope: null },
        kjx: { scope: null },
        kjy: { scope: null },
        kjz: { scope: null },
        kka: { scope: null },
        kkb: { scope: null },
        kkc: { scope: null },
        kkd: { scope: null },
        kke: { scope: null },
        kkf: { scope: null },
        kkg: { scope: null },
        kkh: { scope: null },
        kki: { scope: null },
        kkj: { scope: null },
        kkk: { scope: null },
        kkl: { scope: null },
        kkm: { scope: null },
        kkn: { scope: null },
        kko: { scope: null },
        kkp: { scope: null },
        kkq: { scope: null },
        kkr: { scope: null },
        kks: { scope: null },
        kkt: { scope: null },
        kku: { scope: null },
        kkv: { scope: null },
        kkw: { scope: null },
        kkx: { scope: null },
        kky: { scope: null },
        kkz: { scope: null },
        kla: { scope: null },
        klb: { scope: null },
        klc: { scope: null },
        kld: { scope: null },
        kle: { scope: null },
        klf: { scope: null },
        klg: { scope: null },
        klh: { scope: null },
        kli: { scope: null },
        klj: { scope: null },
        klk: { scope: null },
        kll: { scope: null },
        klm: { scope: null },
        kln: { scope: "macrolanguage" },
        klo: { scope: null },
        klp: { scope: null },
        klq: { scope: null },
        klr: { scope: null },
        kls: { scope: null },
        klt: { scope: null },
        klu: { scope: null },
        klv: { scope: null },
        klw: { scope: null },
        klx: { scope: null },
        kly: { scope: null },
        klz: { scope: null },
        kma: { scope: null },
        kmb: { scope: null },
        kmc: { scope: null },
        kmd: { scope: null },
        kme: { scope: null },
        kmf: { scope: null },
        kmg: { scope: null },
        kmh: { scope: null },
        kmi: { scope: null },
        kmj: { scope: null },
        kmk: { scope: null },
        kml: { scope: null },
        kmm: { scope: null },
        kmn: { scope: null },
        kmo: { scope: null },
        kmp: { scope: null },
        kmq: { scope: null },
        kmr: { scope: null },
        kms: { scope: null },
        kmt: { scope: null },
        kmu: { scope: null },
        kmv: { scope: null },
        kmw: { scope: null },
        kmx: { scope: null },
        kmy: { scope: null },
        kmz: { scope: null },
        kna: { scope: null },
        knb: { scope: null },
        knc: { scope: null },
        knd: { scope: null },
        kne: { scope: null },
        knf: { scope: null },
        kng: { scope: null },
        kni: { scope: null },
        knj: { scope: null },
        knk: { scope: null },
        knl: { scope: null },
        knm: { scope: null },
        knn: { scope: null },
        kno: { scope: null },
        knp: { scope: null },
        knq: { scope: null },
        knr: { scope: null },
        kns: { scope: null },
        knt: { scope: null },
        knu: { scope: null },
        knv: { scope: null },
        knw: { scope: null },
        knx: { scope: null },
        kny: { scope: null },
        knz: { scope: null },
        koa: { scope: null },
        koc: { scope: null },
        kod: { scope: null },
        koe: { scope: null },
        kof: { scope: null },
        kog: { scope: null },
        koh: { scope: null },
        koi: { scope: null },
        koj: { scope: null },
        kok: { scope: "macrolanguage" },
        kol: { scope: null },
        koo: { scope: null },
        kop: { scope: null },
        koq: { scope: null },
        kos: { scope: null },
        kot: { scope: null },
        kou: { scope: null },
        kov: { scope: null },
        kow: { scope: null },
        kox: { scope: null },
        koy: { scope: null },
        koz: { scope: null },
        kpa: { scope: null },
        kpb: { scope: null },
        kpc: { scope: null },
        kpd: { scope: null },
        kpe: { scope: "macrolanguage" },
        kpf: { scope: null },
        kpg: { scope: null },
        kph: { scope: null },
        kpi: { scope: null },
        kpj: { scope: null },
        kpk: { scope: null },
        kpl: { scope: null },
        kpm: { scope: null },
        kpn: { scope: null },
        kpo: { scope: null },
        kpp: { scope: null },
        kpq: { scope: null },
        kpr: { scope: null },
        kps: { scope: null },
        kpt: { scope: null },
        kpu: { scope: null },
        kpv: { scope: null },
        kpw: { scope: null },
        kpx: { scope: null },
        kpy: { scope: null },
        kpz: { scope: null },
        kqa: { scope: null },
        kqb: { scope: null },
        kqc: { scope: null },
        kqd: { scope: null },
        kqe: { scope: null },
        kqf: { scope: null },
        kqg: { scope: null },
        kqh: { scope: null },
        kqi: { scope: null },
        kqj: { scope: null },
        kqk: { scope: null },
        kql: { scope: null },
        kqm: { scope: null },
        kqn: { scope: null },
        kqo: { scope: null },
        kqp: { scope: null },
        kqq: { scope: null },
        kqr: { scope: null },
        kqs: { scope: null },
        kqt: { scope: null },
        kqu: { scope: null },
        kqv: { scope: null },
        kqw: { scope: null },
        kqx: { scope: null },
        kqy: { scope: null },
        kqz: { scope: null },
        kra: { scope: null },
        krb: { scope: null },
        krc: { scope: null },
        krd: { scope: null },
        kre: { scope: null },
        krf: { scope: null },
        krh: { scope: null },
        kri: { scope: null },
        krj: { scope: null },
        krk: { scope: null },
        krl: { scope: null },
        krm: { scope: null },
        krn: { scope: null },
        kro: { scope: "collection" },
        krp: { scope: null },
        krr: { scope: null },
        krs: { scope: null },
        krt: { scope: null },
        kru: { scope: null },
        krv: { scope: null },
        krw: { scope: null },
        krx: { scope: null },
        kry: { scope: null },
        krz: { scope: null },
        ksa: { scope: null },
        ksb: { scope: null },
        ksc: { scope: null },
        ksd: { scope: null },
        kse: { scope: null },
        ksf: { scope: null },
        ksg: { scope: null },
        ksh: { scope: null },
        ksi: { scope: null },
        ksj: { scope: null },
        ksk: { scope: null },
        ksl: { scope: null },
        ksm: { scope: null },
        ksn: { scope: null },
        kso: { scope: null },
        ksp: { scope: null },
        ksq: { scope: null },
        ksr: { scope: null },
        kss: { scope: null },
        kst: { scope: null },
        ksu: { scope: null },
        ksv: { scope: null },
        ksw: { scope: null },
        ksx: { scope: null },
        ksy: { scope: null },
        ksz: { scope: null },
        kta: { scope: null },
        ktb: { scope: null },
        ktc: { scope: null },
        ktd: { scope: null },
        kte: { scope: null },
        ktf: { scope: null },
        ktg: { scope: null },
        kth: { scope: null },
        kti: { scope: null },
        ktj: { scope: null },
        ktk: { scope: null },
        ktl: { scope: null },
        ktm: { scope: null },
        ktn: { scope: null },
        kto: { scope: null },
        ktp: { scope: null },
        ktq: { scope: null },
        ktr: { scope: null },
        kts: { scope: null },
        ktt: { scope: null },
        ktu: { scope: null },
        ktv: { scope: null },
        ktw: { scope: null },
        ktx: { scope: null },
        kty: { scope: null },
        ktz: { scope: null },
        kub: { scope: null },
        kuc: { scope: null },
        kud: { scope: null },
        kue: { scope: null },
        kuf: { scope: null },
        kug: { scope: null },
        kuh: { scope: null },
        kui: { scope: null },
        kuj: { scope: null },
        kuk: { scope: null },
        kul: { scope: null },
        kum: { scope: null },
        kun: { scope: null },
        kuo: { scope: null },
        kup: { scope: null },
        kuq: { scope: null },
        kus: { scope: null },
        kut: { scope: null },
        kuu: { scope: null },
        kuv: { scope: null },
        kuw: { scope: null },
        kux: { scope: null },
        kuy: { scope: null },
        kuz: { scope: null },
        kva: { scope: null },
        kvb: { scope: null },
        kvc: { scope: null },
        kvd: { scope: null },
        kve: { scope: null },
        kvf: { scope: null },
        kvg: { scope: null },
        kvh: { scope: null },
        kvi: { scope: null },
        kvj: { scope: null },
        kvk: { scope: null },
        kvl: { scope: null },
        kvm: { scope: null },
        kvn: { scope: null },
        kvo: { scope: null },
        kvp: { scope: null },
        kvq: { scope: null },
        kvr: { scope: null },
        kvs: { scope: null },
        kvt: { scope: null },
        kvu: { scope: null },
        kvv: { scope: null },
        kvw: { scope: null },
        kvx: { scope: null },
        kvy: { scope: null },
        kvz: { scope: null },
        kwa: { scope: null },
        kwb: { scope: null },
        kwc: { scope: null },
        kwd: { scope: null },
        kwe: { scope: null },
        kwf: { scope: null },
        kwg: { scope: null },
        kwh: { scope: null },
        kwi: { scope: null },
        kwj: { scope: null },
        kwk: { scope: null },
        kwl: { scope: null },
        kwm: { scope: null },
        kwn: { scope: null },
        kwo: { scope: null },
        kwp: { scope: null },
        kwq: { scope: null },
        kwr: { scope: null },
        kws: { scope: null },
        kwt: { scope: null },
        kwu: { scope: null },
        kwv: { scope: null },
        kww: { scope: null },
        kwx: { scope: null },
        kwy: { scope: null },
        kwz: { scope: null },
        kxa: { scope: null },
        kxb: { scope: null },
        kxc: { scope: null },
        kxd: { scope: null },
        kxe: { scope: null },
        kxf: { scope: null },
        kxh: { scope: null },
        kxi: { scope: null },
        kxj: { scope: null },
        kxk: { scope: null },
        kxl: { scope: null },
        kxm: { scope: null },
        kxn: { scope: null },
        kxo: { scope: null },
        kxp: { scope: null },
        kxq: { scope: null },
        kxr: { scope: null },
        kxs: { scope: null },
        kxt: { scope: null },
        kxu: { scope: null },
        kxv: { scope: null },
        kxw: { scope: null },
        kxx: { scope: null },
        kxy: { scope: null },
        kxz: { scope: null },
        kya: { scope: null },
        kyb: { scope: null },
        kyc: { scope: null },
        kyd: { scope: null },
        kye: { scope: null },
        kyf: { scope: null },
        kyg: { scope: null },
        kyh: { scope: null },
        kyi: { scope: null },
        kyj: { scope: null },
        kyk: { scope: null },
        kyl: { scope: null },
        kym: { scope: null },
        kyn: { scope: null },
        kyo: { scope: null },
        kyp: { scope: null },
        kyq: { scope: null },
        kyr: { scope: null },
        kys: { scope: null },
        kyt: { scope: null },
        kyu: { scope: null },
        kyv: { scope: null },
        kyw: { scope: null },
        kyx: { scope: null },
        kyy: { scope: null },
        kyz: { scope: null },
        kza: { scope: null },
        kzb: { scope: null },
        kzc: { scope: null },
        kzd: { scope: null },
        kze: { scope: null },
        kzf: { scope: null },
        kzg: { scope: null },
        kzh: { scope: null },
        kzi: { scope: null },
        kzj: { scope: null },
        kzk: { scope: null },
        kzl: { scope: null },
        kzm: { scope: null },
        kzn: { scope: null },
        kzo: { scope: null },
        kzp: { scope: null },
        kzq: { scope: null },
        kzr: { scope: null },
        kzs: { scope: null },
        kzt: { scope: null },
        kzu: { scope: null },
        kzv: { scope: null },
        kzw: { scope: null },
        kzx: { scope: null },
        kzy: { scope: null },
        kzz: { scope: null },
        laa: { scope: null },
        lab: { scope: null },
        lac: { scope: null },
        lad: { scope: null },
        lae: { scope: null },
        laf: { scope: null },
        lag: { scope: null },
        lah: { scope: "macrolanguage" },
        lai: { scope: null },
        laj: { scope: null },
        lak: { scope: null },
        lal: { scope: null },
        lam: { scope: null },
        lan: { scope: null },
        lap: { scope: null },
        laq: { scope: null },
        lar: { scope: null },
        las: { scope: null },
        lau: { scope: null },
        law: { scope: null },
        lax: { scope: null },
        lay: { scope: null },
        laz: { scope: null },
        lba: { scope: null },
        lbb: { scope: null },
        lbc: { scope: null },
        lbe: { scope: null },
        lbf: { scope: null },
        lbg: { scope: null },
        lbi: { scope: null },
        lbj: { scope: null },
        lbk: { scope: null },
        lbl: { scope: null },
        lbm: { scope: null },
        lbn: { scope: null },
        lbo: { scope: null },
        lbq: { scope: null },
        lbr: { scope: null },
        lbs: { scope: null },
        lbt: { scope: null },
        lbu: { scope: null },
        lbv: { scope: null },
        lbw: { scope: null },
        lbx: { scope: null },
        lby: { scope: null },
        lbz: { scope: null },
        lcc: { scope: null },
        lcd: { scope: null },
        lce: { scope: null },
        lcf: { scope: null },
        lch: { scope: null },
        lcl: { scope: null },
        lcm: { scope: null },
        lcp: { scope: null },
        lcq: { scope: null },
        lcs: { scope: null },
        lda: { scope: null },
        ldb: { scope: null },
        ldd: { scope: null },
        ldg: { scope: null },
        ldh: { scope: null },
        ldi: { scope: null },
        ldj: { scope: null },
        ldk: { scope: null },
        ldl: { scope: null },
        ldm: { scope: null },
        ldn: { scope: null },
        ldo: { scope: null },
        ldp: { scope: null },
        ldq: { scope: null },
        lea: { scope: null },
        leb: { scope: null },
        lec: { scope: null },
        led: { scope: null },
        lee: { scope: null },
        lef: { scope: null },
        leg: { scope: null },
        leh: { scope: null },
        lei: { scope: null },
        lej: { scope: null },
        lek: { scope: null },
        lel: { scope: null },
        lem: { scope: null },
        len: { scope: null },
        leo: { scope: null },
        lep: { scope: null },
        leq: { scope: null },
        ler: { scope: null },
        les: { scope: null },
        let: { scope: null },
        leu: { scope: null },
        lev: { scope: null },
        lew: { scope: null },
        lex: { scope: null },
        ley: { scope: null },
        lez: { scope: null },
        lfa: { scope: null },
        lfn: { scope: null },
        lga: { scope: null },
        lgb: { scope: null },
        lgg: { scope: null },
        lgh: { scope: null },
        lgi: { scope: null },
        lgk: { scope: null },
        lgl: { scope: null },
        lgm: { scope: null },
        lgn: { scope: null },
        lgq: { scope: null },
        lgr: { scope: null },
        lgt: { scope: null },
        lgu: { scope: null },
        lgz: { scope: null },
        lha: { scope: null },
        lhh: { scope: null },
        lhi: { scope: null },
        lhl: { scope: null },
        lhm: { scope: null },
        lhn: { scope: null },
        lhp: { scope: null },
        lhs: { scope: null },
        lht: { scope: null },
        lhu: { scope: null },
        lia: { scope: null },
        lib: { scope: null },
        lic: { scope: null },
        lid: { scope: null },
        lie: { scope: null },
        lif: { scope: null },
        lig: { scope: null },
        lih: { scope: null },
        lii: { scope: null },
        lij: { scope: null },
        lik: { scope: null },
        lil: { scope: null },
        lio: { scope: null },
        lip: { scope: null },
        liq: { scope: null },
        lir: { scope: null },
        lis: { scope: null },
        liu: { scope: null },
        liv: { scope: null },
        liw: { scope: null },
        lix: { scope: null },
        liy: { scope: null },
        liz: { scope: null },
        lja: { scope: null },
        lje: { scope: null },
        lji: { scope: null },
        ljl: { scope: null },
        ljp: { scope: null },
        ljw: { scope: null },
        ljx: { scope: null },
        lka: { scope: null },
        lkb: { scope: null },
        lkc: { scope: null },
        lkd: { scope: null },
        lke: { scope: null },
        lkh: { scope: null },
        lki: { scope: null },
        lkj: { scope: null },
        lkl: { scope: null },
        lkm: { scope: null },
        lkn: { scope: null },
        lko: { scope: null },
        lkr: { scope: null },
        lks: { scope: null },
        lkt: { scope: null },
        lku: { scope: null },
        lky: { scope: null },
        lla: { scope: null },
        llb: { scope: null },
        llc: { scope: null },
        lld: { scope: null },
        lle: { scope: null },
        llf: { scope: null },
        llg: { scope: null },
        llh: { scope: null },
        lli: { scope: null },
        llj: { scope: null },
        llk: { scope: null },
        lll: { scope: null },
        llm: { scope: null },
        lln: { scope: null },
        llo: { scope: null },
        llp: { scope: null },
        llq: { scope: null },
        lls: { scope: null },
        llu: { scope: null },
        llx: { scope: null },
        lma: { scope: null },
        lmb: { scope: null },
        lmc: { scope: null },
        lmd: { scope: null },
        lme: { scope: null },
        lmf: { scope: null },
        lmg: { scope: null },
        lmh: { scope: null },
        lmi: { scope: null },
        lmj: { scope: null },
        lmk: { scope: null },
        lml: { scope: null },
        lmm: { scope: null },
        lmn: { scope: null },
        lmo: { scope: null },
        lmp: { scope: null },
        lmq: { scope: null },
        lmr: { scope: null },
        lmu: { scope: null },
        lmv: { scope: null },
        lmw: { scope: null },
        lmx: { scope: null },
        lmy: { scope: null },
        lmz: { scope: null },
        lna: { scope: null },
        lnb: { scope: null },
        lnd: { scope: null },
        lng: { scope: null },
        lnh: { scope: null },
        lni: { scope: null },
        lnj: { scope: null },
        lnl: { scope: null },
        lnm: { scope: null },
        lnn: { scope: null },
        lno: { scope: null },
        lns: { scope: null },
        lnu: { scope: null },
        lnw: { scope: null },
        lnz: { scope: null },
        loa: { scope: null },
        lob: { scope: null },
        loc: { scope: null },
        loe: { scope: null },
        lof: { scope: null },
        log: { scope: null },
        loh: { scope: null },
        loi: { scope: null },
        loj: { scope: null },
        lok: { scope: null },
        lol: { scope: null },
        lom: { scope: null },
        lon: { scope: null },
        loo: { scope: null },
        lop: { scope: null },
        loq: { scope: null },
        lor: { scope: null },
        los: { scope: null },
        lot: { scope: null },
        lou: { scope: null },
        lov: { scope: null },
        low: { scope: null },
        lox: { scope: null },
        loy: { scope: null },
        loz: { scope: null },
        lpa: { scope: null },
        lpe: { scope: null },
        lpn: { scope: null },
        lpo: { scope: null },
        lpx: { scope: null },
        lra: { scope: null },
        lrc: { scope: null },
        lre: { scope: null },
        lrg: { scope: null },
        lri: { scope: null },
        lrk: { scope: null },
        lrl: { scope: null },
        lrm: { scope: null },
        lrn: { scope: null },
        lro: { scope: null },
        lrr: { scope: null },
        lrt: { scope: null },
        lrv: { scope: null },
        lrz: { scope: null },
        lsa: { scope: null },
        lsb: { scope: null },
        lsd: { scope: null },
        lse: { scope: null },
        lsg: { scope: null },
        lsh: { scope: null },
        lsi: { scope: null },
        lsl: { scope: null },
        lsm: { scope: null },
        lsn: { scope: null },
        lso: { scope: null },
        lsp: { scope: null },
        lsr: { scope: null },
        lss: { scope: null },
        lst: { scope: null },
        lsv: { scope: null },
        lsy: { scope: null },
        ltc: { scope: null },
        ltg: { scope: null },
        lth: { scope: null },
        lti: { scope: null },
        ltn: { scope: null },
        lto: { scope: null },
        lts: { scope: null },
        ltu: { scope: null },
        lua: { scope: null },
        luc: { scope: null },
        lud: { scope: null },
        lue: { scope: null },
        luf: { scope: null },
        lui: { scope: null },
        luj: { scope: null },
        luk: { scope: null },
        lul: { scope: null },
        lum: { scope: null },
        lun: { scope: null },
        luo: { scope: null },
        lup: { scope: null },
        luq: { scope: null },
        lur: { scope: null },
        lus: { scope: null },
        lut: { scope: null },
        luu: { scope: null },
        luv: { scope: null },
        luw: { scope: null },
        luy: { scope: "macrolanguage" },
        luz: { scope: null },
        lva: { scope: null },
        lvi: { scope: null },
        lvk: { scope: null },
        lvs: { scope: null },
        lvu: { scope: null },
        lwa: { scope: null },
        lwe: { scope: null },
        lwg: { scope: null },
        lwh: { scope: null },
        lwl: { scope: null },
        lwm: { scope: null },
        lwo: { scope: null },
        lws: { scope: null },
        lwt: { scope: null },
        lwu: { scope: null },
        lww: { scope: null },
        lxm: { scope: null },
        lya: { scope: null },
        lyg: { scope: null },
        lyn: { scope: null },
        lzh: { scope: null },
        lzl: { scope: null },
        lzn: { scope: null },
        lzz: { scope: null },
        maa: { scope: null },
        mab: { scope: null },
        mad: { scope: null },
        mae: { scope: null },
        maf: { scope: null },
        mag: { scope: null },
        mai: { scope: null },
        maj: { scope: null },
        mak: { scope: null },
        mam: { scope: null },
        man: { scope: "macrolanguage" },
        map: { scope: "collection" },
        maq: { scope: null },
        mas: { scope: null },
        mat: { scope: null },
        mau: { scope: null },
        mav: { scope: null },
        maw: { scope: null },
        max: { scope: null },
        maz: { scope: null },
        mba: { scope: null },
        mbb: { scope: null },
        mbc: { scope: null },
        mbd: { scope: null },
        mbe: { scope: null },
        mbf: { scope: null },
        mbh: { scope: null },
        mbi: { scope: null },
        mbj: { scope: null },
        mbk: { scope: null },
        mbl: { scope: null },
        mbm: { scope: null },
        mbn: { scope: null },
        mbo: { scope: null },
        mbp: { scope: null },
        mbq: { scope: null },
        mbr: { scope: null },
        mbs: { scope: null },
        mbt: { scope: null },
        mbu: { scope: null },
        mbv: { scope: null },
        mbw: { scope: null },
        mbx: { scope: null },
        mby: { scope: null },
        mbz: { scope: null },
        mca: { scope: null },
        mcb: { scope: null },
        mcc: { scope: null },
        mcd: { scope: null },
        mce: { scope: null },
        mcf: { scope: null },
        mcg: { scope: null },
        mch: { scope: null },
        mci: { scope: null },
        mcj: { scope: null },
        mck: { scope: null },
        mcl: { scope: null },
        mcm: { scope: null },
        mcn: { scope: null },
        mco: { scope: null },
        mcp: { scope: null },
        mcq: { scope: null },
        mcr: { scope: null },
        mcs: { scope: null },
        mct: { scope: null },
        mcu: { scope: null },
        mcv: { scope: null },
        mcw: { scope: null },
        mcx: { scope: null },
        mcy: { scope: null },
        mcz: { scope: null },
        mda: { scope: null },
        mdb: { scope: null },
        mdc: { scope: null },
        mdd: { scope: null },
        mde: { scope: null },
        mdf: { scope: null },
        mdg: { scope: null },
        mdh: { scope: null },
        mdi: { scope: null },
        mdj: { scope: null },
        mdk: { scope: null },
        mdl: { scope: null },
        mdm: { scope: null },
        mdn: { scope: null },
        mdp: { scope: null },
        mdq: { scope: null },
        mdr: { scope: null },
        mds: { scope: null },
        mdt: { scope: null },
        mdu: { scope: null },
        mdv: { scope: null },
        mdw: { scope: null },
        mdx: { scope: null },
        mdy: { scope: null },
        mdz: { scope: null },
        mea: { scope: null },
        meb: { scope: null },
        mec: { scope: null },
        med: { scope: null },
        mee: { scope: null },
        mef: { scope: null },
        meg: { scope: null },
        meh: { scope: null },
        mei: { scope: null },
        mej: { scope: null },
        mek: { scope: null },
        mel: { scope: null },
        mem: { scope: null },
        men: { scope: null },
        meo: { scope: null },
        mep: { scope: null },
        meq: { scope: null },
        mer: { scope: null },
        mes: { scope: null },
        met: { scope: null },
        meu: { scope: null },
        mev: { scope: null },
        mew: { scope: null },
        mey: { scope: null },
        mez: { scope: null },
        mfa: { scope: null },
        mfb: { scope: null },
        mfc: { scope: null },
        mfd: { scope: null },
        mfe: { scope: null },
        mff: { scope: null },
        mfg: { scope: null },
        mfh: { scope: null },
        mfi: { scope: null },
        mfj: { scope: null },
        mfk: { scope: null },
        mfl: { scope: null },
        mfm: { scope: null },
        mfn: { scope: null },
        mfo: { scope: null },
        mfp: { scope: null },
        mfq: { scope: null },
        mfr: { scope: null },
        mfs: { scope: null },
        mft: { scope: null },
        mfu: { scope: null },
        mfv: { scope: null },
        mfw: { scope: null },
        mfx: { scope: null },
        mfy: { scope: null },
        mfz: { scope: null },
        mga: { scope: null },
        mgb: { scope: null },
        mgc: { scope: null },
        mgd: { scope: null },
        mge: { scope: null },
        mgf: { scope: null },
        mgg: { scope: null },
        mgh: { scope: null },
        mgi: { scope: null },
        mgj: { scope: null },
        mgk: { scope: null },
        mgl: { scope: null },
        mgm: { scope: null },
        mgn: { scope: null },
        mgo: { scope: null },
        mgp: { scope: null },
        mgq: { scope: null },
        mgr: { scope: null },
        mgs: { scope: null },
        mgt: { scope: null },
        mgu: { scope: null },
        mgv: { scope: null },
        mgw: { scope: null },
        mgx: { scope: null },
        mgy: { scope: null },
        mgz: { scope: null },
        mha: { scope: null },
        mhb: { scope: null },
        mhc: { scope: null },
        mhd: { scope: null },
        mhe: { scope: null },
        mhf: { scope: null },
        mhg: { scope: null },
        mhh: { scope: null },
        mhi: { scope: null },
        mhj: { scope: null },
        mhk: { scope: null },
        mhl: { scope: null },
        mhm: { scope: null },
        mhn: { scope: null },
        mho: { scope: null },
        mhp: { scope: null },
        mhq: { scope: null },
        mhr: { scope: null },
        mhs: { scope: null },
        mht: { scope: null },
        mhu: { scope: null },
        mhw: { scope: null },
        mhx: { scope: null },
        mhy: { scope: null },
        mhz: { scope: null },
        mia: { scope: null },
        mib: { scope: null },
        mic: { scope: null },
        mid: { scope: null },
        mie: { scope: null },
        mif: { scope: null },
        mig: { scope: null },
        mih: { scope: null },
        mii: { scope: null },
        mij: { scope: null },
        mik: { scope: null },
        mil: { scope: null },
        mim: { scope: null },
        min: { scope: null },
        mio: { scope: null },
        mip: { scope: null },
        miq: { scope: null },
        mir: { scope: null },
        mis: { scope: "special" },
        mit: { scope: null },
        miu: { scope: null },
        miw: { scope: null },
        mix: { scope: null },
        miy: { scope: null },
        miz: { scope: null },
        mja: { scope: null },
        mjb: { scope: null },
        mjc: { scope: null },
        mjd: { scope: null },
        mje: { scope: null },
        mjg: { scope: null },
        mjh: { scope: null },
        mji: { scope: null },
        mjj: { scope: null },
        mjk: { scope: null },
        mjl: { scope: null },
        mjm: { scope: null },
        mjn: { scope: null },
        mjo: { scope: null },
        mjp: { scope: null },
        mjq: { scope: null },
        mjr: { scope: null },
        mjs: { scope: null },
        mjt: { scope: null },
        mju: { scope: null },
        mjv: { scope: null },
        mjw: { scope: null },
        mjx: { scope: null },
        mjy: { scope: null },
        mjz: { scope: null },
        mka: { scope: null },
        mkb: { scope: null },
        mkc: { scope: null },
        mke: { scope: null },
        mkf: { scope: null },
        mkg: { scope: null },
        mkh: { scope: "collection" },
        mki: { scope: null },
        mkj: { scope: null },
        mkk: { scope: null },
        mkl: { scope: null },
        mkm: { scope: null },
        mkn: { scope: null },
        mko: { scope: null },
        mkp: { scope: null },
        mkq: { scope: null },
        mkr: { scope: null },
        mks: { scope: null },
        mkt: { scope: null },
        mku: { scope: null },
        mkv: { scope: null },
        mkw: { scope: null },
        mkx: { scope: null },
        mky: { scope: null },
        mkz: { scope: null },
        mla: { scope: null },
        mlb: { scope: null },
        mlc: { scope: null },
        mld: { scope: null },
        mle: { scope: null },
        mlf: { scope: null },
        mlh: { scope: null },
        mli: { scope: null },
        mlj: { scope: null },
        mlk: { scope: null },
        mll: { scope: null },
        mlm: { scope: null },
        mln: { scope: null },
        mlo: { scope: null },
        mlp: { scope: null },
        mlq: { scope: null },
        mlr: { scope: null },
        mls: { scope: null },
        mlu: { scope: null },
        mlv: { scope: null },
        mlw: { scope: null },
        mlx: { scope: null },
        mlz: { scope: null },
        mma: { scope: null },
        mmb: { scope: null },
        mmc: { scope: null },
        mmd: { scope: null },
        mme: { scope: null },
        mmf: { scope: null },
        mmg: { scope: null },
        mmh: { scope: null },
        mmi: { scope: null },
        mmj: { scope: null },
        mmk: { scope: null },
        mml: { scope: null },
        mmm: { scope: null },
        mmn: { scope: null },
        mmo: { scope: null },
        mmp: { scope: null },
        mmq: { scope: null },
        mmr: { scope: null },
        mmt: { scope: null },
        mmu: { scope: null },
        mmv: { scope: null },
        mmw: { scope: null },
        mmx: { scope: null },
        mmy: { scope: null },
        mmz: { scope: null },
        mna: { scope: null },
        mnb: { scope: null },
        mnc: { scope: null },
        mnd: { scope: null },
        mne: { scope: null },
        mnf: { scope: null },
        mng: { scope: null },
        mnh: { scope: null },
        mni: { scope: null },
        mnj: { scope: null },
        mnk: { scope: null },
        mnl: { scope: null },
        mnm: { scope: null },
        mnn: { scope: null },
        mno: { scope: "collection" },
        mnp: { scope: null },
        mnq: { scope: null },
        mnr: { scope: null },
        mns: { scope: null },
        mnt: { scope: null },
        mnu: { scope: null },
        mnv: { scope: null },
        mnw: { scope: null },
        mnx: { scope: null },
        mny: { scope: null },
        mnz: { scope: null },
        moa: { scope: null },
        moc: { scope: null },
        mod: { scope: null },
        moe: { scope: null },
        mof: { scope: null },
        mog: { scope: null },
        moh: { scope: null },
        moi: { scope: null },
        moj: { scope: null },
        mok: { scope: null },
        mom: { scope: null },
        moo: { scope: null },
        mop: { scope: null },
        moq: { scope: null },
        mor: { scope: null },
        mos: { scope: null },
        mot: { scope: null },
        mou: { scope: null },
        mov: { scope: null },
        mow: { scope: null },
        mox: { scope: null },
        moy: { scope: null },
        moz: { scope: null },
        mpa: { scope: null },
        mpb: { scope: null },
        mpc: { scope: null },
        mpd: { scope: null },
        mpe: { scope: null },
        mpg: { scope: null },
        mph: { scope: null },
        mpi: { scope: null },
        mpj: { scope: null },
        mpk: { scope: null },
        mpl: { scope: null },
        mpm: { scope: null },
        mpn: { scope: null },
        mpo: { scope: null },
        mpp: { scope: null },
        mpq: { scope: null },
        mpr: { scope: null },
        mps: { scope: null },
        mpt: { scope: null },
        mpu: { scope: null },
        mpv: { scope: null },
        mpw: { scope: null },
        mpx: { scope: null },
        mpy: { scope: null },
        mpz: { scope: null },
        mqa: { scope: null },
        mqb: { scope: null },
        mqc: { scope: null },
        mqe: { scope: null },
        mqf: { scope: null },
        mqg: { scope: null },
        mqh: { scope: null },
        mqi: { scope: null },
        mqj: { scope: null },
        mqk: { scope: null },
        mql: { scope: null },
        mqm: { scope: null },
        mqn: { scope: null },
        mqo: { scope: null },
        mqp: { scope: null },
        mqq: { scope: null },
        mqr: { scope: null },
        mqs: { scope: null },
        mqt: { scope: null },
        mqu: { scope: null },
        mqv: { scope: null },
        mqw: { scope: null },
        mqx: { scope: null },
        mqy: { scope: null },
        mqz: { scope: null },
        mra: { scope: null },
        mrb: { scope: null },
        mrc: { scope: null },
        mrd: { scope: null },
        mre: { scope: null },
        mrf: { scope: null },
        mrg: { scope: null },
        mrh: { scope: null },
        mrj: { scope: null },
        mrk: { scope: null },
        mrl: { scope: null },
        mrm: { scope: null },
        mrn: { scope: null },
        mro: { scope: null },
        mrp: { scope: null },
        mrq: { scope: null },
        mrr: { scope: null },
        mrs: { scope: null },
        mrt: { scope: null },
        mru: { scope: null },
        mrv: { scope: null },
        mrw: { scope: null },
        mrx: { scope: null },
        mry: { scope: null },
        mrz: { scope: null },
        msb: { scope: null },
        msc: { scope: null },
        msd: { scope: null },
        mse: { scope: null },
        msf: { scope: null },
        msg: { scope: null },
        msh: { scope: null },
        msi: { scope: null },
        msj: { scope: null },
        msk: { scope: null },
        msl: { scope: null },
        msm: { scope: null },
        msn: { scope: null },
        mso: { scope: null },
        msp: { scope: null },
        msq: { scope: null },
        msr: { scope: null },
        mss: { scope: null },
        mst: { scope: null },
        msu: { scope: null },
        msv: { scope: null },
        msw: { scope: null },
        msx: { scope: null },
        msy: { scope: null },
        msz: { scope: null },
        mta: { scope: null },
        mtb: { scope: null },
        mtc: { scope: null },
        mtd: { scope: null },
        mte: { scope: null },
        mtf: { scope: null },
        mtg: { scope: null },
        mth: { scope: null },
        mti: { scope: null },
        mtj: { scope: null },
        mtk: { scope: null },
        mtl: { scope: null },
        mtm: { scope: null },
        mtn: { scope: null },
        mto: { scope: null },
        mtp: { scope: null },
        mtq: { scope: null },
        mtr: { scope: null },
        mts: { scope: null },
        mtt: { scope: null },
        mtu: { scope: null },
        mtv: { scope: null },
        mtw: { scope: null },
        mtx: { scope: null },
        mty: { scope: null },
        mua: { scope: null },
        mub: { scope: null },
        muc: { scope: null },
        mud: { scope: null },
        mue: { scope: null },
        mug: { scope: null },
        muh: { scope: null },
        mui: { scope: null },
        muj: { scope: null },
        muk: { scope: null },
        mul: { scope: "special" },
        mum: { scope: null },
        mun: { scope: "collection" },
        muo: { scope: null },
        mup: { scope: null },
        muq: { scope: null },
        mur: { scope: null },
        mus: { scope: null },
        mut: { scope: null },
        muu: { scope: null },
        muv: { scope: null },
        mux: { scope: null },
        muy: { scope: null },
        muz: { scope: null },
        mva: { scope: null },
        mvb: { scope: null },
        mvd: { scope: null },
        mve: { scope: null },
        mvf: { scope: null },
        mvg: { scope: null },
        mvh: { scope: null },
        mvi: { scope: null },
        mvk: { scope: null },
        mvl: { scope: null },
        mvm: { scope: null },
        mvn: { scope: null },
        mvo: { scope: null },
        mvp: { scope: null },
        mvq: { scope: null },
        mvr: { scope: null },
        mvs: { scope: null },
        mvt: { scope: null },
        mvu: { scope: null },
        mvv: { scope: null },
        mvw: { scope: null },
        mvx: { scope: null },
        mvy: { scope: null },
        mvz: { scope: null },
        mwa: { scope: null },
        mwb: { scope: null },
        mwc: { scope: null },
        mwd: { scope: null },
        mwe: { scope: null },
        mwf: { scope: null },
        mwg: { scope: null },
        mwh: { scope: null },
        mwi: { scope: null },
        mwj: { scope: null },
        mwk: { scope: null },
        mwl: { scope: null },
        mwm: { scope: null },
        mwn: { scope: null },
        mwo: { scope: null },
        mwp: { scope: null },
        mwq: { scope: null },
        mwr: { scope: "macrolanguage" },
        mws: { scope: null },
        mwt: { scope: null },
        mwu: { scope: null },
        mwv: { scope: null },
        mww: { scope: null },
        mwx: { scope: null },
        mwy: { scope: null },
        mwz: { scope: null },
        mxa: { scope: null },
        mxb: { scope: null },
        mxc: { scope: null },
        mxd: { scope: null },
        mxe: { scope: null },
        mxf: { scope: null },
        mxg: { scope: null },
        mxh: { scope: null },
        mxi: { scope: null },
        mxj: { scope: null },
        mxk: { scope: null },
        mxl: { scope: null },
        mxm: { scope: null },
        mxn: { scope: null },
        mxo: { scope: null },
        mxp: { scope: null },
        mxq: { scope: null },
        mxr: { scope: null },
        mxs: { scope: null },
        mxt: { scope: null },
        mxu: { scope: null },
        mxv: { scope: null },
        mxw: { scope: null },
        mxx: { scope: null },
        mxy: { scope: null },
        mxz: { scope: null },
        myb: { scope: null },
        myc: { scope: null },
        myd: { scope: null },
        mye: { scope: null },
        myf: { scope: null },
        myg: { scope: null },
        myh: { scope: null },
        myi: { scope: null },
        myj: { scope: null },
        myk: { scope: null },
        myl: { scope: null },
        mym: { scope: null },
        myn: { scope: "collection" },
        myo: { scope: null },
        myp: { scope: null },
        myq: { scope: null },
        myr: { scope: null },
        mys: { scope: null },
        myt: { scope: null },
        myu: { scope: null },
        myv: { scope: null },
        myw: { scope: null },
        myx: { scope: null },
        myy: { scope: null },
        myz: { scope: null },
        mza: { scope: null },
        mzb: { scope: null },
        mzc: { scope: null },
        mzd: { scope: null },
        mze: { scope: null },
        mzg: { scope: null },
        mzh: { scope: null },
        mzi: { scope: null },
        mzj: { scope: null },
        mzk: { scope: null },
        mzl: { scope: null },
        mzm: { scope: null },
        mzn: { scope: null },
        mzo: { scope: null },
        mzp: { scope: null },
        mzq: { scope: null },
        mzr: { scope: null },
        mzs: { scope: null },
        mzt: { scope: null },
        mzu: { scope: null },
        mzv: { scope: null },
        mzw: { scope: null },
        mzx: { scope: null },
        mzy: { scope: null },
        mzz: { scope: null },
        naa: { scope: null },
        nab: { scope: null },
        nac: { scope: null },
        nad: { scope: null },
        nae: { scope: null },
        naf: { scope: null },
        nag: { scope: null },
        nah: { scope: "collection" },
        nai: { scope: "collection" },
        naj: { scope: null },
        nak: { scope: null },
        nal: { scope: null },
        nam: { scope: null },
        nan: { scope: null },
        nao: { scope: null },
        nap: { scope: null },
        naq: { scope: null },
        nar: { scope: null },
        nas: { scope: null },
        nat: { scope: null },
        naw: { scope: null },
        nax: { scope: null },
        nay: { scope: null },
        naz: { scope: null },
        nba: { scope: null },
        nbb: { scope: null },
        nbc: { scope: null },
        nbd: { scope: null },
        nbe: { scope: null },
        nbf: { scope: null },
        nbg: { scope: null },
        nbh: { scope: null },
        nbi: { scope: null },
        nbj: { scope: null },
        nbk: { scope: null },
        nbm: { scope: null },
        nbn: { scope: null },
        nbo: { scope: null },
        nbp: { scope: null },
        nbq: { scope: null },
        nbr: { scope: null },
        nbs: { scope: null },
        nbt: { scope: null },
        nbu: { scope: null },
        nbv: { scope: null },
        nbw: { scope: null },
        nbx: { scope: null },
        nby: { scope: null },
        nca: { scope: null },
        ncb: { scope: null },
        ncc: { scope: null },
        ncd: { scope: null },
        nce: { scope: null },
        ncf: { scope: null },
        ncg: { scope: null },
        nch: { scope: null },
        nci: { scope: null },
        ncj: { scope: null },
        nck: { scope: null },
        ncl: { scope: null },
        ncm: { scope: null },
        ncn: { scope: null },
        nco: { scope: null },
        ncp: { scope: null },
        ncq: { scope: null },
        ncr: { scope: null },
        ncs: { scope: null },
        nct: { scope: null },
        ncu: { scope: null },
        ncx: { scope: null },
        ncz: { scope: null },
        nda: { scope: null },
        ndb: { scope: null },
        ndc: { scope: null },
        ndd: { scope: null },
        ndf: { scope: null },
        ndg: { scope: null },
        ndh: { scope: null },
        ndi: { scope: null },
        ndj: { scope: null },
        ndk: { scope: null },
        ndl: { scope: null },
        ndm: { scope: null },
        ndn: { scope: null },
        ndp: { scope: null },
        ndq: { scope: null },
        ndr: { scope: null },
        nds: { scope: null },
        ndt: { scope: null },
        ndu: { scope: null },
        ndv: { scope: null },
        ndw: { scope: null },
        ndx: { scope: null },
        ndy: { scope: null },
        ndz: { scope: null },
        nea: { scope: null },
        neb: { scope: null },
        nec: { scope: null },
        ned: { scope: null },
        nee: { scope: null },
        nef: { scope: null },
        neg: { scope: null },
        neh: { scope: null },
        nei: { scope: null },
        nej: { scope: null },
        nek: { scope: null },
        nem: { scope: null },
        nen: { scope: null },
        neo: { scope: null },
        neq: { scope: null },
        ner: { scope: null },
        nes: { scope: null },
        net: { scope: null },
        neu: { scope: null },
        nev: { scope: null },
        new: { scope: null },
        nex: { scope: null },
        ney: { scope: null },
        nez: { scope: null },
        nfa: { scope: null },
        nfd: { scope: null },
        nfl: { scope: null },
        nfr: { scope: null },
        nfu: { scope: null },
        nga: { scope: null },
        ngb: { scope: null },
        ngc: { scope: null },
        ngd: { scope: null },
        nge: { scope: null },
        ngf: { scope: "collection" },
        ngg: { scope: null },
        ngh: { scope: null },
        ngi: { scope: null },
        ngj: { scope: null },
        ngk: { scope: null },
        ngl: { scope: null },
        ngm: { scope: null },
        ngn: { scope: null },
        ngo: { scope: null },
        ngp: { scope: null },
        ngq: { scope: null },
        ngr: { scope: null },
        ngs: { scope: null },
        ngt: { scope: null },
        ngu: { scope: null },
        ngv: { scope: null },
        ngw: { scope: null },
        ngx: { scope: null },
        ngy: { scope: null },
        ngz: { scope: null },
        nha: { scope: null },
        nhb: { scope: null },
        nhc: { scope: null },
        nhd: { scope: null },
        nhe: { scope: null },
        nhf: { scope: null },
        nhg: { scope: null },
        nhh: { scope: null },
        nhi: { scope: null },
        nhk: { scope: null },
        nhm: { scope: null },
        nhn: { scope: null },
        nho: { scope: null },
        nhp: { scope: null },
        nhq: { scope: null },
        nhr: { scope: null },
        nht: { scope: null },
        nhu: { scope: null },
        nhv: { scope: null },
        nhw: { scope: null },
        nhx: { scope: null },
        nhy: { scope: null },
        nhz: { scope: null },
        nia: { scope: null },
        nib: { scope: null },
        nic: { scope: "collection" },
        nid: { scope: null },
        nie: { scope: null },
        nif: { scope: null },
        nig: { scope: null },
        nih: { scope: null },
        nii: { scope: null },
        nij: { scope: null },
        nik: { scope: null },
        nil: { scope: null },
        nim: { scope: null },
        nin: { scope: null },
        nio: { scope: null },
        niq: { scope: null },
        nir: { scope: null },
        nis: { scope: null },
        nit: { scope: null },
        niu: { scope: null },
        niv: { scope: null },
        niw: { scope: null },
        nix: { scope: null },
        niy: { scope: null },
        niz: { scope: null },
        nja: { scope: null },
        njb: { scope: null },
        njd: { scope: null },
        njh: { scope: null },
        nji: { scope: null },
        njj: { scope: null },
        njl: { scope: null },
        njm: { scope: null },
        njn: { scope: null },
        njo: { scope: null },
        njr: { scope: null },
        njs: { scope: null },
        njt: { scope: null },
        nju: { scope: null },
        njx: { scope: null },
        njy: { scope: null },
        njz: { scope: null },
        nka: { scope: null },
        nkb: { scope: null },
        nkc: { scope: null },
        nkd: { scope: null },
        nke: { scope: null },
        nkf: { scope: null },
        nkg: { scope: null },
        nkh: { scope: null },
        nki: { scope: null },
        nkj: { scope: null },
        nkk: { scope: null },
        nkm: { scope: null },
        nkn: { scope: null },
        nko: { scope: null },
        nkp: { scope: null },
        nkq: { scope: null },
        nkr: { scope: null },
        nks: { scope: null },
        nkt: { scope: null },
        nku: { scope: null },
        nkv: { scope: null },
        nkw: { scope: null },
        nkx: { scope: null },
        nkz: { scope: null },
        nla: { scope: null },
        nlc: { scope: null },
        nle: { scope: null },
        nlg: { scope: null },
        nli: { scope: null },
        nlj: { scope: null },
        nlk: { scope: null },
        nll: { scope: null },
        nlm: { scope: null },
        nln: { scope: null },
        nlo: { scope: null },
        nlq: { scope: null },
        nlr: { scope: null },
        nlu: { scope: null },
        nlv: { scope: null },
        nlw: { scope: null },
        nlx: { scope: null },
        nly: { scope: null },
        nlz: { scope: null },
        nma: { scope: null },
        nmb: { scope: null },
        nmc: { scope: null },
        nmd: { scope: null },
        nme: { scope: null },
        nmf: { scope: null },
        nmg: { scope: null },
        nmh: { scope: null },
        nmi: { scope: null },
        nmj: { scope: null },
        nmk: { scope: null },
        nml: { scope: null },
        nmm: { scope: null },
        nmn: { scope: null },
        nmo: { scope: null },
        nmp: { scope: null },
        nmq: { scope: null },
        nmr: { scope: null },
        nms: { scope: null },
        nmt: { scope: null },
        nmu: { scope: null },
        nmv: { scope: null },
        nmw: { scope: null },
        nmx: { scope: null },
        nmy: { scope: null },
        nmz: { scope: null },
        nna: { scope: null },
        nnb: { scope: null },
        nnc: { scope: null },
        nnd: { scope: null },
        nne: { scope: null },
        nnf: { scope: null },
        nng: { scope: null },
        nnh: { scope: null },
        nni: { scope: null },
        nnj: { scope: null },
        nnk: { scope: null },
        nnl: { scope: null },
        nnm: { scope: null },
        nnn: { scope: null },
        nnp: { scope: null },
        nnq: { scope: null },
        nnr: { scope: null },
        nns: { scope: null },
        nnt: { scope: null },
        nnu: { scope: null },
        nnv: { scope: null },
        nnw: { scope: null },
        nnx: { scope: null },
        nny: { scope: null },
        nnz: { scope: null },
        noa: { scope: null },
        noc: { scope: null },
        nod: { scope: null },
        noe: { scope: null },
        nof: { scope: null },
        nog: { scope: null },
        noh: { scope: null },
        noi: { scope: null },
        noj: { scope: null },
        nok: { scope: null },
        nol: { scope: null },
        nom: { scope: null },
        non: { scope: null },
        noo: { scope: null },
        nop: { scope: null },
        noq: { scope: null },
        nos: { scope: null },
        not: { scope: null },
        nou: { scope: null },
        nov: { scope: null },
        now: { scope: null },
        noy: { scope: null },
        noz: { scope: null },
        npa: { scope: null },
        npb: { scope: null },
        npg: { scope: null },
        nph: { scope: null },
        npi: { scope: null },
        npl: { scope: null },
        npn: { scope: null },
        npo: { scope: null },
        nps: { scope: null },
        npu: { scope: null },
        npx: { scope: null },
        npy: { scope: null },
        nqg: { scope: null },
        nqk: { scope: null },
        nql: { scope: null },
        nqm: { scope: null },
        nqn: { scope: null },
        nqo: { scope: null },
        nqq: { scope: null },
        nqt: { scope: null },
        nqy: { scope: null },
        nra: { scope: null },
        nrb: { scope: null },
        nrc: { scope: null },
        nre: { scope: null },
        nrf: { scope: null },
        nrg: { scope: null },
        nri: { scope: null },
        nrk: { scope: null },
        nrl: { scope: null },
        nrm: { scope: null },
        nrn: { scope: null },
        nrp: { scope: null },
        nrr: { scope: null },
        nrt: { scope: null },
        nru: { scope: null },
        nrx: { scope: null },
        nrz: { scope: null },
        nsa: { scope: null },
        nsb: { scope: null },
        nsc: { scope: null },
        nsd: { scope: null },
        nse: { scope: null },
        nsf: { scope: null },
        nsg: { scope: null },
        nsh: { scope: null },
        nsi: { scope: null },
        nsk: { scope: null },
        nsl: { scope: null },
        nsm: { scope: null },
        nsn: { scope: null },
        nso: { scope: null },
        nsp: { scope: null },
        nsq: { scope: null },
        nsr: { scope: null },
        nss: { scope: null },
        nst: { scope: null },
        nsu: { scope: null },
        nsv: { scope: null },
        nsw: { scope: null },
        nsx: { scope: null },
        nsy: { scope: null },
        nsz: { scope: null },
        ntd: { scope: null },
        nte: { scope: null },
        ntg: { scope: null },
        nti: { scope: null },
        ntj: { scope: null },
        ntk: { scope: null },
        ntm: { scope: null },
        nto: { scope: null },
        ntp: { scope: null },
        ntr: { scope: null },
        nts: { scope: null },
        ntu: { scope: null },
        ntw: { scope: null },
        ntx: { scope: null },
        nty: { scope: null },
        ntz: { scope: null },
        nua: { scope: null },
        nub: { scope: "collection" },
        nuc: { scope: null },
        nud: { scope: null },
        nue: { scope: null },
        nuf: { scope: null },
        nug: { scope: null },
        nuh: { scope: null },
        nui: { scope: null },
        nuj: { scope: null },
        nuk: { scope: null },
        nul: { scope: null },
        num: { scope: null },
        nun: { scope: null },
        nuo: { scope: null },
        nup: { scope: null },
        nuq: { scope: null },
        nur: { scope: null },
        nus: { scope: null },
        nut: { scope: null },
        nuu: { scope: null },
        nuv: { scope: null },
        nuw: { scope: null },
        nux: { scope: null },
        nuy: { scope: null },
        nuz: { scope: null },
        nvh: { scope: null },
        nvm: { scope: null },
        nvo: { scope: null },
        nwa: { scope: null },
        nwb: { scope: null },
        nwc: { scope: null },
        nwe: { scope: null },
        nwg: { scope: null },
        nwi: { scope: null },
        nwm: { scope: null },
        nwo: { scope: null },
        nwr: { scope: null },
        nwx: { scope: null },
        nwy: { scope: null },
        nxa: { scope: null },
        nxd: { scope: null },
        nxe: { scope: null },
        nxg: { scope: null },
        nxi: { scope: null },
        nxk: { scope: null },
        nxl: { scope: null },
        nxm: { scope: null },
        nxn: { scope: null },
        nxo: { scope: null },
        nxq: { scope: null },
        nxr: { scope: null },
        nxu: { scope: null },
        nxx: { scope: null },
        nyb: { scope: null },
        nyc: { scope: null },
        nyd: { scope: null },
        nye: { scope: null },
        nyf: { scope: null },
        nyg: { scope: null },
        nyh: { scope: null },
        nyi: { scope: null },
        nyj: { scope: null },
        nyk: { scope: null },
        nyl: { scope: null },
        nym: { scope: null },
        nyn: { scope: null },
        nyo: { scope: null },
        nyp: { scope: null },
        nyq: { scope: null },
        nyr: { scope: null },
        nys: { scope: null },
        nyt: { scope: null },
        nyu: { scope: null },
        nyv: { scope: null },
        nyw: { scope: null },
        nyx: { scope: null },
        nyy: { scope: null },
        nza: { scope: null },
        nzb: { scope: null },
        nzd: { scope: null },
        nzi: { scope: null },
        nzk: { scope: null },
        nzm: { scope: null },
        nzs: { scope: null },
        nzu: { scope: null },
        nzy: { scope: null },
        nzz: { scope: null },
        oaa: { scope: null },
        oac: { scope: null },
        oar: { scope: null },
        oav: { scope: null },
        obi: { scope: null },
        obk: { scope: null },
        obl: { scope: null },
        obm: { scope: null },
        obo: { scope: null },
        obr: { scope: null },
        obt: { scope: null },
        obu: { scope: null },
        oca: { scope: null },
        och: { scope: null },
        ocm: { scope: null },
        oco: { scope: null },
        ocu: { scope: null },
        oda: { scope: null },
        odk: { scope: null },
        odt: { scope: null },
        odu: { scope: null },
        ofo: { scope: null },
        ofs: { scope: null },
        ofu: { scope: null },
        ogb: { scope: null },
        ogc: { scope: null },
        oge: { scope: null },
        ogg: { scope: null },
        ogo: { scope: null },
        ogu: { scope: null },
        oht: { scope: null },
        ohu: { scope: null },
        oia: { scope: null },
        oin: { scope: null },
        ojb: { scope: null },
        ojc: { scope: null },
        ojg: { scope: null },
        ojp: { scope: null },
        ojs: { scope: null },
        ojv: { scope: null },
        ojw: { scope: null },
        oka: { scope: null },
        okb: { scope: null },
        okc: { scope: null },
        okd: { scope: null },
        oke: { scope: null },
        okg: { scope: null },
        okh: { scope: null },
        oki: { scope: null },
        okj: { scope: null },
        okk: { scope: null },
        okl: { scope: null },
        okm: { scope: null },
        okn: { scope: null },
        oko: { scope: null },
        okr: { scope: null },
        oks: { scope: null },
        oku: { scope: null },
        okv: { scope: null },
        okx: { scope: null },
        okz: { scope: null },
        ola: { scope: null },
        old: { scope: null },
        ole: { scope: null },
        olk: { scope: null },
        olm: { scope: null },
        olo: { scope: null },
        olr: { scope: null },
        olt: { scope: null },
        olu: { scope: null },
        oma: { scope: null },
        omb: { scope: null },
        omc: { scope: null },
        ome: { scope: null },
        omg: { scope: null },
        omi: { scope: null },
        omk: { scope: null },
        oml: { scope: null },
        omn: { scope: null },
        omo: { scope: null },
        omp: { scope: null },
        omq: { scope: "collection" },
        omr: { scope: null },
        omt: { scope: null },
        omu: { scope: null },
        omv: { scope: "collection" },
        omw: { scope: null },
        omx: { scope: null },
        omy: { scope: null },
        ona: { scope: null },
        onb: { scope: null },
        one: { scope: null },
        ong: { scope: null },
        oni: { scope: null },
        onj: { scope: null },
        onk: { scope: null },
        onn: { scope: null },
        ono: { scope: null },
        onp: { scope: null },
        onr: { scope: null },
        ons: { scope: null },
        ont: { scope: null },
        onu: { scope: null },
        onw: { scope: null },
        onx: { scope: null },
        ood: { scope: null },
        oog: { scope: null },
        oon: { scope: null },
        oor: { scope: null },
        oos: { scope: null },
        opa: { scope: null },
        opk: { scope: null },
        opm: { scope: null },
        opo: { scope: null },
        opt: { scope: null },
        opy: { scope: null },
        ora: { scope: null },
        orc: { scope: null },
        ore: { scope: null },
        org: { scope: null },
        orh: { scope: null },
        orn: { scope: null },
        oro: { scope: null },
        orr: { scope: null },
        ors: { scope: null },
        ort: { scope: null },
        oru: { scope: null },
        orv: { scope: null },
        orw: { scope: null },
        orx: { scope: null },
        ory: { scope: null },
        orz: { scope: null },
        osa: { scope: null },
        osc: { scope: null },
        osi: { scope: null },
        osn: { scope: null },
        oso: { scope: null },
        osp: { scope: null },
        ost: { scope: null },
        osu: { scope: null },
        osx: { scope: null },
        ota: { scope: null },
        otb: { scope: null },
        otd: { scope: null },
        ote: { scope: null },
        oti: { scope: null },
        otk: { scope: null },
        otl: { scope: null },
        otm: { scope: null },
        otn: { scope: null },
        oto: { scope: "collection" },
        otq: { scope: null },
        otr: { scope: null },
        ots: { scope: null },
        ott: { scope: null },
        otu: { scope: null },
        otw: { scope: null },
        otx: { scope: null },
        oty: { scope: null },
        otz: { scope: null },
        oua: { scope: null },
        oub: { scope: null },
        oue: { scope: null },
        oui: { scope: null },
        oum: { scope: null },
        oun: { scope: null },
        ovd: { scope: null },
        owi: { scope: null },
        owl: { scope: null },
        oyb: { scope: null },
        oyd: { scope: null },
        oym: { scope: null },
        oyy: { scope: null },
        ozm: { scope: null },
        paa: { scope: "collection" },
        pab: { scope: null },
        pac: { scope: null },
        pad: { scope: null },
        pae: { scope: null },
        paf: { scope: null },
        pag: { scope: null },
        pah: { scope: null },
        pai: { scope: null },
        pak: { scope: null },
        pal: { scope: null },
        pam: { scope: null },
        pao: { scope: null },
        pap: { scope: null },
        paq: { scope: null },
        par: { scope: null },
        pas: { scope: null },
        pat: { scope: null },
        pau: { scope: null },
        pav: { scope: null },
        paw: { scope: null },
        pax: { scope: null },
        pay: { scope: null },
        paz: { scope: null },
        pbb: { scope: null },
        pbc: { scope: null },
        pbe: { scope: null },
        pbf: { scope: null },
        pbg: { scope: null },
        pbh: { scope: null },
        pbi: { scope: null },
        pbl: { scope: null },
        pbm: { scope: null },
        pbn: { scope: null },
        pbo: { scope: null },
        pbp: { scope: null },
        pbr: { scope: null },
        pbs: { scope: null },
        pbt: { scope: null },
        pbu: { scope: null },
        pbv: { scope: null },
        pby: { scope: null },
        pbz: { scope: null },
        pca: { scope: null },
        pcb: { scope: null },
        pcc: { scope: null },
        pcd: { scope: null },
        pce: { scope: null },
        pcf: { scope: null },
        pcg: { scope: null },
        pch: { scope: null },
        pci: { scope: null },
        pcj: { scope: null },
        pck: { scope: null },
        pcl: { scope: null },
        pcm: { scope: null },
        pcn: { scope: null },
        pcp: { scope: null },
        pcr: { scope: null },
        pcw: { scope: null },
        pda: { scope: null },
        pdc: { scope: null },
        pdi: { scope: null },
        pdn: { scope: null },
        pdo: { scope: null },
        pdt: { scope: null },
        pdu: { scope: null },
        pea: { scope: null },
        peb: { scope: null },
        ped: { scope: null },
        pee: { scope: null },
        pef: { scope: null },
        peg: { scope: null },
        peh: { scope: null },
        pei: { scope: null },
        pej: { scope: null },
        pek: { scope: null },
        pel: { scope: null },
        pem: { scope: null },
        peo: { scope: null },
        pep: { scope: null },
        peq: { scope: null },
        pes: { scope: null },
        pev: { scope: null },
        pex: { scope: null },
        pey: { scope: null },
        pez: { scope: null },
        pfa: { scope: null },
        pfe: { scope: null },
        pfl: { scope: null },
        pga: { scope: null },
        pgd: { scope: null },
        pgg: { scope: null },
        pgi: { scope: null },
        pgk: { scope: null },
        pgl: { scope: null },
        pgn: { scope: null },
        pgs: { scope: null },
        pgu: { scope: null },
        pgy: { scope: null },
        pgz: { scope: null },
        pha: { scope: null },
        phd: { scope: null },
        phg: { scope: null },
        phh: { scope: null },
        phi: { scope: "collection" },
        phk: { scope: null },
        phl: { scope: null },
        phm: { scope: null },
        phn: { scope: null },
        pho: { scope: null },
        phq: { scope: null },
        phr: { scope: null },
        pht: { scope: null },
        phu: { scope: null },
        phv: { scope: null },
        phw: { scope: null },
        pia: { scope: null },
        pib: { scope: null },
        pic: { scope: null },
        pid: { scope: null },
        pie: { scope: null },
        pif: { scope: null },
        pig: { scope: null },
        pih: { scope: null },
        pii: { scope: null },
        pij: { scope: null },
        pil: { scope: null },
        pim: { scope: null },
        pin: { scope: null },
        pio: { scope: null },
        pip: { scope: null },
        pir: { scope: null },
        pis: { scope: null },
        pit: { scope: null },
        piu: { scope: null },
        piv: { scope: null },
        piw: { scope: null },
        pix: { scope: null },
        piy: { scope: null },
        piz: { scope: null },
        pjt: { scope: null },
        pka: { scope: null },
        pkb: { scope: null },
        pkc: { scope: null },
        pkg: { scope: null },
        pkh: { scope: null },
        pkn: { scope: null },
        pko: { scope: null },
        pkp: { scope: null },
        pkr: { scope: null },
        pks: { scope: null },
        pkt: { scope: null },
        pku: { scope: null },
        pla: { scope: null },
        plb: { scope: null },
        plc: { scope: null },
        pld: { scope: null },
        ple: { scope: null },
        plf: { scope: "collection" },
        plg: { scope: null },
        plh: { scope: null },
        plj: { scope: null },
        plk: { scope: null },
        pll: { scope: null },
        pln: { scope: null },
        plo: { scope: null },
        plp: { scope: null },
        plq: { scope: null },
        plr: { scope: null },
        pls: { scope: null },
        plt: { scope: null },
        plu: { scope: null },
        plv: { scope: null },
        plw: { scope: null },
        ply: { scope: null },
        plz: { scope: null },
        pma: { scope: null },
        pmb: { scope: null },
        pmc: { scope: null },
        pmd: { scope: null },
        pme: { scope: null },
        pmf: { scope: null },
        pmh: { scope: null },
        pmi: { scope: null },
        pmj: { scope: null },
        pmk: { scope: null },
        pml: { scope: null },
        pmm: { scope: null },
        pmn: { scope: null },
        pmo: { scope: null },
        pmq: { scope: null },
        pmr: { scope: null },
        pms: { scope: null },
        pmt: { scope: null },
        pmu: { scope: null },
        pmw: { scope: null },
        pmx: { scope: null },
        pmy: { scope: null },
        pmz: { scope: null },
        pna: { scope: null },
        pnb: { scope: null },
        pnc: { scope: null },
        pnd: { scope: null },
        pne: { scope: null },
        png: { scope: null },
        pnh: { scope: null },
        pni: { scope: null },
        pnj: { scope: null },
        pnk: { scope: null },
        pnl: { scope: null },
        pnm: { scope: null },
        pnn: { scope: null },
        pno: { scope: null },
        pnp: { scope: null },
        pnq: { scope: null },
        pnr: { scope: null },
        pns: { scope: null },
        pnt: { scope: null },
        pnu: { scope: null },
        pnv: { scope: null },
        pnw: { scope: null },
        pnx: { scope: null },
        pny: { scope: null },
        pnz: { scope: null },
        poc: { scope: null },
        pod: { scope: null },
        poe: { scope: null },
        pof: { scope: null },
        pog: { scope: null },
        poh: { scope: null },
        poi: { scope: null },
        pok: { scope: null },
        pom: { scope: null },
        pon: { scope: null },
        poo: { scope: null },
        pop: { scope: null },
        poq: { scope: null },
        pos: { scope: null },
        pot: { scope: null },
        pov: { scope: null },
        pow: { scope: null },
        pox: { scope: null },
        poy: { scope: null },
        poz: { scope: "collection" },
        ppa: { scope: null },
        ppe: { scope: null },
        ppi: { scope: null },
        ppk: { scope: null },
        ppl: { scope: null },
        ppm: { scope: null },
        ppn: { scope: null },
        ppo: { scope: null },
        ppp: { scope: null },
        ppq: { scope: null },
        ppr: { scope: null },
        pps: { scope: null },
        ppt: { scope: null },
        ppu: { scope: null },
        pqa: { scope: null },
        pqe: { scope: "collection" },
        pqm: { scope: null },
        pqw: { scope: "collection" },
        pra: { scope: "collection" },
        prb: { scope: null },
        prc: { scope: null },
        prd: { scope: null },
        pre: { scope: null },
        prf: { scope: null },
        prg: { scope: null },
        prh: { scope: null },
        pri: { scope: null },
        prk: { scope: null },
        prl: { scope: null },
        prm: { scope: null },
        prn: { scope: null },
        pro: { scope: null },
        prp: { scope: null },
        prq: { scope: null },
        prr: { scope: null },
        prs: { scope: null },
        prt: { scope: null },
        pru: { scope: null },
        prw: { scope: null },
        prx: { scope: null },
        pry: { scope: null },
        prz: { scope: null },
        psa: { scope: null },
        psc: { scope: null },
        psd: { scope: null },
        pse: { scope: null },
        psg: { scope: null },
        psh: { scope: null },
        psi: { scope: null },
        psl: { scope: null },
        psm: { scope: null },
        psn: { scope: null },
        pso: { scope: null },
        psp: { scope: null },
        psq: { scope: null },
        psr: { scope: null },
        pss: { scope: null },
        pst: { scope: null },
        psu: { scope: null },
        psw: { scope: null },
        psy: { scope: null },
        pta: { scope: null },
        pth: { scope: null },
        pti: { scope: null },
        ptn: { scope: null },
        pto: { scope: null },
        ptp: { scope: null },
        ptq: { scope: null },
        ptr: { scope: null },
        ptt: { scope: null },
        ptu: { scope: null },
        ptv: { scope: null },
        ptw: { scope: null },
        pty: { scope: null },
        pua: { scope: null },
        pub: { scope: null },
        puc: { scope: null },
        pud: { scope: null },
        pue: { scope: null },
        puf: { scope: null },
        pug: { scope: null },
        pui: { scope: null },
        puj: { scope: null },
        puk: { scope: null },
        pum: { scope: null },
        puo: { scope: null },
        pup: { scope: null },
        puq: { scope: null },
        pur: { scope: null },
        put: { scope: null },
        puu: { scope: null },
        puw: { scope: null },
        pux: { scope: null },
        puy: { scope: null },
        puz: { scope: null },
        pwa: { scope: null },
        pwb: { scope: null },
        pwg: { scope: null },
        pwi: { scope: null },
        pwm: { scope: null },
        pwn: { scope: null },
        pwo: { scope: null },
        pwr: { scope: null },
        pww: { scope: null },
        pxm: { scope: null },
        pye: { scope: null },
        pym: { scope: null },
        pyn: { scope: null },
        pys: { scope: null },
        pyu: { scope: null },
        pyx: { scope: null },
        pyy: { scope: null },
        pzn: { scope: null },
        qaa: { scope: "private-use" },
        qab: { scope: "private-use" },
        qac: { scope: "private-use" },
        qad: { scope: "private-use" },
        qae: { scope: "private-use" },
        qaf: { scope: "private-use" },
        qag: { scope: "private-use" },
        qah: { scope: "private-use" },
        qai: { scope: "private-use" },
        qaj: { scope: "private-use" },
        qak: { scope: "private-use" },
        qal: { scope: "private-use" },
        qam: { scope: "private-use" },
        qan: { scope: "private-use" },
        qao: { scope: "private-use" },
        qap: { scope: "private-use" },
        qaq: { scope: "private-use" },
        qar: { scope: "private-use" },
        qas: { scope: "private-use" },
        qat: { scope: "private-use" },
        qau: { scope: "private-use" },
        qav: { scope: "private-use" },
        qaw: { scope: "private-use" },
        qax: { scope: "private-use" },
        qay: { scope: "private-use" },
        qaz: { scope: "private-use" },
        qba: { scope: "private-use" },
        qbb: { scope: "private-use" },
        qbc: { scope: "private-use" },
        qbd: { scope: "private-use" },
        qbe: { scope: "private-use" },
        qbf: { scope: "private-use" },
        qbg: { scope: "private-use" },
        qbh: { scope: "private-use" },
        qbi: { scope: "private-use" },
        qbj: { scope: "private-use" },
        qbk: { scope: "private-use" },
        qbl: { scope: "private-use" },
        qbm: { scope: "private-use" },
        qbn: { scope: "private-use" },
        qbo: { scope: "private-use" },
        qbp: { scope: "private-use" },
        qbq: { scope: "private-use" },
        qbr: { scope: "private-use" },
        qbs: { scope: "private-use" },
        qbt: { scope: "private-use" },
        qbu: { scope: "private-use" },
        qbv: { scope: "private-use" },
        qbw: { scope: "private-use" },
        qbx: { scope: "private-use" },
        qby: { scope: "private-use" },
        qbz: { scope: "private-use" },
        qca: { scope: "private-use" },
        qcb: { scope: "private-use" },
        qcc: { scope: "private-use" },
        qcd: { scope: "private-use" },
        qce: { scope: "private-use" },
        qcf: { scope: "private-use" },
        qcg: { scope: "private-use" },
        qch: { scope: "private-use" },
        qci: { scope: "private-use" },
        qcj: { scope: "private-use" },
        qck: { scope: "private-use" },
        qcl: { scope: "private-use" },
        qcm: { scope: "private-use" },
        qcn: { scope: "private-use" },
        qco: { scope: "private-use" },
        qcp: { scope: "private-use" },
        qcq: { scope: "private-use" },
        qcr: { scope: "private-use" },
        qcs: { scope: "private-use" },
        qct: { scope: "private-use" },
        qcu: { scope: "private-use" },
        qcv: { scope: "private-use" },
        qcw: { scope: "private-use" },
        qcx: { scope: "private-use" },
        qcy: { scope: "private-use" },
        qcz: { scope: "private-use" },
        qda: { scope: "private-use" },
        qdb: { scope: "private-use" },
        qdc: { scope: "private-use" },
        qdd: { scope: "private-use" },
        qde: { scope: "private-use" },
        qdf: { scope: "private-use" },
        qdg: { scope: "private-use" },
        qdh: { scope: "private-use" },
        qdi: { scope: "private-use" },
        qdj: { scope: "private-use" },
        qdk: { scope: "private-use" },
        qdl: { scope: "private-use" },
        qdm: { scope: "private-use" },
        qdn: { scope: "private-use" },
        qdo: { scope: "private-use" },
        qdp: { scope: "private-use" },
        qdq: { scope: "private-use" },
        qdr: { scope: "private-use" },
        qds: { scope: "private-use" },
        qdt: { scope: "private-use" },
        qdu: { scope: "private-use" },
        qdv: { scope: "private-use" },
        qdw: { scope: "private-use" },
        qdx: { scope: "private-use" },
        qdy: { scope: "private-use" },
        qdz: { scope: "private-use" },
        qea: { scope: "private-use" },
        qeb: { scope: "private-use" },
        qec: { scope: "private-use" },
        qed: { scope: "private-use" },
        qee: { scope: "private-use" },
        qef: { scope: "private-use" },
        qeg: { scope: "private-use" },
        qeh: { scope: "private-use" },
        qei: { scope: "private-use" },
        qej: { scope: "private-use" },
        qek: { scope: "private-use" },
        qel: { scope: "private-use" },
        qem: { scope: "private-use" },
        qen: { scope: "private-use" },
        qeo: { scope: "private-use" },
        qep: { scope: "private-use" },
        qeq: { scope: "private-use" },
        qer: { scope: "private-use" },
        qes: { scope: "private-use" },
        qet: { scope: "private-use" },
        qeu: { scope: "private-use" },
        qev: { scope: "private-use" },
        qew: { scope: "private-use" },
        qex: { scope: "private-use" },
        qey: { scope: "private-use" },
        qez: { scope: "private-use" },
        qfa: { scope: "private-use" },
        qfb: { scope: "private-use" },
        qfc: { scope: "private-use" },
        qfd: { scope: "private-use" },
        qfe: { scope: "private-use" },
        qff: { scope: "private-use" },
        qfg: { scope: "private-use" },
        qfh: { scope: "private-use" },
        qfi: { scope: "private-use" },
        qfj: { scope: "private-use" },
        qfk: { scope: "private-use" },
        qfl: { scope: "private-use" },
        qfm: { scope: "private-use" },
        qfn: { scope: "private-use" },
        qfo: { scope: "private-use" },
        qfp: { scope: "private-use" },
        qfq: { scope: "private-use" },
        qfr: { scope: "private-use" },
        qfs: { scope: "private-use" },
        qft: { scope: "private-use" },
        qfu: { scope: "private-use" },
        qfv: { scope: "private-use" },
        qfw: { scope: "private-use" },
        qfx: { scope: "private-use" },
        qfy: { scope: "private-use" },
        qfz: { scope: "private-use" },
        qga: { scope: "private-use" },
        qgb: { scope: "private-use" },
        qgc: { scope: "private-use" },
        qgd: { scope: "private-use" },
        qge: { scope: "private-use" },
        qgf: { scope: "private-use" },
        qgg: { scope: "private-use" },
        qgh: { scope: "private-use" },
        qgi: { scope: "private-use" },
        qgj: { scope: "private-use" },
        qgk: { scope: "private-use" },
        qgl: { scope: "private-use" },
        qgm: { scope: "private-use" },
        qgn: { scope: "private-use" },
        qgo: { scope: "private-use" },
        qgp: { scope: "private-use" },
        qgq: { scope: "private-use" },
        qgr: { scope: "private-use" },
        qgs: { scope: "private-use" },
        qgt: { scope: "private-use" },
        qgu: { scope: "private-use" },
        qgv: { scope: "private-use" },
        qgw: { scope: "private-use" },
        qgx: { scope: "private-use" },
        qgy: { scope: "private-use" },
        qgz: { scope: "private-use" },
        qha: { scope: "private-use" },
        qhb: { scope: "private-use" },
        qhc: { scope: "private-use" },
        qhd: { scope: "private-use" },
        qhe: { scope: "private-use" },
        qhf: { scope: "private-use" },
        qhg: { scope: "private-use" },
        qhh: { scope: "private-use" },
        qhi: { scope: "private-use" },
        qhj: { scope: "private-use" },
        qhk: { scope: "private-use" },
        qhl: { scope: "private-use" },
        qhm: { scope: "private-use" },
        qhn: { scope: "private-use" },
        qho: { scope: "private-use" },
        qhp: { scope: "private-use" },
        qhq: { scope: "private-use" },
        qhr: { scope: "private-use" },
        qhs: { scope: "private-use" },
        qht: { scope: "private-use" },
        qhu: { scope: "private-use" },
        qhv: { scope: "private-use" },
        qhw: { scope: "private-use" },
        qhx: { scope: "private-use" },
        qhy: { scope: "private-use" },
        qhz: { scope: "private-use" },
        qia: { scope: "private-use" },
        qib: { scope: "private-use" },
        qic: { scope: "private-use" },
        qid: { scope: "private-use" },
        qie: { scope: "private-use" },
        qif: { scope: "private-use" },
        qig: { scope: "private-use" },
        qih: { scope: "private-use" },
        qii: { scope: "private-use" },
        qij: { scope: "private-use" },
        qik: { scope: "private-use" },
        qil: { scope: "private-use" },
        qim: { scope: "private-use" },
        qin: { scope: "private-use" },
        qio: { scope: "private-use" },
        qip: { scope: "private-use" },
        qiq: { scope: "private-use" },
        qir: { scope: "private-use" },
        qis: { scope: "private-use" },
        qit: { scope: "private-use" },
        qiu: { scope: "private-use" },
        qiv: { scope: "private-use" },
        qiw: { scope: "private-use" },
        qix: { scope: "private-use" },
        qiy: { scope: "private-use" },
        qiz: { scope: "private-use" },
        qja: { scope: "private-use" },
        qjb: { scope: "private-use" },
        qjc: { scope: "private-use" },
        qjd: { scope: "private-use" },
        qje: { scope: "private-use" },
        qjf: { scope: "private-use" },
        qjg: { scope: "private-use" },
        qjh: { scope: "private-use" },
        qji: { scope: "private-use" },
        qjj: { scope: "private-use" },
        qjk: { scope: "private-use" },
        qjl: { scope: "private-use" },
        qjm: { scope: "private-use" },
        qjn: { scope: "private-use" },
        qjo: { scope: "private-use" },
        qjp: { scope: "private-use" },
        qjq: { scope: "private-use" },
        qjr: { scope: "private-use" },
        qjs: { scope: "private-use" },
        qjt: { scope: "private-use" },
        qju: { scope: "private-use" },
        qjv: { scope: "private-use" },
        qjw: { scope: "private-use" },
        qjx: { scope: "private-use" },
        qjy: { scope: "private-use" },
        qjz: { scope: "private-use" },
        qka: { scope: "private-use" },
        qkb: { scope: "private-use" },
        qkc: { scope: "private-use" },
        qkd: { scope: "private-use" },
        qke: { scope: "private-use" },
        qkf: { scope: "private-use" },
        qkg: { scope: "private-use" },
        qkh: { scope: "private-use" },
        qki: { scope: "private-use" },
        qkj: { scope: "private-use" },
        qkk: { scope: "private-use" },
        qkl: { scope: "private-use" },
        qkm: { scope: "private-use" },
        qkn: { scope: "private-use" },
        qko: { scope: "private-use" },
        qkp: { scope: "private-use" },
        qkq: { scope: "private-use" },
        qkr: { scope: "private-use" },
        qks: { scope: "private-use" },
        qkt: { scope: "private-use" },
        qku: { scope: "private-use" },
        qkv: { scope: "private-use" },
        qkw: { scope: "private-use" },
        qkx: { scope: "private-use" },
        qky: { scope: "private-use" },
        qkz: { scope: "private-use" },
        qla: { scope: "private-use" },
        qlb: { scope: "private-use" },
        qlc: { scope: "private-use" },
        qld: { scope: "private-use" },
        qle: { scope: "private-use" },
        qlf: { scope: "private-use" },
        qlg: { scope: "private-use" },
        qlh: { scope: "private-use" },
        qli: { scope: "private-use" },
        qlj: { scope: "private-use" },
        qlk: { scope: "private-use" },
        qll: { scope: "private-use" },
        qlm: { scope: "private-use" },
        qln: { scope: "private-use" },
        qlo: { scope: "private-use" },
        qlp: { scope: "private-use" },
        qlq: { scope: "private-use" },
        qlr: { scope: "private-use" },
        qls: { scope: "private-use" },
        qlt: { scope: "private-use" },
        qlu: { scope: "private-use" },
        qlv: { scope: "private-use" },
        qlw: { scope: "private-use" },
        qlx: { scope: "private-use" },
        qly: { scope: "private-use" },
        qlz: { scope: "private-use" },
        qma: { scope: "private-use" },
        qmb: { scope: "private-use" },
        qmc: { scope: "private-use" },
        qmd: { scope: "private-use" },
        qme: { scope: "private-use" },
        qmf: { scope: "private-use" },
        qmg: { scope: "private-use" },
        qmh: { scope: "private-use" },
        qmi: { scope: "private-use" },
        qmj: { scope: "private-use" },
        qmk: { scope: "private-use" },
        qml: { scope: "private-use" },
        qmm: { scope: "private-use" },
        qmn: { scope: "private-use" },
        qmo: { scope: "private-use" },
        qmp: { scope: "private-use" },
        qmq: { scope: "private-use" },
        qmr: { scope: "private-use" },
        qms: { scope: "private-use" },
        qmt: { scope: "private-use" },
        qmu: { scope: "private-use" },
        qmv: { scope: "private-use" },
        qmw: { scope: "private-use" },
        qmx: { scope: "private-use" },
        qmy: { scope: "private-use" },
        qmz: { scope: "private-use" },
        qna: { scope: "private-use" },
        qnb: { scope: "private-use" },
        qnc: { scope: "private-use" },
        qnd: { scope: "private-use" },
        qne: { scope: "private-use" },
        qnf: { scope: "private-use" },
        qng: { scope: "private-use" },
        qnh: { scope: "private-use" },
        qni: { scope: "private-use" },
        qnj: { scope: "private-use" },
        qnk: { scope: "private-use" },
        qnl: { scope: "private-use" },
        qnm: { scope: "private-use" },
        qnn: { scope: "private-use" },
        qno: { scope: "private-use" },
        qnp: { scope: "private-use" },
        qnq: { scope: "private-use" },
        qnr: { scope: "private-use" },
        qns: { scope: "private-use" },
        qnt: { scope: "private-use" },
        qnu: { scope: "private-use" },
        qnv: { scope: "private-use" },
        qnw: { scope: "private-use" },
        qnx: { scope: "private-use" },
        qny: { scope: "private-use" },
        qnz: { scope: "private-use" },
        qoa: { scope: "private-use" },
        qob: { scope: "private-use" },
        qoc: { scope: "private-use" },
        qod: { scope: "private-use" },
        qoe: { scope: "private-use" },
        qof: { scope: "private-use" },
        qog: { scope: "private-use" },
        qoh: { scope: "private-use" },
        qoi: { scope: "private-use" },
        qoj: { scope: "private-use" },
        qok: { scope: "private-use" },
        qol: { scope: "private-use" },
        qom: { scope: "private-use" },
        qon: { scope: "private-use" },
        qoo: { scope: "private-use" },
        qop: { scope: "private-use" },
        qoq: { scope: "private-use" },
        qor: { scope: "private-use" },
        qos: { scope: "private-use" },
        qot: { scope: "private-use" },
        qou: { scope: "private-use" },
        qov: { scope: "private-use" },
        qow: { scope: "private-use" },
        qox: { scope: "private-use" },
        qoy: { scope: "private-use" },
        qoz: { scope: "private-use" },
        qpa: { scope: "private-use" },
        qpb: { scope: "private-use" },
        qpc: { scope: "private-use" },
        qpd: { scope: "private-use" },
        qpe: { scope: "private-use" },
        qpf: { scope: "private-use" },
        qpg: { scope: "private-use" },
        qph: { scope: "private-use" },
        qpi: { scope: "private-use" },
        qpj: { scope: "private-use" },
        qpk: { scope: "private-use" },
        qpl: { scope: "private-use" },
        qpm: { scope: "private-use" },
        qpn: { scope: "private-use" },
        qpo: { scope: "private-use" },
        qpp: { scope: "private-use" },
        qpq: { scope: "private-use" },
        qpr: { scope: "private-use" },
        qps: { scope: "private-use" },
        qpt: { scope: "private-use" },
        qpu: { scope: "private-use" },
        qpv: { scope: "private-use" },
        qpw: { scope: "private-use" },
        qpx: { scope: "private-use" },
        qpy: { scope: "private-use" },
        qpz: { scope: "private-use" },
        qqa: { scope: "private-use" },
        qqb: { scope: "private-use" },
        qqc: { scope: "private-use" },
        qqd: { scope: "private-use" },
        qqe: { scope: "private-use" },
        qqf: { scope: "private-use" },
        qqg: { scope: "private-use" },
        qqh: { scope: "private-use" },
        qqi: { scope: "private-use" },
        qqj: { scope: "private-use" },
        qqk: { scope: "private-use" },
        qql: { scope: "private-use" },
        qqm: { scope: "private-use" },
        qqn: { scope: "private-use" },
        qqo: { scope: "private-use" },
        qqp: { scope: "private-use" },
        qqq: { scope: "private-use" },
        qqr: { scope: "private-use" },
        qqs: { scope: "private-use" },
        qqt: { scope: "private-use" },
        qqu: { scope: "private-use" },
        qqv: { scope: "private-use" },
        qqw: { scope: "private-use" },
        qqx: { scope: "private-use" },
        qqy: { scope: "private-use" },
        qqz: { scope: "private-use" },
        qra: { scope: "private-use" },
        qrb: { scope: "private-use" },
        qrc: { scope: "private-use" },
        qrd: { scope: "private-use" },
        qre: { scope: "private-use" },
        qrf: { scope: "private-use" },
        qrg: { scope: "private-use" },
        qrh: { scope: "private-use" },
        qri: { scope: "private-use" },
        qrj: { scope: "private-use" },
        qrk: { scope: "private-use" },
        qrl: { scope: "private-use" },
        qrm: { scope: "private-use" },
        qrn: { scope: "private-use" },
        qro: { scope: "private-use" },
        qrp: { scope: "private-use" },
        qrq: { scope: "private-use" },
        qrr: { scope: "private-use" },
        qrs: { scope: "private-use" },
        qrt: { scope: "private-use" },
        qru: { scope: "private-use" },
        qrv: { scope: "private-use" },
        qrw: { scope: "private-use" },
        qrx: { scope: "private-use" },
        qry: { scope: "private-use" },
        qrz: { scope: "private-use" },
        qsa: { scope: "private-use" },
        qsb: { scope: "private-use" },
        qsc: { scope: "private-use" },
        qsd: { scope: "private-use" },
        qse: { scope: "private-use" },
        qsf: { scope: "private-use" },
        qsg: { scope: "private-use" },
        qsh: { scope: "private-use" },
        qsi: { scope: "private-use" },
        qsj: { scope: "private-use" },
        qsk: { scope: "private-use" },
        qsl: { scope: "private-use" },
        qsm: { scope: "private-use" },
        qsn: { scope: "private-use" },
        qso: { scope: "private-use" },
        qsp: { scope: "private-use" },
        qsq: { scope: "private-use" },
        qsr: { scope: "private-use" },
        qss: { scope: "private-use" },
        qst: { scope: "private-use" },
        qsu: { scope: "private-use" },
        qsv: { scope: "private-use" },
        qsw: { scope: "private-use" },
        qsx: { scope: "private-use" },
        qsy: { scope: "private-use" },
        qsz: { scope: "private-use" },
        qta: { scope: "private-use" },
        qtb: { scope: "private-use" },
        qtc: { scope: "private-use" },
        qtd: { scope: "private-use" },
        qte: { scope: "private-use" },
        qtf: { scope: "private-use" },
        qtg: { scope: "private-use" },
        qth: { scope: "private-use" },
        qti: { scope: "private-use" },
        qtj: { scope: "private-use" },
        qtk: { scope: "private-use" },
        qtl: { scope: "private-use" },
        qtm: { scope: "private-use" },
        qtn: { scope: "private-use" },
        qto: { scope: "private-use" },
        qtp: { scope: "private-use" },
        qtq: { scope: "private-use" },
        qtr: { scope: "private-use" },
        qts: { scope: "private-use" },
        qtt: { scope: "private-use" },
        qtu: { scope: "private-use" },
        qtv: { scope: "private-use" },
        qtw: { scope: "private-use" },
        qtx: { scope: "private-use" },
        qty: { scope: "private-use" },
        qtz: { scope: "private-use" },
        qua: { scope: null },
        qub: { scope: null },
        quc: { scope: null },
        qud: { scope: null },
        quf: { scope: null },
        qug: { scope: null },
        quh: { scope: null },
        qui: { scope: null },
        quk: { scope: null },
        qul: { scope: null },
        qum: { scope: null },
        qun: { scope: null },
        qup: { scope: null },
        quq: { scope: null },
        qur: { scope: null },
        qus: { scope: null },
        quv: { scope: null },
        quw: { scope: null },
        qux: { scope: null },
        quy: { scope: null },
        quz: { scope: null },
        qva: { scope: null },
        qvc: { scope: null },
        qve: { scope: null },
        qvh: { scope: null },
        qvi: { scope: null },
        qvj: { scope: null },
        qvl: { scope: null },
        qvm: { scope: null },
        qvn: { scope: null },
        qvo: { scope: null },
        qvp: { scope: null },
        qvs: { scope: null },
        qvw: { scope: null },
        qvy: { scope: null },
        qvz: { scope: null },
        qwa: { scope: null },
        qwc: { scope: null },
        qwe: { scope: "collection" },
        qwh: { scope: null },
        qwm: { scope: null },
        qws: { scope: null },
        qwt: { scope: null },
        qxa: { scope: null },
        qxc: { scope: null },
        qxh: { scope: null },
        qxl: { scope: null },
        qxn: { scope: null },
        qxo: { scope: null },
        qxp: { scope: null },
        qxq: { scope: null },
        qxr: { scope: null },
        qxs: { scope: null },
        qxt: { scope: null },
        qxu: { scope: null },
        qxw: { scope: null },
        qya: { scope: null },
        qyp: { scope: null },
        raa: { scope: null },
        rab: { scope: null },
        rac: { scope: null },
        rad: { scope: null },
        raf: { scope: null },
        rag: { scope: null },
        rah: { scope: null },
        rai: { scope: null },
        raj: { scope: "macrolanguage" },
        rak: { scope: null },
        ral: { scope: null },
        ram: { scope: null },
        ran: { scope: null },
        rao: { scope: null },
        rap: { scope: null },
        raq: { scope: null },
        rar: { scope: null },
        ras: { scope: null },
        rat: { scope: null },
        rau: { scope: null },
        rav: { scope: null },
        raw: { scope: null },
        rax: { scope: null },
        ray: { scope: null },
        raz: { scope: null },
        rbb: { scope: null },
        rbk: { scope: null },
        rbl: { scope: null },
        rbp: { scope: null },
        rcf: { scope: null },
        rdb: { scope: null },
        rea: { scope: null },
        reb: { scope: null },
        ree: { scope: null },
        reg: { scope: null },
        rei: { scope: null },
        rej: { scope: null },
        rel: { scope: null },
        rem: { scope: null },
        ren: { scope: null },
        rer: { scope: null },
        res: { scope: null },
        ret: { scope: null },
        rey: { scope: null },
        rga: { scope: null },
        rge: { scope: null },
        rgk: { scope: null },
        rgn: { scope: null },
        rgr: { scope: null },
        rgs: { scope: null },
        rgu: { scope: null },
        rhg: { scope: null },
        rhp: { scope: null },
        ria: { scope: null },
        rie: { scope: null },
        rif: { scope: null },
        ril: { scope: null },
        rim: { scope: null },
        rin: { scope: null },
        rir: { scope: null },
        rit: { scope: null },
        riu: { scope: null },
        rjg: { scope: null },
        rji: { scope: null },
        rjs: { scope: null },
        rka: { scope: null },
        rkb: { scope: null },
        rkh: { scope: null },
        rki: { scope: null },
        rkm: { scope: null },
        rkt: { scope: null },
        rkw: { scope: null },
        rma: { scope: null },
        rmb: { scope: null },
        rmc: { scope: null },
        rmd: { scope: null },
        rme: { scope: null },
        rmf: { scope: null },
        rmg: { scope: null },
        rmh: { scope: null },
        rmi: { scope: null },
        rmk: { scope: null },
        rml: { scope: null },
        rmm: { scope: null },
        rmn: { scope: null },
        rmo: { scope: null },
        rmp: { scope: null },
        rmq: { scope: null },
        rmr: { scope: null },
        rms: { scope: null },
        rmt: { scope: null },
        rmu: { scope: null },
        rmv: { scope: null },
        rmw: { scope: null },
        rmx: { scope: null },
        rmy: { scope: null },
        rmz: { scope: null },
        rna: { scope: null },
        rnd: { scope: null },
        rng: { scope: null },
        rnl: { scope: null },
        rnn: { scope: null },
        rnp: { scope: null },
        rnr: { scope: null },
        rnw: { scope: null },
        roa: { scope: "collection" },
        rob: { scope: null },
        roc: { scope: null },
        rod: { scope: null },
        roe: { scope: null },
        rof: { scope: null },
        rog: { scope: null },
        rol: { scope: null },
        rom: { scope: "macrolanguage" },
        roo: { scope: null },
        rop: { scope: null },
        ror: { scope: null },
        rou: { scope: null },
        row: { scope: null },
        rpn: { scope: null },
        rpt: { scope: null },
        rri: { scope: null },
        rro: { scope: null },
        rrt: { scope: null },
        rsb: { scope: null },
        rsi: { scope: null },
        rsl: { scope: null },
        rsm: { scope: null },
        rtc: { scope: null },
        rth: { scope: null },
        rtm: { scope: null },
        rts: { scope: null },
        rtw: { scope: null },
        rub: { scope: null },
        ruc: { scope: null },
        rue: { scope: null },
        ruf: { scope: null },
        rug: { scope: null },
        ruh: { scope: null },
        rui: { scope: null },
        ruk: { scope: null },
        ruo: { scope: null },
        rup: { scope: null },
        ruq: { scope: null },
        rut: { scope: null },
        ruu: { scope: null },
        ruy: { scope: null },
        ruz: { scope: null },
        rwa: { scope: null },
        rwk: { scope: null },
        rwl: { scope: null },
        rwm: { scope: null },
        rwo: { scope: null },
        rwr: { scope: null },
        rxd: { scope: null },
        rxw: { scope: null },
        ryn: { scope: null },
        rys: { scope: null },
        ryu: { scope: null },
        rzh: { scope: null },
        saa: { scope: null },
        sab: { scope: null },
        sac: { scope: null },
        sad: { scope: null },
        sae: { scope: null },
        saf: { scope: null },
        sah: { scope: null },
        sai: { scope: "collection" },
        saj: { scope: null },
        sak: { scope: null },
        sal: { scope: "collection" },
        sam: { scope: null },
        sao: { scope: null },
        sap: { scope: null },
        saq: { scope: null },
        sar: { scope: null },
        sas: { scope: null },
        sat: { scope: null },
        sau: { scope: null },
        sav: { scope: null },
        saw: { scope: null },
        sax: { scope: null },
        say: { scope: null },
        saz: { scope: null },
        sba: { scope: null },
        sbb: { scope: null },
        sbc: { scope: null },
        sbd: { scope: null },
        sbe: { scope: null },
        sbf: { scope: null },
        sbg: { scope: null },
        sbh: { scope: null },
        sbi: { scope: null },
        sbj: { scope: null },
        sbk: { scope: null },
        sbl: { scope: null },
        sbm: { scope: null },
        sbn: { scope: null },
        sbo: { scope: null },
        sbp: { scope: null },
        sbq: { scope: null },
        sbr: { scope: null },
        sbs: { scope: null },
        sbt: { scope: null },
        sbu: { scope: null },
        sbv: { scope: null },
        sbw: { scope: null },
        sbx: { scope: null },
        sby: { scope: null },
        sbz: { scope: null },
        sca: { scope: null },
        scb: { scope: null },
        sce: { scope: null },
        scf: { scope: null },
        scg: { scope: null },
        sch: { scope: null },
        sci: { scope: null },
        sck: { scope: null },
        scl: { scope: null },
        scn: { scope: null },
        sco: { scope: null },
        scp: { scope: null },
        scq: { scope: null },
        scs: { scope: null },
        sct: { scope: null },
        scu: { scope: null },
        scv: { scope: null },
        scw: { scope: null },
        scx: { scope: null },
        sda: { scope: null },
        sdb: { scope: null },
        sdc: { scope: null },
        sde: { scope: null },
        sdf: { scope: null },
        sdg: { scope: null },
        sdh: { scope: null },
        sdj: { scope: null },
        sdk: { scope: null },
        sdl: { scope: null },
        sdm: { scope: null },
        sdn: { scope: null },
        sdo: { scope: null },
        sdp: { scope: null },
        sdq: { scope: null },
        sdr: { scope: null },
        sds: { scope: null },
        sdt: { scope: null },
        sdu: { scope: null },
        sdv: { scope: "collection" },
        sdx: { scope: null },
        sdz: { scope: null },
        sea: { scope: null },
        seb: { scope: null },
        sec: { scope: null },
        sed: { scope: null },
        see: { scope: null },
        sef: { scope: null },
        seg: { scope: null },
        seh: { scope: null },
        sei: { scope: null },
        sej: { scope: null },
        sek: { scope: null },
        sel: { scope: null },
        sem: { scope: "collection" },
        sen: { scope: null },
        seo: { scope: null },
        sep: { scope: null },
        seq: { scope: null },
        ser: { scope: null },
        ses: { scope: null },
        set: { scope: null },
        seu: { scope: null },
        sev: { scope: null },
        sew: { scope: null },
        sey: { scope: null },
        sez: { scope: null },
        sfb: { scope: null },
        sfe: { scope: null },
        sfm: { scope: null },
        sfs: { scope: null },
        sfw: { scope: null },
        sga: { scope: null },
        sgb: { scope: null },
        sgc: { scope: null },
        sgd: { scope: null },
        sge: { scope: null },
        sgg: { scope: null },
        sgh: { scope: null },
        sgi: { scope: null },
        sgj: { scope: null },
        sgk: { scope: null },
        sgl: { scope: null },
        sgm: { scope: null },
        sgn: { scope: "collection" },
        sgo: { scope: null },
        sgp: { scope: null },
        sgr: { scope: null },
        sgs: { scope: null },
        sgt: { scope: null },
        sgu: { scope: null },
        sgw: { scope: null },
        sgx: { scope: null },
        sgy: { scope: null },
        sgz: { scope: null },
        sha: { scope: null },
        shb: { scope: null },
        shc: { scope: null },
        shd: { scope: null },
        she: { scope: null },
        shg: { scope: null },
        shh: { scope: null },
        shi: { scope: null },
        shj: { scope: null },
        shk: { scope: null },
        shl: { scope: null },
        shm: { scope: null },
        shn: { scope: null },
        sho: { scope: null },
        shp: { scope: null },
        shq: { scope: null },
        shr: { scope: null },
        shs: { scope: null },
        sht: { scope: null },
        shu: { scope: null },
        shv: { scope: null },
        shw: { scope: null },
        shx: { scope: null },
        shy: { scope: null },
        shz: { scope: null },
        sia: { scope: null },
        sib: { scope: null },
        sid: { scope: null },
        sie: { scope: null },
        sif: { scope: null },
        sig: { scope: null },
        sih: { scope: null },
        sii: { scope: null },
        sij: { scope: null },
        sik: { scope: null },
        sil: { scope: null },
        sim: { scope: null },
        sio: { scope: "collection" },
        sip: { scope: null },
        siq: { scope: null },
        sir: { scope: null },
        sis: { scope: null },
        sit: { scope: "collection" },
        siu: { scope: null },
        siv: { scope: null },
        siw: { scope: null },
        six: { scope: null },
        siy: { scope: null },
        siz: { scope: null },
        sja: { scope: null },
        sjb: { scope: null },
        sjd: { scope: null },
        sje: { scope: null },
        sjg: { scope: null },
        sjk: { scope: null },
        sjl: { scope: null },
        sjm: { scope: null },
        sjn: { scope: null },
        sjo: { scope: null },
        sjp: { scope: null },
        sjr: { scope: null },
        sjs: { scope: null },
        sjt: { scope: null },
        sju: { scope: null },
        sjw: { scope: null },
        ska: { scope: null },
        skb: { scope: null },
        skc: { scope: null },
        skd: { scope: null },
        ske: { scope: null },
        skf: { scope: null },
        skg: { scope: null },
        skh: { scope: null },
        ski: { scope: null },
        skj: { scope: null },
        skk: { scope: null },
        skm: { scope: null },
        skn: { scope: null },
        sko: { scope: null },
        skp: { scope: null },
        skq: { scope: null },
        skr: { scope: null },
        sks: { scope: null },
        skt: { scope: null },
        sku: { scope: null },
        skv: { scope: null },
        skw: { scope: null },
        skx: { scope: null },
        sky: { scope: null },
        skz: { scope: null },
        sla: { scope: "collection" },
        slc: { scope: null },
        sld: { scope: null },
        sle: { scope: null },
        slf: { scope: null },
        slg: { scope: null },
        slh: { scope: null },
        sli: { scope: null },
        slj: { scope: null },
        sll: { scope: null },
        slm: { scope: null },
        sln: { scope: null },
        slp: { scope: null },
        slq: { scope: null },
        slr: { scope: null },
        sls: { scope: null },
        slt: { scope: null },
        slu: { scope: null },
        slw: { scope: null },
        slx: { scope: null },
        sly: { scope: null },
        slz: { scope: null },
        sma: { scope: null },
        smb: { scope: null },
        smc: { scope: null },
        smd: { scope: null },
        smf: { scope: null },
        smg: { scope: null },
        smh: { scope: null },
        smi: { scope: "collection" },
        smj: { scope: null },
        smk: { scope: null },
        sml: { scope: null },
        smm: { scope: null },
        smn: { scope: null },
        smp: { scope: null },
        smq: { scope: null },
        smr: { scope: null },
        sms: { scope: null },
        smt: { scope: null },
        smu: { scope: null },
        smv: { scope: null },
        smw: { scope: null },
        smx: { scope: null },
        smy: { scope: null },
        smz: { scope: null },
        snb: { scope: null },
        snc: { scope: null },
        sne: { scope: null },
        snf: { scope: null },
        sng: { scope: null },
        snh: { scope: null },
        sni: { scope: null },
        snj: { scope: null },
        snk: { scope: null },
        snl: { scope: null },
        snm: { scope: null },
        snn: { scope: null },
        sno: { scope: null },
        snp: { scope: null },
        snq: { scope: null },
        snr: { scope: null },
        sns: { scope: null },
        snu: { scope: null },
        snv: { scope: null },
        snw: { scope: null },
        snx: { scope: null },
        sny: { scope: null },
        snz: { scope: null },
        soa: { scope: null },
        sob: { scope: null },
        soc: { scope: null },
        sod: { scope: null },
        soe: { scope: null },
        sog: { scope: null },
        soh: { scope: null },
        soi: { scope: null },
        soj: { scope: null },
        sok: { scope: null },
        sol: { scope: null },
        son: { scope: "collection" },
        soo: { scope: null },
        sop: { scope: null },
        soq: { scope: null },
        sor: { scope: null },
        sos: { scope: null },
        sou: { scope: null },
        sov: { scope: null },
        sow: { scope: null },
        sox: { scope: null },
        soy: { scope: null },
        soz: { scope: null },
        spb: { scope: null },
        spc: { scope: null },
        spd: { scope: null },
        spe: { scope: null },
        spg: { scope: null },
        spi: { scope: null },
        spk: { scope: null },
        spl: { scope: null },
        spm: { scope: null },
        spn: { scope: null },
        spo: { scope: null },
        spp: { scope: null },
        spq: { scope: null },
        spr: { scope: null },
        sps: { scope: null },
        spt: { scope: null },
        spu: { scope: null },
        spv: { scope: null },
        spx: { scope: null },
        spy: { scope: null },
        sqa: { scope: null },
        sqh: { scope: null },
        sqj: { scope: "collection" },
        sqk: { scope: null },
        sqm: { scope: null },
        sqn: { scope: null },
        sqo: { scope: null },
        sqq: { scope: null },
        sqr: { scope: null },
        sqs: { scope: null },
        sqt: { scope: null },
        squ: { scope: null },
        sqx: { scope: null },
        sra: { scope: null },
        srb: { scope: null },
        src: { scope: null },
        sre: { scope: null },
        srf: { scope: null },
        srg: { scope: null },
        srh: { scope: null },
        sri: { scope: null },
        srk: { scope: null },
        srl: { scope: null },
        srm: { scope: null },
        srn: { scope: null },
        sro: { scope: null },
        srq: { scope: null },
        srr: { scope: null },
        srs: { scope: null },
        srt: { scope: null },
        sru: { scope: null },
        srv: { scope: null },
        srw: { scope: null },
        srx: { scope: null },
        sry: { scope: null },
        srz: { scope: null },
        ssa: { scope: "collection" },
        ssb: { scope: null },
        ssc: { scope: null },
        ssd: { scope: null },
        sse: { scope: null },
        ssf: { scope: null },
        ssg: { scope: null },
        ssh: { scope: null },
        ssi: { scope: null },
        ssj: { scope: null },
        ssk: { scope: null },
        ssl: { scope: null },
        ssm: { scope: null },
        ssn: { scope: null },
        sso: { scope: null },
        ssp: { scope: null },
        ssq: { scope: null },
        ssr: { scope: null },
        sss: { scope: null },
        sst: { scope: null },
        ssu: { scope: null },
        ssv: { scope: null },
        ssx: { scope: null },
        ssy: { scope: null },
        ssz: { scope: null },
        sta: { scope: null },
        stb: { scope: null },
        std: { scope: null },
        ste: { scope: null },
        stf: { scope: null },
        stg: { scope: null },
        sth: { scope: null },
        sti: { scope: null },
        stj: { scope: null },
        stk: { scope: null },
        stl: { scope: null },
        stm: { scope: null },
        stn: { scope: null },
        sto: { scope: null },
        stp: { scope: null },
        stq: { scope: null },
        str: { scope: null },
        sts: { scope: null },
        stt: { scope: null },
        stu: { scope: null },
        stv: { scope: null },
        stw: { scope: null },
        sty: { scope: null },
        sua: { scope: null },
        sub: { scope: null },
        suc: { scope: null },
        sue: { scope: null },
        sug: { scope: null },
        sui: { scope: null },
        suj: { scope: null },
        suk: { scope: null },
        sul: { scope: null },
        sum: { scope: null },
        suo: { scope: null },
        suq: { scope: null },
        sur: { scope: null },
        sus: { scope: null },
        sut: { scope: null },
        suv: { scope: null },
        suw: { scope: null },
        sux: { scope: null },
        suy: { scope: null },
        suz: { scope: null },
        sva: { scope: null },
        svb: { scope: null },
        svc: { scope: null },
        sve: { scope: null },
        svk: { scope: null },
        svm: { scope: null },
        svr: { scope: null },
        svs: { scope: null },
        svx: { scope: null },
        swb: { scope: null },
        swc: { scope: null },
        swf: { scope: null },
        swg: { scope: null },
        swh: { scope: null },
        swi: { scope: null },
        swj: { scope: null },
        swk: { scope: null },
        swl: { scope: null },
        swm: { scope: null },
        swn: { scope: null },
        swo: { scope: null },
        swp: { scope: null },
        swq: { scope: null },
        swr: { scope: null },
        sws: { scope: null },
        swt: { scope: null },
        swu: { scope: null },
        swv: { scope: null },
        sww: { scope: null },
        swx: { scope: null },
        swy: { scope: null },
        sxb: { scope: null },
        sxc: { scope: null },
        sxe: { scope: null },
        sxg: { scope: null },
        sxk: { scope: null },
        sxl: { scope: null },
        sxm: { scope: null },
        sxn: { scope: null },
        sxo: { scope: null },
        sxr: { scope: null },
        sxs: { scope: null },
        sxu: { scope: null },
        sxw: { scope: null },
        sya: { scope: null },
        syb: { scope: null },
        syc: { scope: null },
        syd: { scope: "collection" },
        syi: { scope: null },
        syk: { scope: null },
        syl: { scope: null },
        sym: { scope: null },
        syn: { scope: null },
        syo: { scope: null },
        syr: { scope: "macrolanguage" },
        sys: { scope: null },
        syw: { scope: null },
        syx: { scope: null },
        syy: { scope: null },
        sza: { scope: null },
        szb: { scope: null },
        szc: { scope: null },
        szd: { scope: null },
        sze: { scope: null },
        szg: { scope: null },
        szl: { scope: null },
        szn: { scope: null },
        szp: { scope: null },
        szs: { scope: null },
        szv: { scope: null },
        szw: { scope: null },
        szy: { scope: null },
        taa: { scope: null },
        tab: { scope: null },
        tac: { scope: null },
        tad: { scope: null },
        tae: { scope: null },
        taf: { scope: null },
        tag: { scope: null },
        tai: { scope: "collection" },
        taj: { scope: null },
        tak: { scope: null },
        tal: { scope: null },
        tan: { scope: null },
        tao: { scope: null },
        tap: { scope: null },
        taq: { scope: null },
        tar: { scope: null },
        tas: { scope: null },
        tau: { scope: null },
        tav: { scope: null },
        taw: { scope: null },
        tax: { scope: null },
        tay: { scope: null },
        taz: { scope: null },
        tba: { scope: null },
        tbb: { scope: null },
        tbc: { scope: null },
        tbd: { scope: null },
        tbe: { scope: null },
        tbf: { scope: null },
        tbg: { scope: null },
        tbh: { scope: null },
        tbi: { scope: null },
        tbj: { scope: null },
        tbk: { scope: null },
        tbl: { scope: null },
        tbm: { scope: null },
        tbn: { scope: null },
        tbo: { scope: null },
        tbp: { scope: null },
        tbq: { scope: "collection" },
        tbr: { scope: null },
        tbs: { scope: null },
        tbt: { scope: null },
        tbu: { scope: null },
        tbv: { scope: null },
        tbw: { scope: null },
        tbx: { scope: null },
        tby: { scope: null },
        tbz: { scope: null },
        tca: { scope: null },
        tcb: { scope: null },
        tcc: { scope: null },
        tcd: { scope: null },
        tce: { scope: null },
        tcf: { scope: null },
        tcg: { scope: null },
        tch: { scope: null },
        tci: { scope: null },
        tck: { scope: null },
        tcl: { scope: null },
        tcm: { scope: null },
        tcn: { scope: null },
        tco: { scope: null },
        tcp: { scope: null },
        tcq: { scope: null },
        tcs: { scope: null },
        tct: { scope: null },
        tcu: { scope: null },
        tcw: { scope: null },
        tcx: { scope: null },
        tcy: { scope: null },
        tcz: { scope: null },
        tda: { scope: null },
        tdb: { scope: null },
        tdc: { scope: null },
        tdd: { scope: null },
        tde: { scope: null },
        tdf: { scope: null },
        tdg: { scope: null },
        tdh: { scope: null },
        tdi: { scope: null },
        tdj: { scope: null },
        tdk: { scope: null },
        tdl: { scope: null },
        tdm: { scope: null },
        tdn: { scope: null },
        tdo: { scope: null },
        tdq: { scope: null },
        tdr: { scope: null },
        tds: { scope: null },
        tdt: { scope: null },
        tdu: { scope: null },
        tdv: { scope: null },
        tdx: { scope: null },
        tdy: { scope: null },
        tea: { scope: null },
        teb: { scope: null },
        tec: { scope: null },
        ted: { scope: null },
        tee: { scope: null },
        tef: { scope: null },
        teg: { scope: null },
        teh: { scope: null },
        tei: { scope: null },
        tek: { scope: null },
        tem: { scope: null },
        ten: { scope: null },
        teo: { scope: null },
        tep: { scope: null },
        teq: { scope: null },
        ter: { scope: null },
        tes: { scope: null },
        tet: { scope: null },
        teu: { scope: null },
        tev: { scope: null },
        tew: { scope: null },
        tex: { scope: null },
        tey: { scope: null },
        tez: { scope: null },
        tfi: { scope: null },
        tfn: { scope: null },
        tfo: { scope: null },
        tfr: { scope: null },
        tft: { scope: null },
        tga: { scope: null },
        tgb: { scope: null },
        tgc: { scope: null },
        tgd: { scope: null },
        tge: { scope: null },
        tgf: { scope: null },
        tgg: { scope: null },
        tgh: { scope: null },
        tgi: { scope: null },
        tgj: { scope: null },
        tgn: { scope: null },
        tgo: { scope: null },
        tgp: { scope: null },
        tgq: { scope: null },
        tgr: { scope: null },
        tgs: { scope: null },
        tgt: { scope: null },
        tgu: { scope: null },
        tgv: { scope: null },
        tgw: { scope: null },
        tgx: { scope: null },
        tgy: { scope: null },
        tgz: { scope: null },
        thc: { scope: null },
        thd: { scope: null },
        the: { scope: null },
        thf: { scope: null },
        thh: { scope: null },
        thi: { scope: null },
        thk: { scope: null },
        thl: { scope: null },
        thm: { scope: null },
        thn: { scope: null },
        thp: { scope: null },
        thq: { scope: null },
        thr: { scope: null },
        ths: { scope: null },
        tht: { scope: null },
        thu: { scope: null },
        thv: { scope: null },
        thw: { scope: null },
        thx: { scope: null },
        thy: { scope: null },
        thz: { scope: null },
        tia: { scope: null },
        tic: { scope: null },
        tid: { scope: null },
        tie: { scope: null },
        tif: { scope: null },
        tig: { scope: null },
        tih: { scope: null },
        tii: { scope: null },
        tij: { scope: null },
        tik: { scope: null },
        til: { scope: null },
        tim: { scope: null },
        tin: { scope: null },
        tio: { scope: null },
        tip: { scope: null },
        tiq: { scope: null },
        tis: { scope: null },
        tit: { scope: null },
        tiu: { scope: null },
        tiv: { scope: null },
        tiw: { scope: null },
        tix: { scope: null },
        tiy: { scope: null },
        tiz: { scope: null },
        tja: { scope: null },
        tjg: { scope: null },
        tji: { scope: null },
        tjj: { scope: null },
        tjl: { scope: null },
        tjm: { scope: null },
        tjn: { scope: null },
        tjo: { scope: null },
        tjp: { scope: null },
        tjs: { scope: null },
        tju: { scope: null },
        tjw: { scope: null },
        tka: { scope: null },
        tkb: { scope: null },
        tkd: { scope: null },
        tke: { scope: null },
        tkf: { scope: null },
        tkg: { scope: null },
        tkk: { scope: null },
        tkl: { scope: null },
        tkm: { scope: null },
        tkn: { scope: null },
        tkp: { scope: null },
        tkq: { scope: null },
        tkr: { scope: null },
        tks: { scope: null },
        tkt: { scope: null },
        tku: { scope: null },
        tkv: { scope: null },
        tkw: { scope: null },
        tkx: { scope: null },
        tkz: { scope: null },
        tla: { scope: null },
        tlb: { scope: null },
        tlc: { scope: null },
        tld: { scope: null },
        tlf: { scope: null },
        tlg: { scope: null },
        tlh: { scope: null },
        tli: { scope: null },
        tlj: { scope: null },
        tlk: { scope: null },
        tll: { scope: null },
        tlm: { scope: null },
        tln: { scope: null },
        tlo: { scope: null },
        tlp: { scope: null },
        tlq: { scope: null },
        tlr: { scope: null },
        tls: { scope: null },
        tlt: { scope: null },
        tlu: { scope: null },
        tlv: { scope: null },
        tlw: { scope: null },
        tlx: { scope: null },
        tly: { scope: null },
        tma: { scope: null },
        tmb: { scope: null },
        tmc: { scope: null },
        tmd: { scope: null },
        tme: { scope: null },
        tmf: { scope: null },
        tmg: { scope: null },
        tmh: { scope: "macrolanguage" },
        tmi: { scope: null },
        tmj: { scope: null },
        tmk: { scope: null },
        tml: { scope: null },
        tmm: { scope: null },
        tmn: { scope: null },
        tmo: { scope: null },
        tmp: { scope: null },
        tmq: { scope: null },
        tmr: { scope: null },
        tms: { scope: null },
        tmt: { scope: null },
        tmu: { scope: null },
        tmv: { scope: null },
        tmw: { scope: null },
        tmy: { scope: null },
        tmz: { scope: null },
        tna: { scope: null },
        tnb: { scope: null },
        tnc: { scope: null },
        tnd: { scope: null },
        tne: { scope: null },
        tnf: { scope: null },
        tng: { scope: null },
        tnh: { scope: null },
        tni: { scope: null },
        tnk: { scope: null },
        tnl: { scope: null },
        tnm: { scope: null },
        tnn: { scope: null },
        tno: { scope: null },
        tnp: { scope: null },
        tnq: { scope: null },
        tnr: { scope: null },
        tns: { scope: null },
        tnt: { scope: null },
        tnu: { scope: null },
        tnv: { scope: null },
        tnw: { scope: null },
        tnx: { scope: null },
        tny: { scope: null },
        tnz: { scope: null },
        tob: { scope: null },
        toc: { scope: null },
        tod: { scope: null },
        toe: { scope: null },
        tof: { scope: null },
        tog: { scope: null },
        toh: { scope: null },
        toi: { scope: null },
        toj: { scope: null },
        tol: { scope: null },
        tom: { scope: null },
        too: { scope: null },
        top: { scope: null },
        toq: { scope: null },
        tor: { scope: null },
        tos: { scope: null },
        tou: { scope: null },
        tov: { scope: null },
        tow: { scope: null },
        tox: { scope: null },
        toy: { scope: null },
        toz: { scope: null },
        tpa: { scope: null },
        tpc: { scope: null },
        tpe: { scope: null },
        tpf: { scope: null },
        tpg: { scope: null },
        tpi: { scope: null },
        tpj: { scope: null },
        tpk: { scope: null },
        tpl: { scope: null },
        tpm: { scope: null },
        tpn: { scope: null },
        tpo: { scope: null },
        tpp: { scope: null },
        tpq: { scope: null },
        tpr: { scope: null },
        tpt: { scope: null },
        tpu: { scope: null },
        tpv: { scope: null },
        tpw: { scope: null },
        tpx: { scope: null },
        tpy: { scope: null },
        tpz: { scope: null },
        tqb: { scope: null },
        tql: { scope: null },
        tqm: { scope: null },
        tqn: { scope: null },
        tqo: { scope: null },
        tqp: { scope: null },
        tqq: { scope: null },
        tqr: { scope: null },
        tqt: { scope: null },
        tqu: { scope: null },
        tqw: { scope: null },
        tra: { scope: null },
        trb: { scope: null },
        trc: { scope: null },
        trd: { scope: null },
        tre: { scope: null },
        trf: { scope: null },
        trg: { scope: null },
        trh: { scope: null },
        tri: { scope: null },
        trj: { scope: null },
        trk: { scope: "collection" },
        trl: { scope: null },
        trm: { scope: null },
        trn: { scope: null },
        tro: { scope: null },
        trp: { scope: null },
        trq: { scope: null },
        trr: { scope: null },
        trs: { scope: null },
        trt: { scope: null },
        tru: { scope: null },
        trv: { scope: null },
        trw: { scope: null },
        trx: { scope: null },
        try: { scope: null },
        trz: { scope: null },
        tsa: { scope: null },
        tsb: { scope: null },
        tsc: { scope: null },
        tsd: { scope: null },
        tse: { scope: null },
        tsf: { scope: null },
        tsg: { scope: null },
        tsh: { scope: null },
        tsi: { scope: null },
        tsj: { scope: null },
        tsk: { scope: null },
        tsl: { scope: null },
        tsm: { scope: null },
        tsp: { scope: null },
        tsq: { scope: null },
        tsr: { scope: null },
        tss: { scope: null },
        tst: { scope: null },
        tsu: { scope: null },
        tsv: { scope: null },
        tsw: { scope: null },
        tsx: { scope: null },
        tsy: { scope: null },
        tsz: { scope: null },
        tta: { scope: null },
        ttb: { scope: null },
        ttc: { scope: null },
        ttd: { scope: null },
        tte: { scope: null },
        ttf: { scope: null },
        ttg: { scope: null },
        tth: { scope: null },
        tti: { scope: null },
        ttj: { scope: null },
        ttk: { scope: null },
        ttl: { scope: null },
        ttm: { scope: null },
        ttn: { scope: null },
        tto: { scope: null },
        ttp: { scope: null },
        ttq: { scope: null },
        ttr: { scope: null },
        tts: { scope: null },
        ttt: { scope: null },
        ttu: { scope: null },
        ttv: { scope: null },
        ttw: { scope: null },
        tty: { scope: null },
        ttz: { scope: null },
        tua: { scope: null },
        tub: { scope: null },
        tuc: { scope: null },
        tud: { scope: null },
        tue: { scope: null },
        tuf: { scope: null },
        tug: { scope: null },
        tuh: { scope: null },
        tui: { scope: null },
        tuj: { scope: null },
        tul: { scope: null },
        tum: { scope: null },
        tun: { scope: null },
        tuo: { scope: null },
        tup: { scope: "collection" },
        tuq: { scope: null },
        tus: { scope: null },
        tut: { scope: "collection" },
        tuu: { scope: null },
        tuv: { scope: null },
        tuw: { scope: "collection" },
        tux: { scope: null },
        tuy: { scope: null },
        tuz: { scope: null },
        tva: { scope: null },
        tvd: { scope: null },
        tve: { scope: null },
        tvk: { scope: null },
        tvl: { scope: null },
        tvm: { scope: null },
        tvn: { scope: null },
        tvo: { scope: null },
        tvs: { scope: null },
        tvt: { scope: null },
        tvu: { scope: null },
        tvw: { scope: null },
        tvx: { scope: null },
        tvy: { scope: null },
        twa: { scope: null },
        twb: { scope: null },
        twc: { scope: null },
        twd: { scope: null },
        twe: { scope: null },
        twf: { scope: null },
        twg: { scope: null },
        twh: { scope: null },
        twl: { scope: null },
        twm: { scope: null },
        twn: { scope: null },
        two: { scope: null },
        twp: { scope: null },
        twq: { scope: null },
        twr: { scope: null },
        twt: { scope: null },
        twu: { scope: null },
        tww: { scope: null },
        twx: { scope: null },
        twy: { scope: null },
        txa: { scope: null },
        txb: { scope: null },
        txc: { scope: null },
        txe: { scope: null },
        txg: { scope: null },
        txh: { scope: null },
        txi: { scope: null },
        txj: { scope: null },
        txm: { scope: null },
        txn: { scope: null },
        txo: { scope: null },
        txq: { scope: null },
        txr: { scope: null },
        txs: { scope: null },
        txt: { scope: null },
        txu: { scope: null },
        txx: { scope: null },
        txy: { scope: null },
        tya: { scope: null },
        tye: { scope: null },
        tyh: { scope: null },
        tyi: { scope: null },
        tyj: { scope: null },
        tyl: { scope: null },
        tyn: { scope: null },
        typ: { scope: null },
        tyr: { scope: null },
        tys: { scope: null },
        tyt: { scope: null },
        tyu: { scope: null },
        tyv: { scope: null },
        tyx: { scope: null },
        tyy: { scope: null },
        tyz: { scope: null },
        tza: { scope: null },
        tzh: { scope: null },
        tzj: { scope: null },
        tzl: { scope: null },
        tzm: { scope: null },
        tzn: { scope: null },
        tzo: { scope: null },
        tzx: { scope: null },
        uam: { scope: null },
        uan: { scope: null },
        uar: { scope: null },
        uba: { scope: null },
        ubi: { scope: null },
        ubl: { scope: null },
        ubr: { scope: null },
        ubu: { scope: null },
        uby: { scope: null },
        uda: { scope: null },
        ude: { scope: null },
        udg: { scope: null },
        udi: { scope: null },
        udj: { scope: null },
        udl: { scope: null },
        udm: { scope: null },
        udu: { scope: null },
        ues: { scope: null },
        ufi: { scope: null },
        uga: { scope: null },
        ugb: { scope: null },
        uge: { scope: null },
        ugn: { scope: null },
        ugo: { scope: null },
        ugy: { scope: null },
        uha: { scope: null },
        uhn: { scope: null },
        uis: { scope: null },
        uiv: { scope: null },
        uji: { scope: null },
        uka: { scope: null },
        ukg: { scope: null },
        ukh: { scope: null },
        uki: { scope: null },
        ukk: { scope: null },
        ukl: { scope: null },
        ukp: { scope: null },
        ukq: { scope: null },
        uks: { scope: null },
        uku: { scope: null },
        ukv: { scope: null },
        ukw: { scope: null },
        uky: { scope: null },
        ula: { scope: null },
        ulb: { scope: null },
        ulc: { scope: null },
        ule: { scope: null },
        ulf: { scope: null },
        uli: { scope: null },
        ulk: { scope: null },
        ull: { scope: null },
        ulm: { scope: null },
        uln: { scope: null },
        ulu: { scope: null },
        ulw: { scope: null },
        uma: { scope: null },
        umb: { scope: null },
        umc: { scope: null },
        umd: { scope: null },
        umg: { scope: null },
        umi: { scope: null },
        umm: { scope: null },
        umn: { scope: null },
        umo: { scope: null },
        ump: { scope: null },
        umr: { scope: null },
        ums: { scope: null },
        umu: { scope: null },
        una: { scope: null },
        und: { scope: "special" },
        une: { scope: null },
        ung: { scope: null },
        uni: { scope: null },
        unk: { scope: null },
        unm: { scope: null },
        unn: { scope: null },
        unp: { scope: null },
        unr: { scope: null },
        unu: { scope: null },
        unx: { scope: null },
        unz: { scope: null },
        uok: { scope: null },
        upi: { scope: null },
        upv: { scope: null },
        ura: { scope: null },
        urb: { scope: null },
        urc: { scope: null },
        ure: { scope: null },
        urf: { scope: null },
        urg: { scope: null },
        urh: { scope: null },
        uri: { scope: null },
        urj: { scope: "collection" },
        urk: { scope: null },
        url: { scope: null },
        urm: { scope: null },
        urn: { scope: null },
        uro: { scope: null },
        urp: { scope: null },
        urr: { scope: null },
        urt: { scope: null },
        uru: { scope: null },
        urv: { scope: null },
        urw: { scope: null },
        urx: { scope: null },
        ury: { scope: null },
        urz: { scope: null },
        usa: { scope: null },
        ush: { scope: null },
        usi: { scope: null },
        usk: { scope: null },
        usp: { scope: null },
        uss: { scope: null },
        usu: { scope: null },
        uta: { scope: null },
        ute: { scope: null },
        uth: { scope: null },
        utp: { scope: null },
        utr: { scope: null },
        utu: { scope: null },
        uum: { scope: null },
        uun: { scope: null },
        uur: { scope: null },
        uuu: { scope: null },
        uve: { scope: null },
        uvh: { scope: null },
        uvl: { scope: null },
        uwa: { scope: null },
        uya: { scope: null },
        uzn: { scope: null },
        uzs: { scope: null },
        vaa: { scope: null },
        vae: { scope: null },
        vaf: { scope: null },
        vag: { scope: null },
        vah: { scope: null },
        vai: { scope: null },
        vaj: { scope: null },
        val: { scope: null },
        vam: { scope: null },
        van: { scope: null },
        vao: { scope: null },
        vap: { scope: null },
        var: { scope: null },
        vas: { scope: null },
        vau: { scope: null },
        vav: { scope: null },
        vay: { scope: null },
        vbb: { scope: null },
        vbk: { scope: null },
        vec: { scope: null },
        ved: { scope: null },
        vel: { scope: null },
        vem: { scope: null },
        veo: { scope: null },
        vep: { scope: null },
        ver: { scope: null },
        vgr: { scope: null },
        vgt: { scope: null },
        vic: { scope: null },
        vid: { scope: null },
        vif: { scope: null },
        vig: { scope: null },
        vil: { scope: null },
        vin: { scope: null },
        vis: { scope: null },
        vit: { scope: null },
        viv: { scope: null },
        vka: { scope: null },
        vki: { scope: null },
        vkj: { scope: null },
        vkk: { scope: null },
        vkl: { scope: null },
        vkm: { scope: null },
        vkn: { scope: null },
        vko: { scope: null },
        vkp: { scope: null },
        vkt: { scope: null },
        vku: { scope: null },
        vkz: { scope: null },
        vlp: { scope: null },
        vls: { scope: null },
        vma: { scope: null },
        vmb: { scope: null },
        vmc: { scope: null },
        vmd: { scope: null },
        vme: { scope: null },
        vmf: { scope: null },
        vmg: { scope: null },
        vmh: { scope: null },
        vmi: { scope: null },
        vmj: { scope: null },
        vmk: { scope: null },
        vml: { scope: null },
        vmm: { scope: null },
        vmp: { scope: null },
        vmq: { scope: null },
        vmr: { scope: null },
        vms: { scope: null },
        vmu: { scope: null },
        vmv: { scope: null },
        vmw: { scope: null },
        vmx: { scope: null },
        vmy: { scope: null },
        vmz: { scope: null },
        vnk: { scope: null },
        vnm: { scope: null },
        vnp: { scope: null },
        vor: { scope: null },
        vot: { scope: null },
        vra: { scope: null },
        vro: { scope: null },
        vrs: { scope: null },
        vrt: { scope: null },
        vsi: { scope: null },
        vsl: { scope: null },
        vsv: { scope: null },
        vto: { scope: null },
        vum: { scope: null },
        vun: { scope: null },
        vut: { scope: null },
        vwa: { scope: null },
        waa: { scope: null },
        wab: { scope: null },
        wac: { scope: null },
        wad: { scope: null },
        wae: { scope: null },
        waf: { scope: null },
        wag: { scope: null },
        wah: { scope: null },
        wai: { scope: null },
        waj: { scope: null },
        wak: { scope: "collection" },
        wal: { scope: null },
        wam: { scope: null },
        wan: { scope: null },
        wao: { scope: null },
        wap: { scope: null },
        waq: { scope: null },
        war: { scope: null },
        was: { scope: null },
        wat: { scope: null },
        wau: { scope: null },
        wav: { scope: null },
        waw: { scope: null },
        wax: { scope: null },
        way: { scope: null },
        waz: { scope: null },
        wba: { scope: null },
        wbb: { scope: null },
        wbe: { scope: null },
        wbf: { scope: null },
        wbh: { scope: null },
        wbi: { scope: null },
        wbj: { scope: null },
        wbk: { scope: null },
        wbl: { scope: null },
        wbm: { scope: null },
        wbp: { scope: null },
        wbq: { scope: null },
        wbr: { scope: null },
        wbs: { scope: null },
        wbt: { scope: null },
        wbv: { scope: null },
        wbw: { scope: null },
        wca: { scope: null },
        wci: { scope: null },
        wdd: { scope: null },
        wdg: { scope: null },
        wdj: { scope: null },
        wdk: { scope: null },
        wdu: { scope: null },
        wdy: { scope: null },
        wea: { scope: null },
        wec: { scope: null },
        wed: { scope: null },
        weg: { scope: null },
        weh: { scope: null },
        wei: { scope: null },
        wem: { scope: null },
        wen: { scope: "collection" },
        weo: { scope: null },
        wep: { scope: null },
        wer: { scope: null },
        wes: { scope: null },
        wet: { scope: null },
        weu: { scope: null },
        wew: { scope: null },
        wfg: { scope: null },
        wga: { scope: null },
        wgb: { scope: null },
        wgg: { scope: null },
        wgi: { scope: null },
        wgo: { scope: null },
        wgu: { scope: null },
        wgw: { scope: null },
        wgy: { scope: null },
        wha: { scope: null },
        whg: { scope: null },
        whk: { scope: null },
        whu: { scope: null },
        wib: { scope: null },
        wic: { scope: null },
        wie: { scope: null },
        wif: { scope: null },
        wig: { scope: null },
        wih: { scope: null },
        wii: { scope: null },
        wij: { scope: null },
        wik: { scope: null },
        wil: { scope: null },
        wim: { scope: null },
        win: { scope: null },
        wir: { scope: null },
        wit: { scope: null },
        wiu: { scope: null },
        wiv: { scope: null },
        wiw: { scope: null },
        wiy: { scope: null },
        wja: { scope: null },
        wji: { scope: null },
        wka: { scope: null },
        wkb: { scope: null },
        wkd: { scope: null },
        wkl: { scope: null },
        wkr: { scope: null },
        wku: { scope: null },
        wkw: { scope: null },
        wky: { scope: null },
        wla: { scope: null },
        wlc: { scope: null },
        wle: { scope: null },
        wlg: { scope: null },
        wlh: { scope: null },
        wli: { scope: null },
        wlk: { scope: null },
        wll: { scope: null },
        wlm: { scope: null },
        wlo: { scope: null },
        wlr: { scope: null },
        wls: { scope: null },
        wlu: { scope: null },
        wlv: { scope: null },
        wlw: { scope: null },
        wlx: { scope: null },
        wly: { scope: null },
        wma: { scope: null },
        wmb: { scope: null },
        wmc: { scope: null },
        wmd: { scope: null },
        wme: { scope: null },
        wmg: { scope: null },
        wmh: { scope: null },
        wmi: { scope: null },
        wmm: { scope: null },
        wmn: { scope: null },
        wmo: { scope: null },
        wms: { scope: null },
        wmt: { scope: null },
        wmw: { scope: null },
        wmx: { scope: null },
        wnb: { scope: null },
        wnc: { scope: null },
        wnd: { scope: null },
        wne: { scope: null },
        wng: { scope: null },
        wni: { scope: null },
        wnk: { scope: null },
        wnm: { scope: null },
        wnn: { scope: null },
        wno: { scope: null },
        wnp: { scope: null },
        wnu: { scope: null },
        wnw: { scope: null },
        wny: { scope: null },
        woa: { scope: null },
        wob: { scope: null },
        woc: { scope: null },
        wod: { scope: null },
        woe: { scope: null },
        wof: { scope: null },
        wog: { scope: null },
        woi: { scope: null },
        wok: { scope: null },
        wom: { scope: null },
        won: { scope: null },
        woo: { scope: null },
        wor: { scope: null },
        wos: { scope: null },
        wow: { scope: null },
        woy: { scope: null },
        wpc: { scope: null },
        wra: { scope: null },
        wrb: { scope: null },
        wrd: { scope: null },
        wrg: { scope: null },
        wrh: { scope: null },
        wri: { scope: null },
        wrk: { scope: null },
        wrl: { scope: null },
        wrm: { scope: null },
        wrn: { scope: null },
        wro: { scope: null },
        wrp: { scope: null },
        wrr: { scope: null },
        wrs: { scope: null },
        wru: { scope: null },
        wrv: { scope: null },
        wrw: { scope: null },
        wrx: { scope: null },
        wry: { scope: null },
        wrz: { scope: null },
        wsa: { scope: null },
        wsg: { scope: null },
        wsi: { scope: null },
        wsk: { scope: null },
        wsr: { scope: null },
        wss: { scope: null },
        wsu: { scope: null },
        wsv: { scope: null },
        wtf: { scope: null },
        wth: { scope: null },
        wti: { scope: null },
        wtk: { scope: null },
        wtm: { scope: null },
        wtw: { scope: null },
        wua: { scope: null },
        wub: { scope: null },
        wud: { scope: null },
        wuh: { scope: null },
        wul: { scope: null },
        wum: { scope: null },
        wun: { scope: null },
        wur: { scope: null },
        wut: { scope: null },
        wuu: { scope: null },
        wuv: { scope: null },
        wux: { scope: null },
        wuy: { scope: null },
        wwa: { scope: null },
        wwb: { scope: null },
        wwo: { scope: null },
        wwr: { scope: null },
        www: { scope: null },
        wxa: { scope: null },
        wxw: { scope: null },
        wya: { scope: null },
        wyb: { scope: null },
        wyi: { scope: null },
        wym: { scope: null },
        wyr: { scope: null },
        wyy: { scope: null },
        xaa: { scope: null },
        xab: { scope: null },
        xac: { scope: null },
        xad: { scope: null },
        xae: { scope: null },
        xag: { scope: null },
        xai: { scope: null },
        xaj: { scope: null },
        xak: { scope: null },
        xal: { scope: null },
        xam: { scope: null },
        xan: { scope: null },
        xao: { scope: null },
        xap: { scope: null },
        xaq: { scope: null },
        xar: { scope: null },
        xas: { scope: null },
        xat: { scope: null },
        xau: { scope: null },
        xav: { scope: null },
        xaw: { scope: null },
        xay: { scope: null },
        xba: { scope: null },
        xbb: { scope: null },
        xbc: { scope: null },
        xbd: { scope: null },
        xbe: { scope: null },
        xbg: { scope: null },
        xbi: { scope: null },
        xbj: { scope: null },
        xbm: { scope: null },
        xbn: { scope: null },
        xbo: { scope: null },
        xbp: { scope: null },
        xbr: { scope: null },
        xbw: { scope: null },
        xbx: { scope: null },
        xby: { scope: null },
        xcb: { scope: null },
        xcc: { scope: null },
        xce: { scope: null },
        xcg: { scope: null },
        xch: { scope: null },
        xcl: { scope: null },
        xcm: { scope: null },
        xcn: { scope: null },
        xco: { scope: null },
        xcr: { scope: null },
        xct: { scope: null },
        xcu: { scope: null },
        xcv: { scope: null },
        xcw: { scope: null },
        xcy: { scope: null },
        xda: { scope: null },
        xdc: { scope: null },
        xdk: { scope: null },
        xdm: { scope: null },
        xdo: { scope: null },
        xdy: { scope: null },
        xeb: { scope: null },
        xed: { scope: null },
        xeg: { scope: null },
        xel: { scope: null },
        xem: { scope: null },
        xep: { scope: null },
        xer: { scope: null },
        xes: { scope: null },
        xet: { scope: null },
        xeu: { scope: null },
        xfa: { scope: null },
        xga: { scope: null },
        xgb: { scope: null },
        xgd: { scope: null },
        xgf: { scope: null },
        xgg: { scope: null },
        xgi: { scope: null },
        xgl: { scope: null },
        xgm: { scope: null },
        xgn: { scope: "collection" },
        xgr: { scope: null },
        xgu: { scope: null },
        xgw: { scope: null },
        xha: { scope: null },
        xhc: { scope: null },
        xhd: { scope: null },
        xhe: { scope: null },
        xhr: { scope: null },
        xht: { scope: null },
        xhu: { scope: null },
        xhv: { scope: null },
        xia: { scope: null },
        xib: { scope: null },
        xii: { scope: null },
        xil: { scope: null },
        xin: { scope: null },
        xip: { scope: null },
        xir: { scope: null },
        xis: { scope: null },
        xiv: { scope: null },
        xiy: { scope: null },
        xjb: { scope: null },
        xjt: { scope: null },
        xka: { scope: null },
        xkb: { scope: null },
        xkc: { scope: null },
        xkd: { scope: null },
        xke: { scope: null },
        xkf: { scope: null },
        xkg: { scope: null },
        xkh: { scope: null },
        xki: { scope: null },
        xkj: { scope: null },
        xkk: { scope: null },
        xkl: { scope: null },
        xkn: { scope: null },
        xko: { scope: null },
        xkp: { scope: null },
        xkq: { scope: null },
        xkr: { scope: null },
        xks: { scope: null },
        xkt: { scope: null },
        xku: { scope: null },
        xkv: { scope: null },
        xkw: { scope: null },
        xkx: { scope: null },
        xky: { scope: null },
        xkz: { scope: null },
        xla: { scope: null },
        xlb: { scope: null },
        xlc: { scope: null },
        xld: { scope: null },
        xle: { scope: null },
        xlg: { scope: null },
        xli: { scope: null },
        xln: { scope: null },
        xlo: { scope: null },
        xlp: { scope: null },
        xls: { scope: null },
        xlu: { scope: null },
        xly: { scope: null },
        xma: { scope: null },
        xmb: { scope: null },
        xmc: { scope: null },
        xmd: { scope: null },
        xme: { scope: null },
        xmf: { scope: null },
        xmg: { scope: null },
        xmh: { scope: null },
        xmj: { scope: null },
        xmk: { scope: null },
        xml: { scope: null },
        xmm: { scope: null },
        xmn: { scope: null },
        xmo: { scope: null },
        xmp: { scope: null },
        xmq: { scope: null },
        xmr: { scope: null },
        xms: { scope: null },
        xmt: { scope: null },
        xmu: { scope: null },
        xmv: { scope: null },
        xmw: { scope: null },
        xmx: { scope: null },
        xmy: { scope: null },
        xmz: { scope: null },
        xna: { scope: null },
        xnb: { scope: null },
        xnd: { scope: "collection" },
        xng: { scope: null },
        xnh: { scope: null },
        xni: { scope: null },
        xnj: { scope: null },
        xnk: { scope: null },
        xnm: { scope: null },
        xnn: { scope: null },
        xno: { scope: null },
        xnq: { scope: null },
        xnr: { scope: null },
        xns: { scope: null },
        xnt: { scope: null },
        xnu: { scope: null },
        xny: { scope: null },
        xnz: { scope: null },
        xoc: { scope: null },
        xod: { scope: null },
        xog: { scope: null },
        xoi: { scope: null },
        xok: { scope: null },
        xom: { scope: null },
        xon: { scope: null },
        xoo: { scope: null },
        xop: { scope: null },
        xor: { scope: null },
        xow: { scope: null },
        xpa: { scope: null },
        xpb: { scope: null },
        xpc: { scope: null },
        xpd: { scope: null },
        xpe: { scope: null },
        xpf: { scope: null },
        xpg: { scope: null },
        xph: { scope: null },
        xpi: { scope: null },
        xpj: { scope: null },
        xpk: { scope: null },
        xpl: { scope: null },
        xpm: { scope: null },
        xpn: { scope: null },
        xpo: { scope: null },
        xpp: { scope: null },
        xpq: { scope: null },
        xpr: { scope: null },
        xps: { scope: null },
        xpt: { scope: null },
        xpu: { scope: null },
        xpv: { scope: null },
        xpw: { scope: null },
        xpx: { scope: null },
        xpy: { scope: null },
        xpz: { scope: null },
        xqa: { scope: null },
        xqt: { scope: null },
        xra: { scope: null },
        xrb: { scope: null },
        xrd: { scope: null },
        xre: { scope: null },
        xrg: { scope: null },
        xri: { scope: null },
        xrm: { scope: null },
        xrn: { scope: null },
        xrq: { scope: null },
        xrr: { scope: null },
        xrt: { scope: null },
        xru: { scope: null },
        xrw: { scope: null },
        xsa: { scope: null },
        xsb: { scope: null },
        xsc: { scope: null },
        xsd: { scope: null },
        xse: { scope: null },
        xsh: { scope: null },
        xsi: { scope: null },
        xsj: { scope: null },
        xsl: { scope: null },
        xsm: { scope: null },
        xsn: { scope: null },
        xso: { scope: null },
        xsp: { scope: null },
        xsq: { scope: null },
        xsr: { scope: null },
        xss: { scope: null },
        xsu: { scope: null },
        xsv: { scope: null },
        xsy: { scope: null },
        xta: { scope: null },
        xtb: { scope: null },
        xtc: { scope: null },
        xtd: { scope: null },
        xte: { scope: null },
        xtg: { scope: null },
        xth: { scope: null },
        xti: { scope: null },
        xtj: { scope: null },
        xtl: { scope: null },
        xtm: { scope: null },
        xtn: { scope: null },
        xto: { scope: null },
        xtp: { scope: null },
        xtq: { scope: null },
        xtr: { scope: null },
        xts: { scope: null },
        xtt: { scope: null },
        xtu: { scope: null },
        xtv: { scope: null },
        xtw: { scope: null },
        xty: { scope: null },
        xtz: { scope: null },
        xua: { scope: null },
        xub: { scope: null },
        xud: { scope: null },
        xug: { scope: null },
        xuj: { scope: null },
        xul: { scope: null },
        xum: { scope: null },
        xun: { scope: null },
        xuo: { scope: null },
        xup: { scope: null },
        xur: { scope: null },
        xut: { scope: null },
        xuu: { scope: null },
        xve: { scope: null },
        xvi: { scope: null },
        xvn: { scope: null },
        xvo: { scope: null },
        xvs: { scope: null },
        xwa: { scope: null },
        xwc: { scope: null },
        xwd: { scope: null },
        xwe: { scope: null },
        xwg: { scope: null },
        xwj: { scope: null },
        xwk: { scope: null },
        xwl: { scope: null },
        xwo: { scope: null },
        xwr: { scope: null },
        xwt: { scope: null },
        xww: { scope: null },
        xxb: { scope: null },
        xxk: { scope: null },
        xxm: { scope: null },
        xxr: { scope: null },
        xxt: { scope: null },
        xya: { scope: null },
        xyb: { scope: null },
        xyj: { scope: null },
        xyk: { scope: null },
        xyl: { scope: null },
        xyt: { scope: null },
        xyy: { scope: null },
        xzh: { scope: null },
        xzm: { scope: null },
        xzp: { scope: null },
        yaa: { scope: null },
        yab: { scope: null },
        yac: { scope: null },
        yad: { scope: null },
        yae: { scope: null },
        yaf: { scope: null },
        yag: { scope: null },
        yah: { scope: null },
        yai: { scope: null },
        yaj: { scope: null },
        yak: { scope: null },
        yal: { scope: null },
        yam: { scope: null },
        yan: { scope: null },
        yao: { scope: null },
        yap: { scope: null },
        yaq: { scope: null },
        yar: { scope: null },
        yas: { scope: null },
        yat: { scope: null },
        yau: { scope: null },
        yav: { scope: null },
        yaw: { scope: null },
        yax: { scope: null },
        yay: { scope: null },
        yaz: { scope: null },
        yba: { scope: null },
        ybb: { scope: null },
        ybd: { scope: null },
        ybe: { scope: null },
        ybh: { scope: null },
        ybi: { scope: null },
        ybj: { scope: null },
        ybk: { scope: null },
        ybl: { scope: null },
        ybm: { scope: null },
        ybn: { scope: null },
        ybo: { scope: null },
        ybx: { scope: null },
        yby: { scope: null },
        ych: { scope: null },
        ycl: { scope: null },
        ycn: { scope: null },
        ycp: { scope: null },
        yda: { scope: null },
        ydd: { scope: null },
        yde: { scope: null },
        ydg: { scope: null },
        ydk: { scope: null },
        yds: { scope: null },
        yea: { scope: null },
        yec: { scope: null },
        yee: { scope: null },
        yei: { scope: null },
        yej: { scope: null },
        yel: { scope: null },
        yen: { scope: null },
        yer: { scope: null },
        yes: { scope: null },
        yet: { scope: null },
        yeu: { scope: null },
        yev: { scope: null },
        yey: { scope: null },
        yga: { scope: null },
        ygi: { scope: null },
        ygl: { scope: null },
        ygm: { scope: null },
        ygp: { scope: null },
        ygr: { scope: null },
        ygs: { scope: null },
        ygu: { scope: null },
        ygw: { scope: null },
        yha: { scope: null },
        yhd: { scope: null },
        yhl: { scope: null },
        yhs: { scope: null },
        yia: { scope: null },
        yif: { scope: null },
        yig: { scope: null },
        yih: { scope: null },
        yii: { scope: null },
        yij: { scope: null },
        yik: { scope: null },
        yil: { scope: null },
        yim: { scope: null },
        yin: { scope: null },
        yip: { scope: null },
        yiq: { scope: null },
        yir: { scope: null },
        yis: { scope: null },
        yit: { scope: null },
        yiu: { scope: null },
        yiv: { scope: null },
        yix: { scope: null },
        yiy: { scope: null },
        yiz: { scope: null },
        yka: { scope: null },
        ykg: { scope: null },
        yki: { scope: null },
        ykk: { scope: null },
        ykl: { scope: null },
        ykm: { scope: null },
        ykn: { scope: null },
        yko: { scope: null },
        ykr: { scope: null },
        ykt: { scope: null },
        yku: { scope: null },
        yky: { scope: null },
        yla: { scope: null },
        ylb: { scope: null },
        yle: { scope: null },
        ylg: { scope: null },
        yli: { scope: null },
        yll: { scope: null },
        ylm: { scope: null },
        yln: { scope: null },
        ylo: { scope: null },
        ylr: { scope: null },
        ylu: { scope: null },
        yly: { scope: null },
        yma: { scope: null },
        ymb: { scope: null },
        ymc: { scope: null },
        ymd: { scope: null },
        yme: { scope: null },
        ymg: { scope: null },
        ymh: { scope: null },
        ymi: { scope: null },
        ymk: { scope: null },
        yml: { scope: null },
        ymm: { scope: null },
        ymn: { scope: null },
        ymo: { scope: null },
        ymp: { scope: null },
        ymq: { scope: null },
        ymr: { scope: null },
        yms: { scope: null },
        ymt: { scope: null },
        ymx: { scope: null },
        ymz: { scope: null },
        yna: { scope: null },
        ynd: { scope: null },
        yne: { scope: null },
        yng: { scope: null },
        ynh: { scope: null },
        ynk: { scope: null },
        ynl: { scope: null },
        ynn: { scope: null },
        yno: { scope: null },
        ynq: { scope: null },
        yns: { scope: null },
        ynu: { scope: null },
        yob: { scope: null },
        yog: { scope: null },
        yoi: { scope: null },
        yok: { scope: null },
        yol: { scope: null },
        yom: { scope: null },
        yon: { scope: null },
        yos: { scope: null },
        yot: { scope: null },
        yox: { scope: null },
        yoy: { scope: null },
        ypa: { scope: null },
        ypb: { scope: null },
        ypg: { scope: null },
        yph: { scope: null },
        ypk: { scope: "collection" },
        ypm: { scope: null },
        ypn: { scope: null },
        ypo: { scope: null },
        ypp: { scope: null },
        ypz: { scope: null },
        yra: { scope: null },
        yrb: { scope: null },
        yre: { scope: null },
        yri: { scope: null },
        yrk: { scope: null },
        yrl: { scope: null },
        yrm: { scope: null },
        yrn: { scope: null },
        yro: { scope: null },
        yrs: { scope: null },
        yrw: { scope: null },
        yry: { scope: null },
        ysc: { scope: null },
        ysd: { scope: null },
        ysg: { scope: null },
        ysl: { scope: null },
        ysm: { scope: null },
        ysn: { scope: null },
        yso: { scope: null },
        ysp: { scope: null },
        ysr: { scope: null },
        yss: { scope: null },
        ysy: { scope: null },
        yta: { scope: null },
        ytl: { scope: null },
        ytp: { scope: null },
        ytw: { scope: null },
        yty: { scope: null },
        yua: { scope: null },
        yub: { scope: null },
        yuc: { scope: null },
        yud: { scope: null },
        yue: { scope: null },
        yuf: { scope: null },
        yug: { scope: null },
        yui: { scope: null },
        yuj: { scope: null },
        yuk: { scope: null },
        yul: { scope: null },
        yum: { scope: null },
        yun: { scope: null },
        yup: { scope: null },
        yuq: { scope: null },
        yur: { scope: null },
        yut: { scope: null },
        yuu: { scope: null },
        yuw: { scope: null },
        yux: { scope: null },
        yuy: { scope: null },
        yuz: { scope: null },
        yva: { scope: null },
        yvt: { scope: null },
        ywa: { scope: null },
        ywg: { scope: null },
        ywl: { scope: null },
        ywn: { scope: null },
        ywq: { scope: null },
        ywr: { scope: null },
        ywt: { scope: null },
        ywu: { scope: null },
        yww: { scope: null },
        yxa: { scope: null },
        yxg: { scope: null },
        yxl: { scope: null },
        yxm: { scope: null },
        yxu: { scope: null },
        yxy: { scope: null },
        yyr: { scope: null },
        yyu: { scope: null },
        yyz: { scope: null },
        yzg: { scope: null },
        yzk: { scope: null },
        zaa: { scope: null },
        zab: { scope: null },
        zac: { scope: null },
        zad: { scope: null },
        zae: { scope: null },
        zaf: { scope: null },
        zag: { scope: null },
        zah: { scope: null },
        zai: { scope: null },
        zaj: { scope: null },
        zak: { scope: null },
        zal: { scope: null },
        zam: { scope: null },
        zao: { scope: null },
        zap: { scope: "macrolanguage" },
        zaq: { scope: null },
        zar: { scope: null },
        zas: { scope: null },
        zat: { scope: null },
        zau: { scope: null },
        zav: { scope: null },
        zaw: { scope: null },
        zax: { scope: null },
        zay: { scope: null },
        zaz: { scope: null },
        zba: { scope: null },
        zbc: { scope: null },
        zbe: { scope: null },
        zbl: { scope: null },
        zbt: { scope: null },
        zbu: { scope: null },
        zbw: { scope: null },
        zca: { scope: null },
        zch: { scope: null },
        zdj: { scope: null },
        zea: { scope: null },
        zeg: { scope: null },
        zeh: { scope: null },
        zen: { scope: null },
        zga: { scope: null },
        zgb: { scope: null },
        zgh: { scope: null },
        zgm: { scope: null },
        zgn: { scope: null },
        zgr: { scope: null },
        zhb: { scope: null },
        zhd: { scope: null },
        zhi: { scope: null },
        zhn: { scope: null },
        zhw: { scope: null },
        zhx: { scope: "collection" },
        zia: { scope: null },
        zib: { scope: null },
        zik: { scope: null },
        zil: { scope: null },
        zim: { scope: null },
        zin: { scope: null },
        zir: { scope: null },
        ziw: { scope: null },
        ziz: { scope: null },
        zka: { scope: null },
        zkb: { scope: null },
        zkd: { scope: null },
        zkg: { scope: null },
        zkh: { scope: null },
        zkk: { scope: null },
        zkn: { scope: null },
        zko: { scope: null },
        zkp: { scope: null },
        zkr: { scope: null },
        zkt: { scope: null },
        zku: { scope: null },
        zkv: { scope: null },
        zkz: { scope: null },
        zla: { scope: null },
        zle: { scope: "collection" },
        zlj: { scope: null },
        zlm: { scope: null },
        zln: { scope: null },
        zlq: { scope: null },
        zls: { scope: "collection" },
        zlw: { scope: "collection" },
        zma: { scope: null },
        zmb: { scope: null },
        zmc: { scope: null },
        zmd: { scope: null },
        zme: { scope: null },
        zmf: { scope: null },
        zmg: { scope: null },
        zmh: { scope: null },
        zmi: { scope: null },
        zmj: { scope: null },
        zmk: { scope: null },
        zml: { scope: null },
        zmm: { scope: null },
        zmn: { scope: null },
        zmo: { scope: null },
        zmp: { scope: null },
        zmq: { scope: null },
        zmr: { scope: null },
        zms: { scope: null },
        zmt: { scope: null },
        zmu: { scope: null },
        zmv: { scope: null },
        zmw: { scope: null },
        zmx: { scope: null },
        zmy: { scope: null },
        zmz: { scope: null },
        zna: { scope: null },
        znd: { scope: "collection" },
        zne: { scope: null },
        zng: { scope: null },
        znk: { scope: null },
        zns: { scope: null },
        zoc: { scope: null },
        zoh: { scope: null },
        zom: { scope: null },
        zoo: { scope: null },
        zoq: { scope: null },
        zor: { scope: null },
        zos: { scope: null },
        zpa: { scope: null },
        zpb: { scope: null },
        zpc: { scope: null },
        zpd: { scope: null },
        zpe: { scope: null },
        zpf: { scope: null },
        zpg: { scope: null },
        zph: { scope: null },
        zpi: { scope: null },
        zpj: { scope: null },
        zpk: { scope: null },
        zpl: { scope: null },
        zpm: { scope: null },
        zpn: { scope: null },
        zpo: { scope: null },
        zpp: { scope: null },
        zpq: { scope: null },
        zpr: { scope: null },
        zps: { scope: null },
        zpt: { scope: null },
        zpu: { scope: null },
        zpv: { scope: null },
        zpw: { scope: null },
        zpx: { scope: null },
        zpy: { scope: null },
        zpz: { scope: null },
        zqe: { scope: null },
        zra: { scope: null },
        zrg: { scope: null },
        zrn: { scope: null },
        zro: { scope: null },
        zrp: { scope: null },
        zrs: { scope: null },
        zsa: { scope: null },
        zsk: { scope: null },
        zsl: { scope: null },
        zsm: { scope: null },
        zsr: { scope: null },
        zsu: { scope: null },
        zte: { scope: null },
        ztg: { scope: null },
        ztl: { scope: null },
        ztm: { scope: null },
        ztn: { scope: null },
        ztp: { scope: null },
        ztq: { scope: null },
        zts: { scope: null },
        ztt: { scope: null },
        ztu: { scope: null },
        ztx: { scope: null },
        zty: { scope: null },
        zua: { scope: null },
        zuh: { scope: null },
        zum: { scope: null },
        zun: { scope: null },
        zuy: { scope: null },
        zwa: { scope: null },
        zxx: { scope: "special" },
        zyb: { scope: null },
        zyg: { scope: null },
        zyj: { scope: null },
        zyn: { scope: null },
        zyp: { scope: null },
        zza: { scope: "macrolanguage" },
        zzj: { scope: null },
    },
    extended: {
        aao: { prefix: "ar" },
        abh: { prefix: "ar" },
        abv: { prefix: "ar" },
        acm: { prefix: "ar" },
        acq: { prefix: "ar" },
        acw: { prefix: "ar" },
        acx: { prefix: "ar" },
        acy: { prefix: "ar" },
        adf: { prefix: "ar" },
        ads: { prefix: "sgn" },
        aeb: { prefix: "ar" },
        aec: { prefix: "ar" },
        aed: { prefix: "sgn" },
        aen: { prefix: "sgn" },
        afb: { prefix: "ar" },
        afg: { prefix: "sgn" },
        ajp: { prefix: "ar" },
        apc: { prefix: "ar" },
        apd: { prefix: "ar" },
        arb: { prefix: "ar" },
        arq: { prefix: "ar" },
        ars: { prefix: "ar" },
        ary: { prefix: "ar" },
        arz: { prefix: "ar" },
        ase: { prefix: "sgn" },
        asf: { prefix: "sgn" },
        asp: { prefix: "sgn" },
        asq: { prefix: "sgn" },
        asw: { prefix: "sgn" },
        auz: { prefix: "ar" },
        avl: { prefix: "ar" },
        ayh: { prefix: "ar" },
        ayl: { prefix: "ar" },
        ayn: { prefix: "ar" },
        ayp: { prefix: "ar" },
        bbz: { prefix: "ar" },
        bfi: { prefix: "sgn" },
        bfk: { prefix: "sgn" },
        bjn: { prefix: "ms" },
        bog: { prefix: "sgn" },
        bqn: { prefix: "sgn" },
        bqy: { prefix: "sgn" },
        btj: { prefix: "ms" },
        bve: { prefix: "ms" },
        bvl: { prefix: "sgn" },
        bvu: { prefix: "ms" },
        bzs: { prefix: "sgn" },
        cdo: { prefix: "zh" },
        cds: { prefix: "sgn" },
        cjy: { prefix: "zh" },
        cmn: { prefix: "zh" },
        cnp: { prefix: "zh" },
        coa: { prefix: "ms" },
        cpx: { prefix: "zh" },
        csc: { prefix: "sgn" },
        csd: { prefix: "sgn" },
        cse: { prefix: "sgn" },
        csf: { prefix: "sgn" },
        csg: { prefix: "sgn" },
        csl: { prefix: "sgn" },
        csn: { prefix: "sgn" },
        csp: { prefix: "zh" },
        csq: { prefix: "sgn" },
        csr: { prefix: "sgn" },
        csx: { prefix: "sgn" },
        czh: { prefix: "zh" },
        czo: { prefix: "zh" },
        doq: { prefix: "sgn" },
        dse: { prefix: "sgn" },
        dsl: { prefix: "sgn" },
        dup: { prefix: "ms" },
        ecs: { prefix: "sgn" },
        ehs: { prefix: "sgn" },
        esl: { prefix: "sgn" },
        esn: { prefix: "sgn" },
        eso: { prefix: "sgn" },
        eth: { prefix: "sgn" },
        fcs: { prefix: "sgn" },
        fse: { prefix: "sgn" },
        fsl: { prefix: "sgn" },
        fss: { prefix: "sgn" },
        gan: { prefix: "zh" },
        gds: { prefix: "sgn" },
        gom: { prefix: "kok" },
        gse: { prefix: "sgn" },
        gsg: { prefix: "sgn" },
        gsm: { prefix: "sgn" },
        gss: { prefix: "sgn" },
        gus: { prefix: "sgn" },
        hab: { prefix: "sgn" },
        haf: { prefix: "sgn" },
        hak: { prefix: "zh" },
        hds: { prefix: "sgn" },
        hji: { prefix: "ms" },
        hks: { prefix: "sgn" },
        hos: { prefix: "sgn" },
        hps: { prefix: "sgn" },
        hsh: { prefix: "sgn" },
        hsl: { prefix: "sgn" },
        hsn: { prefix: "zh" },
        icl: { prefix: "sgn" },
        iks: { prefix: "sgn" },
        ils: { prefix: "sgn" },
        inl: { prefix: "sgn" },
        ins: { prefix: "sgn" },
        ise: { prefix: "sgn" },
        isg: { prefix: "sgn" },
        isr: { prefix: "sgn" },
        jak: { prefix: "ms" },
        jax: { prefix: "ms" },
        jcs: { prefix: "sgn" },
        jhs: { prefix: "sgn" },
        jks: { prefix: "sgn" },
        jls: { prefix: "sgn" },
        jos: { prefix: "sgn" },
        jsl: { prefix: "sgn" },
        jus: { prefix: "sgn" },
        kgi: { prefix: "sgn" },
        knn: { prefix: "kok" },
        kvb: { prefix: "ms" },
        kvk: { prefix: "sgn" },
        kvr: { prefix: "ms" },
        kxd: { prefix: "ms" },
        lbs: { prefix: "sgn" },
        lce: { prefix: "ms" },
        lcf: { prefix: "ms" },
        liw: { prefix: "ms" },
        lls: { prefix: "sgn" },
        lsb: { prefix: "sgn" },
        lsg: { prefix: "sgn" },
        lsl: { prefix: "sgn" },
        lsn: { prefix: "sgn" },
        lso: { prefix: "sgn" },
        lsp: { prefix: "sgn" },
        lst: { prefix: "sgn" },
        lsv: { prefix: "sgn" },
        lsy: { prefix: "sgn" },
        ltg: { prefix: "lv" },
        lvs: { prefix: "lv" },
        lws: { prefix: "sgn" },
        lzh: { prefix: "zh" },
        max: { prefix: "ms" },
        mdl: { prefix: "sgn" },
        meo: { prefix: "ms" },
        mfa: { prefix: "ms" },
        mfb: { prefix: "ms" },
        mfs: { prefix: "sgn" },
        min: { prefix: "ms" },
        mnp: { prefix: "zh" },
        mqg: { prefix: "ms" },
        mre: { prefix: "sgn" },
        msd: { prefix: "sgn" },
        msi: { prefix: "ms" },
        msr: { prefix: "sgn" },
        mui: { prefix: "ms" },
        mzc: { prefix: "sgn" },
        mzg: { prefix: "sgn" },
        mzy: { prefix: "sgn" },
        nan: { prefix: "zh" },
        nbs: { prefix: "sgn" },
        ncs: { prefix: "sgn" },
        nsi: { prefix: "sgn" },
        nsl: { prefix: "sgn" },
        nsp: { prefix: "sgn" },
        nsr: { prefix: "sgn" },
        nzs: { prefix: "sgn" },
        okl: { prefix: "sgn" },
        orn: { prefix: "ms" },
        ors: { prefix: "ms" },
        pel: { prefix: "ms" },
        pga: { prefix: "ar" },
        pgz: { prefix: "sgn" },
        pks: { prefix: "sgn" },
        prl: { prefix: "sgn" },
        prz: { prefix: "sgn" },
        psc: { prefix: "sgn" },
        psd: { prefix: "sgn" },
        pse: { prefix: "ms" },
        psg: { prefix: "sgn" },
        psl: { prefix: "sgn" },
        pso: { prefix: "sgn" },
        psp: { prefix: "sgn" },
        psr: { prefix: "sgn" },
        pys: { prefix: "sgn" },
        rms: { prefix: "sgn" },
        rsi: { prefix: "sgn" },
        rsl: { prefix: "sgn" },
        rsm: { prefix: "sgn" },
        sdl: { prefix: "sgn" },
        sfb: { prefix: "sgn" },
        sfs: { prefix: "sgn" },
        sgg: { prefix: "sgn" },
        sgx: { prefix: "sgn" },
        shu: { prefix: "ar" },
        slf: { prefix: "sgn" },
        sls: { prefix: "sgn" },
        sqk: { prefix: "sgn" },
        sqs: { prefix: "sgn" },
        sqx: { prefix: "sgn" },
        ssh: { prefix: "ar" },
        ssp: { prefix: "sgn" },
        ssr: { prefix: "sgn" },
        svk: { prefix: "sgn" },
        swc: { prefix: "sw" },
        swh: { prefix: "sw" },
        swl: { prefix: "sgn" },
        syy: { prefix: "sgn" },
        szs: { prefix: "sgn" },
        tmw: { prefix: "ms" },
        tse: { prefix: "sgn" },
        tsm: { prefix: "sgn" },
        tsq: { prefix: "sgn" },
        tss: { prefix: "sgn" },
        tsy: { prefix: "sgn" },
        tza: { prefix: "sgn" },
        ugn: { prefix: "sgn" },
        ugy: { prefix: "sgn" },
        ukl: { prefix: "sgn" },
        uks: { prefix: "sgn" },
        urk: { prefix: "ms" },
        uzn: { prefix: "uz" },
        uzs: { prefix: "uz" },
        vgt: { prefix: "sgn" },
        vkk: { prefix: "ms" },
        vkt: { prefix: "ms" },
        vsi: { prefix: "sgn" },
        vsl: { prefix: "sgn" },
        vsv: { prefix: "sgn" },
        wbs: { prefix: "sgn" },
        wuu: { prefix: "zh" },
        xki: { prefix: "sgn" },
        xml: { prefix: "sgn" },
        xmm: { prefix: "ms" },
        xms: { prefix: "sgn" },
        yds: { prefix: "sgn" },
        ygs: { prefix: "sgn" },
        yhs: { prefix: "sgn" },
        ysl: { prefix: "sgn" },
        ysm: { prefix: "sgn" },
        yue: { prefix: "zh" },
        zib: { prefix: "sgn" },
        zlm: { prefix: "ms" },
        zmi: { prefix: "ms" },
        zsl: { prefix: "sgn" },
        zsm: { prefix: "ms" },
    },
    script: {
        adlm: {},
        afak: {},
        aghb: {},
        ahom: {},
        arab: {},
        aran: {},
        armi: {},
        armn: {},
        avst: {},
        bali: {},
        bamu: {},
        bass: {},
        batk: {},
        beng: {},
        bhks: {},
        blis: {},
        bopo: {},
        brah: {},
        brai: {},
        bugi: {},
        buhd: {},
        cakm: {},
        cans: {},
        cari: {},
        cham: {},
        cher: {},
        chrs: {},
        cirt: {},
        copt: {},
        cpmn: {},
        cprt: {},
        cyrl: {},
        cyrs: {},
        deva: {},
        diak: {},
        dogr: {},
        dsrt: {},
        dupl: {},
        egyd: {},
        egyh: {},
        egyp: {},
        elba: {},
        elym: {},
        ethi: {},
        geok: {},
        geor: {},
        glag: {},
        gong: {},
        gonm: {},
        goth: {},
        gran: {},
        grek: {},
        gujr: {},
        guru: {},
        hanb: {},
        hang: {},
        hani: {},
        hano: {},
        hans: {},
        hant: {},
        hatr: {},
        hebr: {},
        hira: {},
        hluw: {},
        hmng: {},
        hmnp: {},
        hrkt: {},
        hung: {},
        inds: {},
        ital: {},
        jamo: {},
        java: {},
        jpan: {},
        jurc: {},
        kali: {},
        kana: {},
        khar: {},
        khmr: {},
        khoj: {},
        kitl: {},
        kits: {},
        knda: {},
        kore: {},
        kpel: {},
        kthi: {},
        lana: {},
        laoo: {},
        latf: {},
        latg: {},
        latn: {},
        leke: {},
        lepc: {},
        limb: {},
        lina: {},
        linb: {},
        lisu: {},
        loma: {},
        lyci: {},
        lydi: {},
        mahj: {},
        maka: {},
        mand: {},
        mani: {},
        marc: {},
        maya: {},
        medf: {},
        mend: {},
        merc: {},
        mero: {},
        mlym: {},
        modi: {},
        mong: {},
        moon: {},
        mroo: {},
        mtei: {},
        mult: {},
        mymr: {},
        nand: {},
        narb: {},
        nbat: {},
        newa: {},
        nkdb: {},
        nkgb: {},
        nkoo: {},
        nshu: {},
        ogam: {},
        olck: {},
        orkh: {},
        orya: {},
        osge: {},
        osma: {},
        ougr: {},
        palm: {},
        pauc: {},
        pcun: {},
        pelm: {},
        perm: {},
        phag: {},
        phli: {},
        phlp: {},
        phlv: {},
        phnx: {},
        piqd: {},
        plrd: {},
        prti: {},
        psin: {},
        qaaa: {},
        qaab: {},
        qaac: {},
        qaad: {},
        qaae: {},
        qaaf: {},
        qaag: {},
        qaah: {},
        qaai: {},
        qaaj: {},
        qaak: {},
        qaal: {},
        qaam: {},
        qaan: {},
        qaao: {},
        qaap: {},
        qaaq: {},
        qaar: {},
        qaas: {},
        qaat: {},
        qaau: {},
        qaav: {},
        qaaw: {},
        qaax: {},
        qaba: {},
        qabb: {},
        qabc: {},
        qabd: {},
        qabe: {},
        qabf: {},
        qabg: {},
        qabh: {},
        qabi: {},
        qabj: {},
        qabk: {},
        qabl: {},
        qabm: {},
        qabn: {},
        qabo: {},
        qabp: {},
        qabq: {},
        qabr: {},
        qabs: {},
        qabt: {},
        qabu: {},
        qabv: {},
        qabw: {},
        qabx: {},
        ranj: {},
        rjng: {},
        rohg: {},
        roro: {},
        runr: {},
        samr: {},
        sara: {},
        sarb: {},
        saur: {},
        sgnw: {},
        shaw: {},
        shrd: {},
        shui: {},
        sidd: {},
        sind: {},
        sinh: {},
        sogd: {},
        sogo: {},
        sora: {},
        soyo: {},
        sund: {},
        sylo: {},
        syrc: {},
        syre: {},
        syrj: {},
        syrn: {},
        tagb: {},
        takr: {},
        tale: {},
        talu: {},
        taml: {},
        tang: {},
        tavt: {},
        telu: {},
        teng: {},
        tfng: {},
        tglg: {},
        thaa: {},
        thai: {},
        tibt: {},
        tirh: {},
        tnsa: {},
        toto: {},
        ugar: {},
        vaii: {},
        visp: {},
        vith: {},
        wara: {},
        wcho: {},
        wole: {},
        xpeo: {},
        xsux: {},
        yezi: {},
        yiii: {},
        zanb: {},
        zinh: {},
        zmth: {},
        zsye: {},
        zsym: {},
        zxxx: {},
        zyyy: {},
        zzzz: {},
    },
    region: {
        aa: {},
        ac: {},
        ad: {},
        ae: {},
        af: {},
        ag: {},
        ai: {},
        al: {},
        am: {},
        an: {},
        ao: {},
        aq: {},
        ar: {},
        as: {},
        at: {},
        au: {},
        aw: {},
        ax: {},
        az: {},
        ba: {},
        bb: {},
        bd: {},
        be: {},
        bf: {},
        bg: {},
        bh: {},
        bi: {},
        bj: {},
        bl: {},
        bm: {},
        bn: {},
        bo: {},
        bq: {},
        br: {},
        bs: {},
        bt: {},
        bu: {},
        bv: {},
        bw: {},
        by: {},
        bz: {},
        ca: {},
        cc: {},
        cd: {},
        cf: {},
        cg: {},
        ch: {},
        ci: {},
        ck: {},
        cl: {},
        cm: {},
        cn: {},
        co: {},
        cp: {},
        cr: {},
        cs: {},
        cu: {},
        cv: {},
        cw: {},
        cx: {},
        cy: {},
        cz: {},
        dd: {},
        de: {},
        dg: {},
        dj: {},
        dk: {},
        dm: {},
        do: {},
        dz: {},
        ea: {},
        ec: {},
        ee: {},
        eg: {},
        eh: {},
        er: {},
        es: {},
        et: {},
        eu: {},
        ez: {},
        fi: {},
        fj: {},
        fk: {},
        fm: {},
        fo: {},
        fr: {},
        fx: {},
        ga: {},
        gb: {},
        gd: {},
        ge: {},
        gf: {},
        gg: {},
        gh: {},
        gi: {},
        gl: {},
        gm: {},
        gn: {},
        gp: {},
        gq: {},
        gr: {},
        gs: {},
        gt: {},
        gu: {},
        gw: {},
        gy: {},
        hk: {},
        hm: {},
        hn: {},
        hr: {},
        ht: {},
        hu: {},
        ic: {},
        id: {},
        ie: {},
        il: {},
        im: {},
        in: {},
        io: {},
        iq: {},
        ir: {},
        is: {},
        it: {},
        je: {},
        jm: {},
        jo: {},
        jp: {},
        ke: {},
        kg: {},
        kh: {},
        ki: {},
        km: {},
        kn: {},
        kp: {},
        kr: {},
        kw: {},
        ky: {},
        kz: {},
        la: {},
        lb: {},
        lc: {},
        li: {},
        lk: {},
        lr: {},
        ls: {},
        lt: {},
        lu: {},
        lv: {},
        ly: {},
        ma: {},
        mc: {},
        md: {},
        me: {},
        mf: {},
        mg: {},
        mh: {},
        mk: {},
        ml: {},
        mm: {},
        mn: {},
        mo: {},
        mp: {},
        mq: {},
        mr: {},
        ms: {},
        mt: {},
        mu: {},
        mv: {},
        mw: {},
        mx: {},
        my: {},
        mz: {},
        na: {},
        nc: {},
        ne: {},
        nf: {},
        ng: {},
        ni: {},
        nl: {},
        no: {},
        np: {},
        nr: {},
        nt: {},
        nu: {},
        nz: {},
        om: {},
        pa: {},
        pe: {},
        pf: {},
        pg: {},
        ph: {},
        pk: {},
        pl: {},
        pm: {},
        pn: {},
        pr: {},
        ps: {},
        pt: {},
        pw: {},
        py: {},
        qa: {},
        qm: {},
        qn: {},
        qo: {},
        qp: {},
        qq: {},
        qr: {},
        qs: {},
        qt: {},
        qu: {},
        qv: {},
        qw: {},
        qx: {},
        qy: {},
        qz: {},
        re: {},
        ro: {},
        rs: {},
        ru: {},
        rw: {},
        sa: {},
        sb: {},
        sc: {},
        sd: {},
        se: {},
        sg: {},
        sh: {},
        si: {},
        sj: {},
        sk: {},
        sl: {},
        sm: {},
        sn: {},
        so: {},
        sr: {},
        ss: {},
        st: {},
        su: {},
        sv: {},
        sx: {},
        sy: {},
        sz: {},
        ta: {},
        tc: {},
        td: {},
        tf: {},
        tg: {},
        th: {},
        tj: {},
        tk: {},
        tl: {},
        tm: {},
        tn: {},
        to: {},
        tp: {},
        tr: {},
        tt: {},
        tv: {},
        tw: {},
        tz: {},
        ua: {},
        ug: {},
        um: {},
        un: {},
        us: {},
        uy: {},
        uz: {},
        va: {},
        vc: {},
        ve: {},
        vg: {},
        vi: {},
        vn: {},
        vu: {},
        wf: {},
        ws: {},
        xa: {},
        xb: {},
        xc: {},
        xd: {},
        xe: {},
        xf: {},
        xg: {},
        xh: {},
        xi: {},
        xj: {},
        xk: {},
        xl: {},
        xm: {},
        xn: {},
        xo: {},
        xp: {},
        xq: {},
        xr: {},
        xs: {},
        xt: {},
        xu: {},
        xv: {},
        xw: {},
        xx: {},
        xy: {},
        xz: {},
        yd: {},
        ye: {},
        yt: {},
        yu: {},
        za: {},
        zm: {},
        zr: {},
        zw: {},
        zz: {},
        "001": {},
        "002": {},
        "003": {},
        "005": {},
        "009": {},
        "011": {},
        "013": {},
        "014": {},
        "015": {},
        "017": {},
        "018": {},
        "019": {},
        "021": {},
        "029": {},
        "030": {},
        "034": {},
        "035": {},
        "039": {},
        "053": {},
        "054": {},
        "057": {},
        "061": {},
        "142": {},
        "143": {},
        "145": {},
        "150": {},
        "151": {},
        "154": {},
        "155": {},
        "202": {},
        "419": {},
    },
    variant: {
        "1606nict": { prefixes: ["frm"] },
        "1694acad": { prefixes: ["fr"] },
        "1901": { prefixes: ["de"] },
        "1959acad": { prefixes: ["be"] },
        "1994": {
            prefixes: [
                "sl-rozaj",
                "sl-rozaj-biske",
                "sl-rozaj-njiva",
                "sl-rozaj-osojs",
                "sl-rozaj-solba",
            ],
        },
        "1996": { prefixes: ["de"] },
        abl1943: { prefixes: ["pt-BR"] },
        akuapem: { prefixes: ["tw"] },
        alalc97: { prefixes: [] },
        aluku: { prefixes: ["djk"] },
        ao1990: { prefixes: ["pt", "gl"] },
        aranes: { prefixes: ["oc"] },
        arevela: { prefixes: ["hy"] },
        arevmda: { prefixes: ["hy"] },
        arkaika: { prefixes: ["eo"] },
        asante: { prefixes: ["tw"] },
        auvern: { prefixes: ["oc"] },
        baku1926: {
            prefixes: ["az", "ba", "crh", "kk", "krc", "ky", "sah", "tk", "tt", "uz"],
        },
        balanka: { prefixes: ["blo"] },
        barla: { prefixes: ["kea"] },
        basiceng: { prefixes: ["en"] },
        bauddha: { prefixes: ["sa"] },
        biscayan: { prefixes: ["eu"] },
        biske: { prefixes: ["sl-rozaj"] },
        bohoric: { prefixes: ["sl"] },
        boont: { prefixes: ["en"] },
        bornholm: { prefixes: ["da"] },
        cisaup: { prefixes: ["oc"] },
        colb1945: { prefixes: ["pt"] },
        cornu: { prefixes: ["en"] },
        creiss: { prefixes: ["oc"] },
        dajnko: { prefixes: ["sl"] },
        ekavsk: { prefixes: ["sr", "sr-Latn", "sr-Cyrl"] },
        emodeng: { prefixes: ["en"] },
        fonipa: { prefixes: [] },
        fonkirsh: { prefixes: [] },
        fonnapa: { prefixes: [] },
        fonupa: { prefixes: [] },
        fonxsamp: { prefixes: [] },
        gallo: { prefixes: ["fr"] },
        gascon: { prefixes: ["oc"] },
        grclass: {
            prefixes: [
                "oc",
                "oc-aranes",
                "oc-auvern",
                "oc-cisaup",
                "oc-creiss",
                "oc-gascon",
                "oc-lemosin",
                "oc-lengadoc",
                "oc-nicard",
                "oc-provenc",
                "oc-vivaraup",
            ],
        },
        grital: { prefixes: ["oc", "oc-cisaup", "oc-nicard", "oc-provenc"] },
        grmistr: {
            prefixes: [
                "oc",
                "oc-aranes",
                "oc-auvern",
                "oc-cisaup",
                "oc-creiss",
                "oc-gascon",
                "oc-lemosin",
                "oc-lengadoc",
                "oc-nicard",
                "oc-provenc",
                "oc-vivaraup",
            ],
        },
        hepburn: { prefixes: ["ja-Latn"] },
        heploc: { prefixes: ["ja-Latn-hepburn"] },
        hognorsk: { prefixes: ["nn"] },
        hsistemo: { prefixes: ["eo"] },
        ijekavsk: { prefixes: ["sr", "sr-Latn", "sr-Cyrl"] },
        itihasa: { prefixes: ["sa"] },
        ivanchov: { prefixes: ["bg"] },
        jauer: { prefixes: ["rm"] },
        jyutping: { prefixes: ["yue"] },
        kkcor: { prefixes: ["kw"] },
        kociewie: { prefixes: ["pl"] },
        kscor: { prefixes: ["kw"] },
        laukika: { prefixes: ["sa"] },
        lemosin: { prefixes: ["oc"] },
        lengadoc: { prefixes: ["oc"] },
        lipaw: { prefixes: ["sl-rozaj"] },
        luna1918: { prefixes: ["ru"] },
        metelko: { prefixes: ["sl"] },
        monoton: { prefixes: ["el"] },
        ndyuka: { prefixes: ["djk"] },
        nedis: { prefixes: ["sl"] },
        newfound: { prefixes: ["en-CA"] },
        nicard: { prefixes: ["oc"] },
        njiva: { prefixes: ["sl-rozaj"] },
        nulik: { prefixes: ["vo"] },
        osojs: { prefixes: ["sl-rozaj"] },
        oxendict: { prefixes: ["en"] },
        pahawh2: { prefixes: ["mww", "hnj"] },
        pahawh3: { prefixes: ["mww", "hnj"] },
        pahawh4: { prefixes: ["mww", "hnj"] },
        pamaka: { prefixes: ["djk"] },
        peano: { prefixes: ["la"] },
        petr1708: { prefixes: ["ru"] },
        pinyin: { prefixes: ["zh-Latn", "bo-Latn"] },
        polyton: { prefixes: ["el"] },
        provenc: { prefixes: ["oc"] },
        puter: { prefixes: ["rm"] },
        rigik: { prefixes: ["vo"] },
        rozaj: { prefixes: ["sl"] },
        rumgr: { prefixes: ["rm"] },
        scotland: { prefixes: ["en"] },
        scouse: { prefixes: ["en"] },
        simple: { prefixes: [] },
        solba: { prefixes: ["sl-rozaj"] },
        sotav: { prefixes: ["kea"] },
        spanglis: { prefixes: ["en", "es"] },
        surmiran: { prefixes: ["rm"] },
        sursilv: { prefixes: ["rm"] },
        sutsilv: { prefixes: ["rm"] },
        synnejyl: { prefixes: ["da"] },
        tarask: { prefixes: ["be"] },
        tongyong: { prefixes: ["zh-Latn"] },
        tunumiit: { prefixes: ["kl"] },
        uccor: { prefixes: ["kw"] },
        ucrcor: { prefixes: ["kw"] },
        ulster: { prefixes: ["sco"] },
        unifon: { prefixes: ["en", "hup", "kyh", "tol", "yur"] },
        vaidika: { prefixes: ["sa"] },
        valencia: { prefixes: ["ca"] },
        vallader: { prefixes: ["rm"] },
        vecdruka: { prefixes: ["lv"] },
        vivaraup: { prefixes: ["oc"] },
        wadegile: { prefixes: ["zh-Latn"] },
        xsistemo: { prefixes: ["eo"] },
    },
};
//# sourceMappingURL=data.js.map